(function () {
        'use strict';
        var WORKER_BASE = 'https://api.tinytunesongs.com';
        var ASSET_BASE = 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev';
        var LIKENESS_PLACEHOLDER_IMG = 'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/UPLOAD_PHOTO_LATER.jpg?v=1789489919';
function ttDisplayCharUrl(url) {
  return (window.ttCharacterMode === 'photo_likeness') ? LIKENESS_PLACEHOLDER_IMG : url;
}
        var code = (new URLSearchParams(window.location.search).get('code') || '').trim().toLowerCase();

        window._ttCharacterSaveBusy = 0;

        function trackedSave(payload, maxAttempts) {
          window._ttCharacterSaveBusy = (window._ttCharacterSaveBusy || 0) + 1;
          return postCharacterSaveWithRetry(payload, maxAttempts).then(
            function (out) {
              window._ttCharacterSaveBusy = Math.max(0, (window._ttCharacterSaveBusy || 0) - 1);
              return out;
            },
            function (err) {
              window._ttCharacterSaveBusy = Math.max(0, (window._ttCharacterSaveBusy || 0) - 1);
              throw err;
            }
          );
        }

        var D = {
          genders: [
            ['girl', 'Girl', '👧'],
            ['boy', 'Boy', '👦'],
          ],
          ages: [
            ['baby', 'Baby', '1–2 years', '🍼'],
            ['toddler', 'Toddler', '2–4 years', '🧸'],
            ['littlekid', 'Little Kid', '4–6 years', '⭐'],
            ['bigkid', 'Big Kid', '6–10 years', '🎈'],
          ],
          skins: [
            ['fair', 'Fair', '#F5D9C4'],
            ['light', 'Light', '#EAC19B'],
            ['lightbrown', 'Light Brown', '#C68642'],
            ['medium', 'Medium', '#A36A42'],
            ['tan', 'Tan', '#8D5524'],
            ['deep', 'Deep', '#5C3A21'],
          ],
          ethnicities: [
            ['white', 'White'],
            ['black', 'Black'],
            ['eastasian', 'East Asian'],
            ['southasian', 'South Asian'],
            ['hispanic', 'Hispanic / Latino'],
            ['middleeastern', 'Middle Eastern'],
          ],
          ethBySkin: {
            fair: ['white', 'eastasian'],
            light: ['white', 'eastasian', 'hispanic'],
            lightbrown: ['hispanic', 'middleeastern', 'southasian'],
            medium: ['southasian', 'middleeastern', 'hispanic'],
            tan: ['southasian', 'black'],
            deep: ['black'],
          },
          eyes: [
            ['brown', 'Brown', '#6b4423'],
            ['darkbrown', 'Dark Brown', '#3b2a1a'],
            ['blue', 'Blue', '#5b8fc7'],
            ['green', 'Green', '#5a8a5a'],
            ['hazel', 'Hazel', '#8a6b3b'],
          ],
          eyeByEth: {
            white: ['brown', 'darkbrown', 'blue', 'green', 'hazel'],
            black: ['brown', 'darkbrown'],
            eastasian: ['brown', 'darkbrown'],
            southasian: ['brown', 'darkbrown'],
            middleeastern: ['brown', 'darkbrown', 'hazel'],
            hispanic: ['brown', 'darkbrown', 'hazel'],
          },
          hairColors: [
            ['black', 'Black', '#1c1714'],
            ['darkbrown', 'Dark Brown', '#3b2a1a'],
            ['lightbrown', 'Light Brown', '#7a5230'],
            ['blonde', 'Blonde', '#d9b370'],
            ['red', 'Red', '#a8472a'],
            ['auburn', 'Auburn', '#6e3a2a'],
          ],
          hairColorByEth: {
            white: ['black', 'darkbrown', 'lightbrown', 'blonde', 'red', 'auburn'],
            black: ['black', 'darkbrown'],
            eastasian: ['black', 'darkbrown'],
            southasian: ['black', 'darkbrown'],
            middleeastern: ['black', 'darkbrown'],
            hispanic: ['black', 'darkbrown', 'lightbrown'],
          },
          hairByAge: {
            baby: {
              girl: [
                ['bald', 'Little / No Hair'],
                ['wispy', 'Wispy'],
                ['short', 'Short'],
                ['littlecurls', 'Little Curls'],
                ['tinypigtails', 'Tiny Pigtails'],
              ],
              boy: [
                ['bald', 'Little / No Hair'],
                ['wispy', 'Wispy'],
                ['short', 'Short'],
                ['littlecurls', 'Little Curls'],
              ],
            },
            toddler: {
              girl: [
                ['short', 'Short'],
                ['curly', 'Curly'],
                ['wavy', 'Wavy'],
                ['coily', 'Coily'],
                ['pigtails', 'Pigtails'],
                ['shoulder', 'Shoulder Length'],
                ['shortbraids', 'Short Braids'],
              ],
              boy: [
                ['short', 'Short'],
                ['curly', 'Curly'],
                ['wavy', 'Wavy'],
                ['coily', 'Coily'],
                ['buzz', 'Buzz Cut'],
                ['spiky', 'Spiky'],
              ],
            },
            littlekid: {
              girl: [
                ['short', 'Short'],
                ['shoulder', 'Shoulder Length'],
                ['long', 'Long'],
                ['curly', 'Curly'],
                ['wavy', 'Wavy'],
                ['coily', 'Coily'],
                ['pigtails', 'Pigtails'],
                ['ponytail', 'Ponytail'],
                ['braids', 'Braids'],
                ['cornrows', 'Cornrows'],
                ['bowlcut', 'Bowl Cut'],
              ],
              boy: [
                ['short', 'Short'],
                ['buzz', 'Buzz Cut'],
                ['curly', 'Curly'],
                ['wavy', 'Wavy'],
                ['long', 'Long'],
                ['coily', 'Coily'],
                ['afro', 'Afro'],
                ['spiky', 'Spiky'],
                ['cornrows', 'Cornrows'],
                ['bowlcut', 'Bowl Cut'],
              ],
            },
            bigkid: {
              girl: [
                ['short', 'Short'],
                ['shoulder', 'Shoulder Length'],
                ['long', 'Long'],
                ['curly', 'Curly'],
                ['wavy', 'Wavy'],
                ['coily', 'Coily'],
                ['pigtails', 'Pigtails'],
                ['ponytail', 'Ponytail'],
                ['braids', 'Braids'],
                ['cornrows', 'Cornrows'],
                ['bowlcut', 'Bowl Cut'],
              ],
              boy: [
                ['short', 'Short'],
                ['buzz', 'Buzz Cut'],
                ['curly', 'Curly'],
                ['wavy', 'Wavy'],
                ['long', 'Long'],
                ['coily', 'Coily'],
                ['afro', 'Afro'],
                ['spiky', 'Spiky'],
                ['cornrows', 'Cornrows'],
                ['bowlcut', 'Bowl Cut'],
              ],
            },
          },
          hairRestrict: { coily: ['black'], afro: ['black'], cornrows: ['black'] },
        };
        var HAIR_EMOJI = {
          bald: '👶',
          wispy: '🌫️',
          short: '✂️',
          littlecurls: '🌀',
          tinypigtails: '🎀',
          curly: '🌀',
          wavy: '〰️',
          coily: '🌀',
          pigtails: '🎀',
          shoulder: '💇',
          shortbraids: '🪢',
          long: '💁',
          ponytail: '🐎',
          braids: '🪢',
          cornrows: '🧶',
          bowlcut: '🥣',
          buzz: '✂️',
          spiky: '⚡',
          afro: '🟤',
        };
                // Themed Princess dresses — same R2 assets/outfit IDs as the dedicated
        // Princess theme flow. Must always go through Grok, never the default
        // KIE outfit path — KIE flags these as too sensitive.
                               var PRINCESS_DRESSES = {
          skyblossom: { label: 'Sky Blossom', outfitId: 'sky blossom', url: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/PRINCESS%20-%20BABY%20BLUE.jpg' },
          rosepetal: { label: 'Rose Petal', outfitId: 'rose petal', url: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/PRINCESS%20-%20PINK.jpg' },
          violetstar: { label: 'Violet Star', outfitId: 'violet star', url: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/PRINCESS%20-%20PURPLE.jpg' },
          goldendawn: { label: 'Golden Dawn', outfitId: 'golden dawn', url: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/PRINCESS%20-%20YELLOW.jpg' },
        };

        // Themed Superhero suits — same R2 assets/outfit IDs as the dedicated
        // Superhero theme flow. Must always go through Grok, never KIE.
                // Halloween costumes — same images as the order-form carousel.
        var HALLOWEEN_COSTUME_IMAGES = {
          princess: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/ha%20-%20princess.jpg',
          dinosaur: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20DINO.jpg',
          witch: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20WITCH.jpg',
          vampire: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20VAMPIRE.jpg',
          pumpkin: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20PUMPKIN.jpg',
          skeleton: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20SKELETON.jpg',
          cat: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20CAT.jpg',
          wizard: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20WIZARD.jpg',
          lion: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20LION.jpg',
          ghost: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/HA%20-%20GHOST.jpg',
        };
        function halloweenCostumeUrl() {
          return HALLOWEEN_COSTUME_IMAGES[String(pageThemeOutfitName || '').trim().toLowerCase()] || '';
        }

        var SUPERHERO_OUTFITS = {
          nightguardian: { label: 'Night Guardian', outfitId: 'night guardian', url: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/SUPER%20HERO%20-%20BLACK.jpg' },
          stormbolt: { label: 'Storm Bolt', outfitId: 'storm bolt', url: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/SUPER%20HERO%20-%20BLUE.jpg' },
          libertyguard: { label: 'Liberty Guard', outfitId: 'liberty guard', url: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/SUPER%20HERO%20-%20AMERICA.jpg' },
          infernoknight: { label: 'Inferno Knight', outfitId: 'inferno knight', url: 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/SUPER%20HERO%20-%20RED.jpg' },
        };

        var OUTFITS = {
          boy: [
            ['birthday', 'Birthday'],
            ['casual', 'Everyday'],
            ['cozy', 'Cozy'],
            ['pajamas', 'Pajamas'],
            ['sporty', 'Sporty'],
            ['summer', 'Summer'],
            ['superhero', 'Superhero'],
            ['superhero-red', 'Superhero Red'],
            ['nightguardian', 'Night Guardian'],
            ['stormbolt', 'Storm Bolt'],
            ['libertyguard', 'Liberty Guard'],
            ['infernoknight', 'Inferno Knight'],
          ],
                    girl: [
            ['birthday', 'Birthday'],
            ['casual', 'Everyday'],
            ['casual1', 'Casual'],
            ['casual2', 'Casual 2'],
            ['pajamas', 'Pajamas'],
            ['sporty', 'Sporty'],
            ['summer', 'Summer'],
            ['skyblossom', 'Sky Blossom'],
            ['rosepetal', 'Rose Petal'],
            ['violetstar', 'Violet Star'],
            ['goldendawn', 'Golden Dawn'],
          ],
        };
                var OUTFIT_SAVE = {
          keep: 'keep',
          birthday: 'birthday party',
          sunday: 'sunday best',
          summer: 'summer fun',
          casual: 'everyday casual',
          casual1: 'casual look 1',
          casual2: 'casual look 2',
          cozy: 'cozy winter',
          sporty: 'sporty',
          pajamas: 'cozy pajamas',
                    skyblossom: 'sky blossom',
          rosepetal: 'rose petal',
          violetstar: 'violet star',
          goldendawn: 'golden dawn',
          nightguardian: 'night guardian',
          stormbolt: 'storm bolt',
          libertyguard: 'liberty guard',
          infernoknight: 'inferno knight',
        };

        // ============ LANGUAGE (?lang=es) ============
        var ttLang2 =
          (new URLSearchParams(window.location.search).get('lang') || 'en').toLowerCase() === 'es' ? 'es' : 'en';
        if (ttLang2 === 'es') {
          var GENDER_ES = { girl: 'Niña', boy: 'Niño' };
          var AGE_ES = {
            baby: ['Bebé', '1–2 años'],
            toddler: ['Pequeño/a', '2–4 años'],
            littlekid: ['Niño/a Pequeño/a', '4–6 años'],
            bigkid: ['Niño/a Grande', '6–10 años'],
          };
          var SKIN_ES = {
            fair: 'Clara',
            light: 'Clara Media',
            lightbrown: 'Marrón Claro',
            medium: 'Media',
            tan: 'Bronceada',
            deep: 'Oscura',
          };
          var ETH_ES = {
            white: 'Blanco/a',
            black: 'Negro/a',
            eastasian: 'Asiático/a Oriental',
            southasian: 'Asiático/a del Sur',
            hispanic: 'Hispano/a / Latino/a',
            middleeastern: 'Medio Oriente',
          };
          var EYE_ES = { brown: 'Café', darkbrown: 'Café Oscuro', blue: 'Azul', green: 'Verde', hazel: 'Avellana' };
          var HAIRCOLOR_ES = {
            black: 'Negro',
            darkbrown: 'Café Oscuro',
            lightbrown: 'Café Claro',
            blonde: 'Rubio',
            red: 'Rojo',
            auburn: 'Castaño Rojizo',
          };
          var HAIRSTYLE_ES = {
            bald: 'Poco / Sin Cabello',
            wispy: 'Ligero',
            short: 'Corto',
            littlecurls: 'Rizos Pequeños',
            tinypigtails: 'Colitas Pequeñas',
            curly: 'Rizado',
            wavy: 'Ondulado',
            coily: 'Muy Rizado',
            pigtails: 'Colitas',
            shoulder: 'Hasta los Hombros',
            shortbraids: 'Trenzas Cortas',
            long: 'Largo',
            ponytail: 'Cola de Caballo',
            braids: 'Trenzas',
            cornrows: 'Trenzas Pegadas',
            bowlcut: 'Corte Tazón',
            buzz: 'Rapado',
            spiky: 'Puntas',
            afro: 'Afro',
          };
          var OUTFIT_ES = {
            birthday: 'Cumpleaños',
            casual: 'Diario',
            casual1: 'Casual',
            casual2: 'Casual 2',
            cozy: 'Abrigado',
            pajamas: 'Pijama',
            sporty: 'Deportivo',
            summer: 'Verano',
            superhero: 'Superhéroe',
            'superhero-red': 'Superhéroe Rojo',
            princess: 'Princesa',
          };

          D.genders.forEach(function (g) {
            if (GENDER_ES[g[0]]) g[1] = GENDER_ES[g[0]];
          });
          D.ages.forEach(function (a) {
            if (AGE_ES[a[0]]) {
              a[1] = AGE_ES[a[0]][0];
              a[2] = AGE_ES[a[0]][1];
            }
          });
          D.skins.forEach(function (s) {
            if (SKIN_ES[s[0]]) s[1] = SKIN_ES[s[0]];
          });
          D.ethnicities.forEach(function (e) {
            if (ETH_ES[e[0]]) e[1] = ETH_ES[e[0]];
          });
          D.eyes.forEach(function (e) {
            if (EYE_ES[e[0]]) e[1] = EYE_ES[e[0]];
          });
          D.hairColors.forEach(function (h) {
            if (HAIRCOLOR_ES[h[0]]) h[1] = HAIRCOLOR_ES[h[0]];
          });
          Object.keys(D.hairByAge).forEach(function (ageKey) {
            Object.keys(D.hairByAge[ageKey]).forEach(function (genderKey) {
              D.hairByAge[ageKey][genderKey].forEach(function (p) {
                if (HAIRSTYLE_ES[p[0]]) p[1] = HAIRSTYLE_ES[p[0]];
              });
            });
          });
          Object.keys(OUTFITS).forEach(function (genderKey) {
            OUTFITS[genderKey].forEach(function (o) {
              if (OUTFIT_ES[o[0]]) o[1] = OUTFIT_ES[o[0]];
            });
          });
        }

        var PT2_ES = {
          eyebrows: {
            gender: '',
            age: 'Sobre él/ella',
            skin: 'Su apariencia',
            ethnicity: 'Su apariencia',
            eye: 'Últimos detalles',
            haircolor: 'Últimos detalles',
            hairstyle: 'Últimos detalles',
            outfit: 'Una cosa más',
          },
          genderTitleNamed: function (nm) {
            return 'Vamos a crear el personaje de ' + nm;
          },
          genderTitleDefault: 'Vamos a crear su personaje',
          genderHintSuperhero: '¡Vamos a crear su look de superhéroe!',
          genderHintPrincess: '¡Vamos a crear su look de princesa!',
          genderHintDefault: '¿Tu pequeña estrella es niña o niño?',
          ageTitle: '¿Qué edad tiene?',
          ageHint: 'Elige la edad que mejor encaje.',
          skinTitle: 'Elige su tono de piel',
          skinHint: 'Toca el tono que más se le parezca.',
          ethTitle: '¿Qué lo/la describe mejor?',
          ethHint: 'Esto nos ayuda a hacer coincidir sus rasgos.',
          eyeTitle: 'Color de ojos',
          eyeHint: function (nm) {
            return 'Elige el color de ojos de ' + nm + '.';
          },
          haircolorTitle: 'Color de cabello',
          haircolorHint: '¿De qué color es su cabello?',
          hairstyleTitle: 'Elige tu personaje',
          hairstyleHint: 'Desliza y toca el que más se le parezca.',
          outfitTitle: function (nm) {
            return 'Viste a ' + nm + ' para la canción';
          },
          outfitHint: 'Conserva su look — o elige un nuevo atuendo.',
          keepOutfit: 'Conservar este atuendo',
          customOutfit: 'Atuendo personalizado',
          toOutfitSuperhero: function (nm) {
            return '✨ Vestir a ' + nm + ' de Superhéroe →';
          },
          toOutfitPrincess: function (nm) {
            return '✨ Vestir a ' + nm + ' de Princesa →';
          },
          toOutfitDefault: 'No gracias, se ve bien — elegir atuendo →',
          sayHelloTo: '✨ Saluda a',
          littleStarDefault: 'Tu pequeña estrella',
          startOver: 'Empezar de nuevo',
          tweakPrompt: '¿Quieres hacer algún cambio?',
          tweakSub: 'Escribe lo que te gustaría diferente y lo actualizaremos en segundos',
          tweakUpdateBtn: 'Actualizar personaje',
          tweakLockedTitle: '✨ Lo hicimos único',
          tweakLockedSub: 'Ya usaste tu ajuste gratuito.',
          tweakRemaining: function (left) {
            return (
              left +
              ' ajuste' +
              (left === 1 ? '' : 's') +
              ' gratuito' +
              (left === 1 ? '' : 's') +
              ' restante' +
              (left === 1 ? '' : 's')
            );
          },
          updatingLook: function (nm) {
            return 'Actualizando el look de ' + nm + '...';
          },
          creatingCharacter: 'Creando su personaje...',
          creatingOutfit: function (nm) {
            return 'Creando el atuendo de ' + nm + '…';
          },
          puttingOnCostume: function (label) {
            return 'Poniéndole el traje de ' + label + '…';
          },
          readyForReveal: '✓ ¡Listo para su gran revelación! 🎬',
          dressingThem: function (nm, label) {
            return 'Vistiendo a ' + nm + ' de ' + label + '…';
          },
          couldntCreateCostume:
            '⚠️ No pudimos crear el traje — <button type="button" id="ttcThemeRetry" style="background:none;border:none;color:#3c8ab3;font-weight:900;text-decoration:underline;cursor:pointer;padding:0;font-size:inherit;">toca para reintentar</button>',
          couldntCreateCharacter: 'No pudimos crear el personaje — por favor intenta de nuevo.',
          somethingWrong: 'Algo salió mal — por favor intenta de nuevo.',
          heroLabel: 'Superhéroe',
          princessLabel: 'Princesa',
          dressLabel: function (nm, outfitLabel) {
            return '✨ Vestir a ' + nm + ' de ' + outfitLabel;
          },
          dressCustom: function (nm) {
            return '✨ Vestir a ' + nm + ' con un atuendo personalizado';
          },
          thisIsTheOne: 'Este es →',
          tapFavorite: 'Toca tu favorito',
          currentLook: 'su look actual',
          newOutfit: 'su nuevo atuendo',
          outfitPlaceholders: [
            'ej. capa y botas de superhéroe rojo',
            'ej. vestido de princesa azul brillante',
            'ej. pijama de dinosaurio abrigado',
            'ej. overol de mezclilla con camisa a rayas',
            'ej. uniforme y shorts de fútbol',
            'ej. traje de astronauta con casco',
          ],
          tweakPlaceholders: [
            'ej. dale cabello rizado rojo',
            'ej. agrega lentes redondos y pecas',
            'ej. haz el cabello más oscuro',
            'ej. cambia el color de ojos a color avellana',
            'ej. agrega una pequeña marca cerca del ojo',
            'ej. dale una sonrisa más grande',
          ],
          entityTitle: '¿Detectamos otros personajes — quieres agregar descripciones?',
          entitySaveContinue: 'Guardar y continuar',
          entityDecline: 'No gracias, omitir esto',
          entitySaving: 'Guardando…',
          entitySaved: '✓ Recibimos tus detalles — ¡desplázate hacia arriba mientras terminamos su canción!',
          entitySaveFailed: 'No pudimos guardar — por favor intenta de nuevo.',
          entityIsPetOrPerson: function (label) {
            return '¿' + label + ' es una mascota o una persona?';
          },
          entityPet: '🐾 Mascota',
          entityPerson: '🧑 Persona',
          entityDescribeSkin: 'Descríbelo/a abajo, incluyendo tono de piel / etnia',
          entityPetType: 'Tipo de mascota (ej. perro, gato)',
          entityPetBreed: 'Raza (ej. schnoodle)',
          entityPetColor: 'Color (ej. negro, café y blanco)',
          entityWhatLooksLike: function (label) {
            return '¿Cómo se ve ' + label + '?';
          },
          entitySuggestions: {
            grandma: 'ej. blanca, alrededor de 60, cabello blanco, lentes',
            grandpa: 'ej. negro, alrededor de 60, cabello gris, barba',
            mom: 'ej. hispana, 30 años, cabello castaño, estatura media',
            dad: 'ej. blanco, 30 años, cabello castaño, estatura media',
            sister: 'ej. etnia, edad, color de cabello, peinado',
            brother: 'ej. etnia, edad, color de cabello, peinado',
            aunt: 'ej. etnia, edad, color de cabello, peinado',
            uncle: 'ej. etnia, edad, color de cabello, peinado',
            cousin: 'ej. etnia, edad, color de cabello, peinado',
            dog: 'ej. golden retriever, pelaje dorado sólido',
            cat: 'ej. gato atigrado naranja',
          },
          allSet: '¡Listo!',
          them: 'A ellos',
          missingCode: 'Falta el código de vista previa. Por favor actualiza la página.',
          expiredPreview: 'Esta vista previa ha expirado. Por favor crea una nueva para continuar.',
        };
        function pt2(key) {
          return ttLang2 === 'es' ? PT2_ES[key] : null;
        }
        // ============ END LANGUAGE ============

        var pick = {
  gender: null,
  age: null,
  skin: null,
  ethnicity: null,
  eye: null,
  haircolor: null,
  hairstyle: null,
  outfit: null,
};
var saveGeneration = 0;
        var customCharacterUrl = null;
        var pendingDetectedEntities = null;
        var pendingEntityCode = null;
        var pendingEntitySkin = null;
        var STEPS = ['gender', 'age', 'skin', 'ethnicity', 'eye', 'haircolor', 'hairstyle', 'outfit'];
        var pageTheme = '';
        var pageThemeOutfitName = '';

        var restoredCharacterUrl = null;
        var restoredCharacterId = null;
        var restoredOutfit = null;

         function getUnfinishedEntities(fields) {
  let detected = [];
  let described = [];
  let images = {};
  try { detected = JSON.parse(fields?.detected_entities || '[]'); } catch (e) {}
  try { described = JSON.parse(fields?.entity_descriptions || '[]'); } catch (e) {}
  try { images = JSON.parse(fields?.entity_reference_images || '{}'); } catch (e) {}
  const describedKeys = new Set(described.map(d => d.key));
  return detected.filter(e => !describedKeys.has(e.key) && !images[e.key]);
}

           function fetchPageTheme() {
          if (!code) return Promise.resolve();
          return fetch(WORKER_BASE + '/status-by-code?code=' + encodeURIComponent(code), { cache: 'no-store' })
            .then(function (r) {
              return r.json().catch(function () {
                return {};
              });
            })
            .then(function (data) {
              var f = (data && (data.fields || data.airtable_fields || data.record_fields || data.record)) || {};
              pageTheme = String(f.theme || '')
                .trim()
                .toLowerCase();
              pageThemeOutfitName = String(f.selected_outfit || '').trim();
                // No outfit step before purchase: themed orders are already in costume, everyone else keeps their look
              var idx = STEPS.indexOf('outfit');
              if (idx >= 0) STEPS.splice(idx, 1);
                            var existingUrl = f.character_image_url || f.video_character_image || f.custom_character_image_url || '';
              if (existingUrl) {
                restoredCharacterUrl = existingUrl;
                restoredCharacterId = f.base_character || null;
                restoredOutfit = f.outfit || f.selected_outfit || null;
              }
                            if (f.character_mode) {
                window.ttCharacterMode = String(f.character_mode).trim();
              }
                            window.ttUnfinishedEntities = getUnfinishedEntities(f);
        window.ttUnfinishedEntityCode = code;
        try { window.ttAllCastEntities = JSON.parse(f.detected_entities || '[]'); } catch (e) { window.ttAllCastEntities = []; }
        try { window.ttEntityImages = JSON.parse(f.entity_reference_images || '{}'); } catch (e) { window.ttEntityImages = {}; }
               setTimeout(renderCastStrip, 300); // covers the case where the lyrics card already exists (e.g. page reload after the song finished)
            })
            .catch(function (err) {
              console.error('[TT] fetchPageTheme failed:', err);
            });
        }

        function showRestoredCharacter() {
  form.style.display = 'none';
  revealWrap.style.display = 'none';
  var entryLikenessWrapRestore = document.getElementById('ttCharbEntryLikenessWrap');
  if (entryLikenessWrapRestore) entryLikenessWrapRestore.style.display = 'none';
                    $('ttCharbSavedImg').src = ttDisplayCharUrl(restoredCharacterUrl);
          fitFrameToImage($('ttCharbSavedImg'), document.querySelector('#ttCharbSaved .ttq-saved-frame'));
          $('ttCharbSavedName').textContent = titleName() || 'All set!';
          $('ttCharbSub').textContent = '✓ Ready for their big reveal! 🎬';
          savedWrap.style.display = 'block';
          back.classList.remove('show');
          fill.style.width = '100%';

          var frame = document.querySelector('#ttCharbSaved .ttq-saved-frame');
          if (frame && restoredOutfit && restoredOutfit !== 'keep') frame.classList.add('is-dressed');

          try {
            window.savedCharacterId = restoredCharacterId || 'restored';
            window.savedCharacterUrl = restoredCharacterUrl;
            window.ttOutfit = restoredOutfit || 'keep';
          } catch (e) {}

          if (typeof window.updateVideoCta === 'function') window.updateVideoCta();
          if (typeof window.applyCharacterToPlayer === 'function') window.applyCharacterToPlayer();

          document.dispatchEvent(
            new CustomEvent('ttCharacterSaved', {
              detail: {
                character_id: restoredCharacterId || 'restored',
                url: restoredCharacterUrl,
                outfit: restoredOutfit || 'keep',
                gender: pick.gender,
                base_character: restoredCharacterId,
              },
            })
          );
          document.dispatchEvent(new CustomEvent('ttCharacterDressed', { detail: { url: restoredCharacterUrl } }));
        }
           var EYEBROWS =
          ttLang2 === 'es'
            ? PT2_ES.eyebrows
            : {
                gender: '',
                age: 'About them',
                skin: 'Their look',
                ethnicity: 'Their look',
                eye: 'Finishing touches',
                haircolor: 'Finishing touches',
                hairstyle: 'Finishing touches',
                outfit: 'One last thing',
              };
        var si = 0;

        var $ = function (id) {
          return document.getElementById(id);
        };
        var form = $('ttCharbForm'),
          stepWrap = $('ttncStep'),
          optWrap = $('ttncOptions'),
          eyebrow = $('ttncEyebrow'),
          qt = $('ttncQTitle'),
          qh = $('ttncQHint');
        var back = $('ttncBack'),
          fill = $('ttqFill'),
          revealWrap = $('ttncReveal'),
          savedWrap = $('ttCharbSaved');
               function openLyricsModal() {
          const lyrics = window.ttFullLyrics || '';
          if (!lyrics) return;
          const existing = document.getElementById('ttLyricsModalOverlay');
          if (existing) { existing.remove(); }

          const overlay = document.createElement('div');
          overlay.id = 'ttLyricsModalOverlay';
          overlay.style.cssText = 'position:fixed;inset:0;background:rgba(2,6,23,.62);backdrop-filter:blur(10px);z-index:10065;display:flex;align-items:center;justify-content:center;padding:20px;';
          const bodyHtml = typeof window.ttRenderLyricsHtml === 'function'
            ? window.ttRenderLyricsHtml(lyrics)
            : escapeHtml(lyrics).replace(/\n/g, '<br>');
          overlay.innerHTML =
            '<div style="background:#fff;border-radius:24px;padding:22px 20px 18px;max-width:420px;width:100%;max-height:80vh;display:flex;flex-direction:column;box-shadow:0 30px 70px rgba(0,0,0,.35);">' +
              '<div style="text-align:center;font-family:\'Fraunces\',serif;font-weight:600;font-size:20px;color:#16324a;margin-bottom:2px;">🎶 Lyrics</div>' +
              '<div style="text-align:center;font-size:12.5px;font-weight:700;color:#9aa5b1;margin-bottom:16px;">Scroll to read along</div>' +
              '<div style="overflow-y:auto;padding:4px 4px 10px;flex:1;">' + bodyHtml + '</div>' +
              '<button type="button" id="ttLyricsModalBack" style="margin-top:14px;display:flex;align-items:center;justify-content:center;gap:8px;background:linear-gradient(135deg,#4fa3d1,#3c8ab3);color:#fff;font-family:\'Nunito\',sans-serif;font-weight:900;font-size:14px;padding:14px 22px;border-radius:14px;border:none;cursor:pointer;box-shadow:0 10px 24px rgba(60,138,179,.32);">' +
                '<span style="font-size:16px;">⬅</span> Back to Video' +
              '</button>' +
            '</div>';
          document.body.appendChild(overlay);
          overlay.addEventListener('click', function (ev) { if (ev.target === overlay) overlay.remove(); });
          overlay.querySelector('#ttLyricsModalBack').addEventListener('click', function () { overlay.remove(); });
        }
        window.ttCloseLyricsModal = function () {
          const el = document.getElementById('ttLyricsModalOverlay');
          if (el) el.remove();
        };

              function openCastLightbox(label, imgUrl) {
          var overlay = document.createElement('div');
          overlay.style.cssText = 'position:fixed;inset:0;background:rgba(2,6,23,.65);backdrop-filter:blur(10px);z-index:10060;display:flex;align-items:center;justify-content:center;padding:20px;';
          overlay.innerHTML =
            '<div style="background:#fff;border-radius:26px;padding:24px;max-width:320px;width:100%;text-align:center;box-shadow:0 30px 70px rgba(0,0,0,.35);">' +
              '<img src="' + imgUrl + '" style="width:100%;border-radius:18px;box-shadow:0 10px 26px rgba(26,58,92,.2);margin-bottom:16px;">' +
              '<div style="font-family:\'Fraunces\',serif;font-weight:600;font-size:21px;color:#16324a;margin-bottom:18px;">' + escapeHtml(label) + '</div>' +
              '<button type="button" id="ttCastLightboxClose" style="background:#111827;color:#fff;font-family:\'Nunito\',sans-serif;font-weight:900;font-size:13px;padding:11px 26px;border-radius:999px;border:none;cursor:pointer;">Close</button>' +
            '</div>';
          document.body.appendChild(overlay);
          overlay.addEventListener('click', function (ev) { if (ev.target === overlay) overlay.remove(); });
          overlay.querySelector('#ttCastLightboxClose').addEventListener('click', function () { overlay.remove(); });
        }

             function renderCastStrip(attempt) {
          attempt = attempt || 1;
          if (!window.ttAllowCastPrePurchase) return; // cast is added after checkout now
          if (document.getElementById('ttCastStrip')) return;
          var all = window.ttAllCastEntities || [];
          if (!all.length) return;

          var lyricsCard = document.getElementById('ttLyricsReveal');
          if (!lyricsCard || !lyricsCard.parentNode) {
            if (attempt < 40) setTimeout(function () { renderCastStrip(attempt + 1); }, 500);
            return;
          }
          var builderRoot = lyricsCard;
          var images = window.ttEntityImages || {};

          if (!document.getElementById('ttCastStripStyles')) {
            var s = document.createElement('style');
            s.id = 'ttCastStripStyles';
            s.textContent = '@keyframes ttCastPop{0%{opacity:0;transform:scale(.7) translateY(8px)}100%{opacity:1;transform:scale(1) translateY(0)}}';
            document.head.appendChild(s);
          }

          var wrap = document.createElement('div');
          wrap.id = 'ttCastStrip';
                   wrap.style.cssText = 'margin:18px 0 16px;padding:18px 16px 16px;border-radius:22px;background:linear-gradient(165deg,#fffdf8,#fff6e6);border:1.5px solid rgba(240,180,41,.28);box-shadow:0 10px 26px rgba(240,180,41,.14);text-align:center;';

                  var circlesHtml = all.slice(0, 5).map(function (e, i) {
            var img = images[e.key];
            var isDone = !!img;
            var delay = (i * 0.12).toFixed(2);
            var ring = isDone
              ? 'background:linear-gradient(135deg,#4fa3d1,#f0b429);padding:2px;'
              : 'background:repeating-conic-gradient(rgba(154,165,177,.55) 0 8deg, transparent 8deg 16deg);padding:2px;';
              var inner = isDone
    ? '<img src="' + img + '" style="width:100%;height:100%;object-fit:cover;object-position:center 15%;border-radius:50%;">'
    : '<div style="width:100%;height:100%;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:900;color:#c9ccd4;">+</div>';
            return '<div class="ttCastCircleItem" data-key="' + escapeHtml(e.key) + '" style="display:flex;flex-direction:column;align-items:center;gap:4px;flex:0 1 auto;max-width:66px;opacity:0;animation:ttCastPop .55s cubic-bezier(.22,1,.36,1) forwards;animation-delay:' + delay + 's;cursor:pointer;">' +
              '<div style="width:52px;height:52px;border-radius:50%;' + ring + 'box-shadow:0 6px 14px rgba(26,58,92,.16);transition:transform .15s;">' +
                '<div style="width:100%;height:100%;border-radius:50%;overflow:hidden;background:#fff;">' + inner + '</div>' +
              '</div>' +
                        '<div style="font-family:\'Fraunces\',serif;font-weight:600;font-size:11px;color:#16324a;line-height:1.15;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:64px;">' + escapeHtml(e.label) + '</div>' +
              (isDone
                ? '<div style="font-size:9px;font-weight:800;color:#4fa3d1;letter-spacing:.01em;">Tap to see</div>'
                : '<div style="font-size:9px;font-weight:800;color:#b8860b;letter-spacing:.01em;">Tap to add</div>') +
            '</div>';
          }).join('');

                    var castName = titleName() || 'Their';
          var possessive = castName === 'Their' ? castName : (castName.slice(-1).toLowerCase() === 's' ? castName + "'" : castName + "'s");
          var allDoneForHeader = all.every(function (e) { return !!images[e.key]; });
          var headerSub = allDoneForHeader ? 'Tap anyone to see them ✨' : 'Tap anyone to see them or finish their look';
                 wrap.innerHTML =
            '<div style="font-family:\'Fraunces\',serif;font-weight:600;font-size:18px;color:#16324a;margin-bottom:4px;">✨ ' + escapeHtml(possessive) + ' Supporting Cast</div>' +
            '<div style="font-size:11.5px;font-weight:700;color:#9aa5b1;margin-bottom:14px;">' + headerSub + '</div>' +
            '<div style="display:flex;flex-wrap:nowrap;gap:8px;justify-content:center;overflow-x:auto;padding:0 2px;">' + circlesHtml + '</div>';

                     builderRoot.parentNode.insertBefore(wrap, builderRoot);

          Array.prototype.forEach.call(wrap.querySelectorAll('.ttCastCircleItem'), function (el) {
            el.addEventListener('mouseenter', function () { el.firstElementChild.style.transform = 'scale(1.06)'; });
            el.addEventListener('mouseleave', function () { el.firstElementChild.style.transform = 'scale(1)'; });
                    el.addEventListener('click', function () {
              var key = el.dataset.key;
              var e = all.filter(function (x) { return x.key === key; })[0];
              if (!e) return;
              var img = images[e.key];
                 if (img) {
                openCastLightbox(e.label, img);
                return;
              }
              ttOpenStripEditor(wrap, e);
              return;
                          var kind = e.kind === 'unknown' ? 'person' : e.kind;
              function saveTextDesc(sel) {
                var finalKind = (sel && sel.species === 'Horse') ? 'horse' : kind;
                var compiled = compileEntityDescription(finalKind, sel);
                var payloadDesc = Object.assign({ key: e.key, kind: finalKind }, compiled);
                fetch(WORKER_BASE + '/save-entity-descriptions', {
                  method: 'POST', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ code: window.ttUnfinishedEntityCode, descriptions: [payloadDesc] }),
                }).catch(function () {});
              }
              var mainUsedPhotoLikeness = window.ttCharacterMode === 'photo_likeness';
              if (!mainUsedPhotoLikeness) {
                openEntityCarousel(e.key, kind, e.label, saveTextDesc);
                return;
              }
              ensureEntityModalStyles();
              var chooserOverlay = document.createElement('div');
              chooserOverlay.className = 'tt-em-overlay';
              chooserOverlay.style.display = 'flex';
              chooserOverlay.innerHTML =
                '<div class="tt-em-box">' +
                  '<button type="button" class="tt-em-close">×</button>' +
                  '<div class="tt-em-title">How would you like to add ' + escapeHtml(e.label) + '?</div>' +
                  '<div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap;">' +
                    '<button type="button" class="ttCastChooseText" style="flex:1;min-width:140px;background:#f8fbfd;border:2px solid rgba(79,163,209,.3);border-radius:12px;padding:14px;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:13px;color:#3c8ab3;cursor:pointer;">✍️ Describe with words</button>' +
                    '<button type="button" class="ttCastChoosePhoto" style="flex:1;min-width:140px;background:#f8fbfd;border:2px solid rgba(240,180,41,.4);border-radius:12px;padding:14px;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:13px;color:#b8860b;cursor:pointer;">📸 Upload their photo</button>' +
                  '</div>' +
                '</div>';
              document.body.appendChild(chooserOverlay);
              chooserOverlay.querySelector('.tt-em-close').addEventListener('click', function () { chooserOverlay.remove(); });
              chooserOverlay.addEventListener('click', function (ev) { if (ev.target === chooserOverlay) chooserOverlay.remove(); });
              chooserOverlay.querySelector('.ttCastChooseText').addEventListener('click', function () {
                chooserOverlay.remove();
                openEntityCarousel(e.key, kind, e.label, saveTextDesc);
              });
              chooserOverlay.querySelector('.ttCastChoosePhoto').addEventListener('click', function () {
                chooserOverlay.remove();
                var tempInput = document.createElement('input');
                tempInput.type = 'file';
                tempInput.accept = 'image/*';
                tempInput.style.display = 'none';
                document.body.appendChild(tempInput);
                function proceedToConsent(ageGroup, gender) {
                  tempInput.dataset.ageGroup = ageGroup || '';
                  tempInput.dataset.gender = gender || '';
                  openEntityPhotoConsent(e.label,
                    function onAuthorized() { tempInput.click(); },
                    function onDeclined() { openEntityCarousel(e.key, kind, e.label, saveTextDesc); tempInput.remove(); }
                  );
                }
                                                 if (kind === 'pet' || kind === 'horse') {
                  askPetSpecies(e.label, function (species) {
                    tempInput.dataset.species = species || '';
                    proceedToConsent('', '');
                  });
                } else {
                  askEntityGenderAndAge(e.label, function (gender, ageGroup) { proceedToConsent(ageGroup, gender); });
                }
                                             tempInput.addEventListener('change', function () {
                  var file = tempInput.files && tempInput.files[0];
                  if (!file) { tempInput.remove(); return; }
                  confirmEntityPhoto(e.label, file,
                    function () { startEntityUpload(file); },
                    function () { tempInput.value = ''; tempInput.click(); }
                  );
                });
                function startEntityUpload(file) {
                  var tempStatus = document.createElement('div');
                  tempStatus.style.cssText = 'margin-top:8px;font-size:11.5px;font-weight:800;text-align:center;';
                  // Insert right under the tapped circle so feedback appears
                  // exactly where the person is looking — was previously
                  // created but never added to the page, so nothing ever
                  // showed up no matter what happened with the upload.
                  el.appendChild(tempStatus);
                      uploadEntityPhotoFile(e.key, kind, e.label, window.ttUnfinishedEntityCode, file, tempStatus, tempInput.dataset.ageGroup || '', tempInput.dataset.gender || '', tempInput.dataset.species || '', function (freshUrl) {
                    if (freshUrl) {
                      // Keep the shared image cache in sync so re-opening
                      // this strip later (or the lightbox) reflects it too.
                      window.ttEntityImages = window.ttEntityImages || {};
                      window.ttEntityImages[e.key] = freshUrl;
                    }
                                     // el's direct children are always, in order:
                    // [0] the ring circle, [1] the name label, [2] the tap-hint label.
                    // Index by position, not by a :last-child selector — that
                    // selector was matching the ring's INNER photo div (which
                    // is trivially "last child" of its own single-child
                    // parent) instead of the actual label, overwriting the
                    // photo with plain text.
                    var ringEl = el.children[0];
                    if (ringEl && freshUrl) {
                      // Swap the dashed "+" ring for a solid gold ring
                      // with the real photo inside — matches how an
                      // already-done cast member renders on page load.
                      ringEl.style.background = 'linear-gradient(135deg,#4fa3d1,#f0b429)';
                      var innerEl = ringEl.firstElementChild;
                      if (innerEl) innerEl.innerHTML = '<img src="' + freshUrl + '" style="width:100%;height:100%;object-fit:cover;object-position:center 15%;border-radius:50%;">';
                    }
                    var tapLabel = el.children[2];
                    if (tapLabel && freshUrl) {
                      tapLabel.textContent = 'Tap to see';
                      tapLabel.style.color = '#4fa3d1';
                    }
                                if (tempStatus) tempStatus.innerHTML = '<div style="font-size:10.5px;font-weight:800;color:#16a34a;margin-top:4px;">✓ Added</div>';
                  });
                  tempInput.remove();
                }
              });
            });
          });
               }

                       // Shows the chosen photo back with the person's name — "Is this Mommy?" —
        // so a photo uploaded into the wrong person's slot gets caught before it's used.
        function confirmEntityPhoto(label, file, onYes, onRetry) {
          ensureEntityModalStyles();
          var url = URL.createObjectURL(file);
          var safe = escapeHtml(label);
          var ov = document.createElement('div');
          ov.className = 'tt-em-overlay';
          ov.style.display = 'flex';
          ov.innerHTML =
            '<div class="tt-em-box" style="text-align:center;">' +
              '<div class="tt-em-title">Is this <span style="color:#3c8ab3;">' + safe + '</span>?</div>' +
              '<img src="' + url + '" alt="" style="width:170px;height:170px;object-fit:cover;border-radius:50%;border:4px solid #f0b429;margin:6px auto 12px;display:block;">' +
              '<div style="font-size:13px;font-weight:700;color:#6b7280;margin-bottom:16px;line-height:1.5;">This photo will become <strong style="color:#111827;">' + safe + '</strong>’s character in the video.</div>' +
              '<div style="display:flex;gap:10px;flex-wrap:wrap;">' +
                '<button type="button" class="ttEpRetry" style="flex:1;min-width:130px;background:#fff;border:2px solid rgba(148,163,184,.4);border-radius:12px;padding:13px;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:13px;color:#374151;cursor:pointer;">↻ Pick a different photo</button>' +
                '<button type="button" class="ttEpYes" style="flex:1;min-width:130px;background:linear-gradient(135deg,#4fa3d1,#3c8ab3);border:none;border-radius:12px;padding:13px;font-family:\'Nunito\',sans-serif;font-weight:900;font-size:13px;color:#fff;cursor:pointer;">✓ Yes, this is ' + safe + '</button>' +
              '</div>' +
            '</div>';
          document.body.appendChild(ov);
          function close() { ov.remove(); URL.revokeObjectURL(url); }
          ov.querySelector('.ttEpYes').addEventListener('click', function () { close(); onYes(); });
          ov.querySelector('.ttEpRetry').addEventListener('click', function () { close(); onRetry(); });
        }

                window.ttRefreshCastStrip = function () {
          if (!code) return;
          fetch(WORKER_BASE + '/status-by-code?code=' + encodeURIComponent(code), { cache: 'no-store' })
            .then(function (r) { return r.json().catch(function () { return {}; }); })
            .then(function (data) {
              var f = (data && (data.fields || data.airtable_fields || data.record_fields || data.record)) || {};
              try { window.ttAllCastEntities = JSON.parse(f.detected_entities || '[]'); } catch (e) { window.ttAllCastEntities = []; }
              try { window.ttEntityImages = JSON.parse(f.entity_reference_images || '{}'); } catch (e) { window.ttEntityImages = {}; }
              var old = document.getElementById('ttCastStrip');
              if (old) old.remove();
              renderCastStrip();
            })
            .catch(function () {});
        };

        function getChildName() {
          var el = document.getElementById('ttLyricsName');
          var t = el && el.textContent ? el.textContent.trim() : '';
          return t || String(window.ttChildName || '').trim();
        }
        function titleName() {
          var n = getChildName();
          if (!n) return '';
          return n
            .replace(/\s+/g, ' ')
            .split(' ')
            .map(function (w) {
              return w.slice(0, 1).toUpperCase() + w.slice(1);
            })
            .join(' ');
        }

        function ethForSkin(s) {
          return D.ethnicities.filter(function (e) {
            return (D.ethBySkin[s] || []).indexOf(e[0]) >= 0;
          });
        }
        function eyeForEth(e) {
          return D.eyes.filter(function (x) {
            return (D.eyeByEth[e] || []).indexOf(x[0]) >= 0;
          });
        }
        function hcForEth(e) {
          return D.hairColors.filter(function (x) {
            return (D.hairColorByEth[e] || []).indexOf(x[0]) >= 0;
          });
        }
        function hsFor(age, g, eth) {
          return ((D.hairByAge[age] || {})[g] || []).filter(function (p) {
            var r = D.hairRestrict[p[0]];
            return !r || r.indexOf(eth) >= 0;
          });
        }

        function baseStem(p) {
          if (!p.gender || !p.age || !p.skin || !p.ethnicity || !p.eye || !p.haircolor || !p.hairstyle) return null;
          return (
            'char-' +
            p.skin +
            '-' +
            p.ethnicity +
            '-' +
            p.age +
            '-' +
            p.gender +
            '-' +
            p.eye +
            '-' +
            p.haircolor +
            '-' +
            p.hairstyle
          );
        }
        function effectiveBaseStem() {
          if (customCharacterUrl) return customCharacterUrl.replace(ASSET_BASE + '/', '').replace(/\.jpg$/i, '');
          return baseStem(pick);
        }
        function effectiveBaseUrl() {
          return customCharacterUrl || ASSET_BASE + '/' + baseStem(pick) + '.jpg';
        }

        function cfg(step) {
          var nm = getChildName() || (ttLang2 === 'es' ? 'él/ella' : 'them');
          switch (step) {
            case 'gender':
              return {
                key: 'gender',
                title: pt2('genderTitleNamed')
                  ? getChildName()
                    ? PT2_ES.genderTitleNamed(titleName())
                    : PT2_ES.genderTitleDefault
                  : getChildName()
                  ? "Let's create " + titleName() + "'s character"
                  : "Let's create their character",
                hint: pt2('genderHintDefault')
                  ? pageTheme === 'superhero'
                    ? PT2_ES.genderHintSuperhero
                    : pageTheme === 'princess'
                    ? PT2_ES.genderHintPrincess
                    : PT2_ES.genderHintDefault
                                    : pageTheme === 'halloween'
                  ? "Let's build them, then suit them up for Halloween! 🎃"
                  : pageTheme === 'superhero'
                  ? "Let's build their superhero look!"
                  : pageTheme === 'princess'
                  ? "Let's build their princess look!"
                  : 'Is your little star a girl or a boy?',
                type: 'cards2',
                items: D.genders.map(function (g) {
                  return { t: g[0], l: g[1], e: g[2] };
                }),
              };
            case 'age':
              return {
                key: 'age',
                title: pt2('ageTitle') || 'How old are they?',
                hint: pt2('ageHint') || 'Pick the age that fits best.',
                type: 'cards2',
                items: D.ages.map(function (a) {
                  return { t: a[0], l: a[1], sub: a[2], e: a[3] };
                }),
              };
            case 'skin':
              return {
                key: 'skin',
                title: pt2('skinTitle') || 'Choose their skin tone',
                hint: pt2('skinHint') || 'Tap the shade most like them.',
                type: 'swatch',
                swatchKind: 'skin',
                items: D.skins.map(function (s) {
                  return { t: s[0], l: s[1], c: s[2] };
                }),
              };
            case 'ethnicity':
              return {
                key: 'ethnicity',
                title: pt2('ethTitle') || 'Which best describes them?',
                hint: pt2('ethHint') || 'This helps us match their features.',
                type: 'rows',
                items: ethForSkin(pick.skin).map(function (e) {
                  return { t: e[0], l: e[1] };
                }),
              };
            case 'eye':
              return {
                key: 'eye',
                title: pt2('eyeTitle') || 'Eye color',
                hint: pt2('eyeHint') ? PT2_ES.eyeHint(nm) : 'Pick ' + nm + "'s eye color.",
                type: 'swatch',
                swatchKind: 'eye',
                items: eyeForEth(pick.ethnicity).map(function (e) {
                  return { t: e[0], l: e[1], c: e[2] };
                }),
              };
            case 'haircolor':
              return {
                key: 'haircolor',
                title: pt2('haircolorTitle') || 'Hair color',
                hint: pt2('haircolorHint') || 'What color is their hair?',
                type: 'swatch',
                swatchKind: 'hair',
                items: hcForEth(pick.ethnicity).map(function (h) {
                  return { t: h[0], l: h[1], c: h[2] };
                }),
              };
            case 'hairstyle':
              return {
                key: 'hairstyle',
                title: pt2('hairstyleTitle') || 'Pick your character',
                hint: pt2('hairstyleHint') || 'Swipe through and tap the one that looks like them.',
                type: 'lineup',
                items: hsFor(pick.age, pick.gender, pick.ethnicity).map(function (p) {
                  return { t: p[0], l: p[1] };
                }),
              };
            case 'outfit':
              return {
                key: 'outfit',
                title: pt2('outfitTitle')
                  ? PT2_ES.outfitTitle(titleName() || nm)
                  : 'Dress ' + (titleName() || 'them') + ' for the song',
                hint: pt2('outfitHint') || 'Keep their look — or pick a new outfit.',
                type: 'outfit',
                items: (OUTFITS[pick.gender] || []).map(function (o) {
                  return { t: o[0], l: o[1] };
                }),
              };
          }
        }

        function setProgress() {
          var pctSteps = si / STEPS.length;
          fill.style.width = Math.round(pctSteps * 100) + '%';
        }

        function render() {
          var step = STEPS[si];
          var c = cfg(step);
          back.classList.toggle('show', si > 0);
          eyebrow.textContent = EYEBROWS[step] || '';
          qt.textContent = c.title;
          qh.textContent = c.hint || '';
          optWrap.innerHTML = '';
          setProgress();

          if (c.type === 'swatch') {
            var sw = document.createElement('div');
            sw.className = 'ttq-swatches';
            c.items.forEach(function (it) {
              var el = document.createElement('div');
              el.className = 'ttq-swatch' + (pick[c.key] === it.t ? ' sel' : '');
              el.setAttribute('role', 'button');
              var vis;
              if (c.swatchKind === 'eye') {
                vis =
                  '<div class="ttq-swatch-vis ttq-vis-eye" style="--iris:' +
                  it.c +
                  '">' +
                  '<span class="ttq-eyeball">' +
                  '<span class="ttq-iris" style="background-color:' +
                  it.c +
                  '"></span>' +
                  '<span class="ttq-pupil"></span>' +
                  '<span class="ttq-glint"></span>' +
                  '<span class="ttq-glint2"></span>' +
                  '</span>' +
                  '<span class="ttq-lash"></span>' +
                  '<span class="ttq-lash-b"></span>' +
                  '</div>';
              } else if (c.swatchKind === 'hair') {
                var hid = 'hg' + it.t;
                vis =
                  '<div class="ttq-swatch-vis">' +
                  '<svg viewBox="0 0 60 60" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">' +
                  '<defs><radialGradient id="' +
                  hid +
                  '" cx="35%" cy="28%" r="85%">' +
                  '<stop offset="0%" stop-color="#ffffff" stop-opacity="0.45"/>' +
                  '<stop offset="35%" stop-color="' +
                  it.c +
                  '"/>' +
                  '<stop offset="100%" stop-color="' +
                  it.c +
                  '"/>' +
                  '</radialGradient></defs>' +
                  '<circle cx="30" cy="30" r="30" fill="' +
                  it.c +
                  '"/>' +
                  '<circle cx="30" cy="30" r="30" fill="url(#' +
                  hid +
                  ')"/>' +
                  '<path d="M12 44 Q 22 12 48 14" stroke="#ffffff" stroke-opacity="0.35" stroke-width="2.5" fill="none" stroke-linecap="round"/>' +
                  '<path d="M16 50 Q 27 20 52 22" stroke="#ffffff" stroke-opacity="0.18" stroke-width="2" fill="none" stroke-linecap="round"/>' +
                  '<path d="M9 36 Q 18 8 42 9" stroke="#000000" stroke-opacity="0.12" stroke-width="2" fill="none" stroke-linecap="round"/>' +
                  '</svg></div>';
              } else {
                var sid = 'sg' + it.t;
                vis =
                  '<div class="ttq-swatch-vis">' +
                  '<svg viewBox="0 0 60 60" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">' +
                  '<defs><radialGradient id="' +
                  sid +
                  '" cx="34%" cy="26%" r="90%">' +
                  '<stop offset="0%" stop-color="#ffffff" stop-opacity="0.5"/>' +
                  '<stop offset="40%" stop-color="' +
                  it.c +
                  '"/>' +
                  '<stop offset="100%" stop-color="' +
                  it.c +
                  '"/>' +
                  '</radialGradient>' +
                  '<radialGradient id="' +
                  sid +
                  'b" cx="68%" cy="84%" r="70%">' +
                  '<stop offset="0%" stop-color="#000000" stop-opacity="0.14"/>' +
                  '<stop offset="60%" stop-color="#000000" stop-opacity="0"/>' +
                  '</radialGradient></defs>' +
                  '<circle cx="30" cy="30" r="30" fill="' +
                  it.c +
                  '"/>' +
                  '<circle cx="30" cy="30" r="30" fill="url(#' +
                  sid +
                  ')"/>' +
                  '<circle cx="30" cy="30" r="30" fill="url(#' +
                  sid +
                  'b)"/>' +
                  '</svg></div>';
              }
              el.innerHTML = vis + '<div class="ttq-swatch-label">' + it.l + '</div>';
              el.addEventListener('click', function () {
                selectAndAdvance(c.key, it.t, el, sw);
              });
              sw.appendChild(el);
            });
            optWrap.appendChild(sw);
          } else if (c.type === 'rows') {
            var rw = document.createElement('div');
            rw.className = 'ttq-rows';
            c.items.forEach(function (it) {
              var el = document.createElement('button');
              el.type = 'button';
              el.className = 'ttq-row' + (pick[c.key] === it.t ? ' sel' : '');
              el.innerHTML = '<span class="ttq-row-label">' + it.l + '</span>';
              el.addEventListener('click', function () {
                selectAndAdvance(c.key, it.t, el, rw);
              });
              rw.appendChild(el);
            });
            optWrap.appendChild(rw);
          } else if (c.type === 'outfit') {
            var CUSTOM_OUTFIT_IMG = 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/outfit%20custom.png';
                        var outfitItems = [
              { t: 'keep', l: pt2('keepOutfit') || 'Keep this outfit', isKeep: true },
              { t: 'custom', l: pt2('customOutfit') || 'Custom outfit', isCustomTrigger: true },
            ].concat(c.items);
            var lineWrapO = document.createElement('div');
            lineWrapO.className = 'ttq-lineup';
            var trackO = document.createElement('div');
            trackO.className = 'ttq-track';
            var dotsO = document.createElement('div');
            dotsO.className = 'ttq-ldots';
            var selOutfit = pick.outfit || 'keep';
            var customModeActive = false;
            var slidesO = [];

                                   outfitItems.forEach(function (it) {
              var url = it.isKeep
                ? effectiveBaseUrl()
                : it.isCustomTrigger
                ? CUSTOM_OUTFIT_IMG
                : PRINCESS_DRESSES[it.t]
                ? PRINCESS_DRESSES[it.t].url
                : SUPERHERO_OUTFITS[it.t]
                ? SUPERHERO_OUTFITS[it.t].url
                : ASSET_BASE + '/outfit-' + pick.gender + '-' + it.t + '.jpg';
              var slide = document.createElement('div');
              slide.className = 'ttq-slide';
              slide.dataset.token = it.t;
              slide.innerHTML =
                '<div class="ttq-slide-card' +
                (selOutfit === it.t ? ' sel' : '') +
                '">' +
                '<div class="ttq-slide-skel"></div>' +
                '<img alt="' +
                it.l +
                '" loading="lazy">' +
                '<span class="ttq-slide-chk">✓</span>' +
                '</div>' +
                '<div class="ttq-slide-label">' +
                it.l +
                '</div>';
              var img = slide.querySelector('img');
              img.addEventListener('load', function () {
                slide.querySelector('.ttq-slide-skel').style.display = 'none';
                img.style.opacity = '1';
              });
              img.addEventListener('error', function () {
                slide.remove();
                var i = slidesO.indexOf(slide);
                if (i >= 0) slidesO.splice(i, 1);
                buildDotsO();
              });
              img.src = url;
              slide.addEventListener('click', function () {
                Array.prototype.forEach.call(trackO.children, function (s) {
                  var card = s.querySelector('.ttq-slide-card');
                  if (card) card.classList.remove('sel');
                });
                slide.querySelector('.ttq-slide-card').classList.add('sel');
                centerSlideO(slide);

                if (it.isCustomTrigger) {
                  customModeActive = true;
                  selOutfit = 'custom';
                  coWrap.classList.add('show');
                  finishBtnO.disabled = false;
                  updateFinishBtnOLabel();
                  var coInputEl = coWrap.querySelector('input');
                  if (coInputEl) coInputEl.focus();
                  return;
                }

                customModeActive = false;
                coWrap.classList.remove('show');
                selOutfit = it.t;
                pick.outfit = it.t;
                finishBtnO.disabled = false;
                updateFinishBtnOLabel();
              });
              trackO.appendChild(slide);
              slidesO.push(slide);
            });

            var arrowLO = document.createElement('button');
            arrowLO.type = 'button';
            arrowLO.className = 'ttq-arrow ttq-arrow-l';
            arrowLO.innerHTML = '‹';
            arrowLO.setAttribute('aria-label', 'Previous');
            var arrowRO = document.createElement('button');
            arrowRO.type = 'button';
            arrowRO.className = 'ttq-arrow ttq-arrow-r';
            arrowRO.innerHTML = '›';
            arrowRO.setAttribute('aria-label', 'Next');
            arrowLO.addEventListener('click', function () {
              trackO.scrollBy({ left: -Math.round(trackO.clientWidth * 0.7), behavior: 'smooth' });
            });
            arrowRO.addEventListener('click', function () {
              trackO.scrollBy({ left: Math.round(trackO.clientWidth * 0.7), behavior: 'smooth' });
            });

            function centerSlideO(slide) {
              trackO.scrollTo({
                left: slide.offsetLeft - (trackO.clientWidth - slide.clientWidth) / 2,
                behavior: 'smooth',
              });
            }
            function buildDotsO() {
              dotsO.innerHTML = '';
              slidesO.forEach(function () {
                var d = document.createElement('span');
                d.className = 'ttq-ldot';
                dotsO.appendChild(d);
              });
              updateDotsO();
            }
            function updateDotsO() {
              var center = trackO.scrollLeft + trackO.clientWidth / 2;
              var best = 0,
                bestD = 1e9;
              slidesO.forEach(function (s, i) {
                var c2 = s.offsetLeft + s.clientWidth / 2;
                var d = Math.abs(c2 - center);
                if (d < bestD) {
                  bestD = d;
                  best = i;
                }
              });
              Array.prototype.forEach.call(dotsO.children, function (d, i) {
                d.classList.toggle('on', i === best);
              });
            }
            trackO.addEventListener('scroll', function () {
              window.requestAnimationFrame(updateDotsO);
            });

            lineWrapO.appendChild(arrowLO);
            lineWrapO.appendChild(trackO);
            lineWrapO.appendChild(arrowRO);
            optWrap.appendChild(lineWrapO);
            optWrap.appendChild(dotsO);
            buildDotsO();

            setTimeout(function () {
              var target =
                slidesO.filter(function (s) {
                  return s.dataset.token === selOutfit;
                })[0] || slidesO[0];
              if (target) centerSlideO(target);
            }, 60);

            var finishBtnO = document.createElement('button');
            finishBtnO.type = 'button';
            finishBtnO.className = 'ttq-primary';
            finishBtnO.style.marginTop = '22px';
            finishBtnO.disabled = !pick.outfit;

            function outfitLabelFor(token) {
              if (!token || token === 'keep') return pt2('currentLook') || 'their current look';
              var match = outfitItems.filter(function (it) {
                return it.t === token;
              })[0];
              return match ? match.l : pt2('newOutfit') || 'their new outfit';
            }
            function updateFinishBtnOLabel() {
              var name = titleName() || (ttLang2 === 'es' ? 'él/ella' : 'them');
              if (customModeActive) {
                finishBtnO.textContent = pt2('dressCustom')
                  ? PT2_ES.dressCustom(name)
                  : '✨ Dress ' + name + ' in a custom outfit';
                return;
              }
              finishBtnO.textContent = pt2('dressLabel')
                ? PT2_ES.dressLabel(name, outfitLabelFor(pick.outfit || 'keep'))
                : '✨ Dress ' + name + ' in ' + outfitLabelFor(pick.outfit || 'keep');
            }
            updateFinishBtnOLabel();
            finishBtnO.addEventListener('click', function () {
              if (customModeActive) {
                runCustomOutfitFlow();
              } else {
                saveCharacter();
              }
            });
            optWrap.appendChild(finishBtnO);

            var coWrap = document.createElement('div');
            coWrap.className = 'ttq-custom-outfit-input-wrap';
            coWrap.innerHTML = '<input type="text" id="ttqCustomOutfitInput" placeholder="">';
            optWrap.appendChild(coWrap);
            var coStatus = document.createElement('div');
            coStatus.className = 'ttq-custom-outfit-status';
            coStatus.id = 'ttqCustomOutfitStatus';
            optWrap.appendChild(coStatus);
            var coPreview = document.createElement('div');
            coPreview.className = 'ttq-custom-outfit-preview';
            coPreview.innerHTML =
              '<div class="ttq-custom-outfit-preview-spinner"><div class="ttq-spin"></div></div><img alt="">';
            optWrap.appendChild(coPreview);

            var coInput = coWrap.querySelector('#ttqCustomOutfitInput');

            var CUSTOM_OUTFIT_EXAMPLES = pt2('outfitPlaceholders') || [
              'e.g. red superhero cape and boots',
              'e.g. sparkly blue princess gown',
              'e.g. cozy dinosaur onesie',
              'e.g. denim overalls with a striped shirt',
              'e.g. soccer jersey and shorts',
              'e.g. astronaut suit with a helmet',
            ];
            var coPhIndex = 0;
            coInput.setAttribute('placeholder', CUSTOM_OUTFIT_EXAMPLES[0]);
            var coPhTimer = setInterval(function () {
              if (document.activeElement === coInput || coInput.value) return;
              coPhIndex = (coPhIndex + 1) % CUSTOM_OUTFIT_EXAMPLES.length;
              coInput.setAttribute('placeholder', CUSTOM_OUTFIT_EXAMPLES[coPhIndex]);
            }, 2200);

            function runCustomOutfitFlow() {
              var desc = (coInput.value || '').trim();
              if (!desc) {
                coInput.focus();
                return;
              }

              // Clear the whole outfit step and show just a loading state
              optWrap.innerHTML = '';
              var loadingWrap = document.createElement('div');
              loadingWrap.style.cssText = 'text-align:center;padding:60px 20px;';
              loadingWrap.innerHTML =
                '<div style="width:48px;height:48px;margin:0 auto 20px;border-radius:50%;border:4px solid rgba(79,163,209,.2);border-top-color:#4fa3d1;animation:ttSpin .8s linear infinite;"></div>' +
                '<div style="font-family:\'Fraunces\',serif;font-weight:600;font-size:20px;color:#16324a;">' +
                (pt2('creatingOutfit')
                  ? PT2_ES.creatingOutfit(titleName() || 'su')
                  : 'Creating ' + (titleName() || 'their') + "'s outfit…") +
                '</div>';
              optWrap.appendChild(loadingWrap);
              try {
                loadingWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
              } catch (e) {}

              fetch(WORKER_BASE + '/generate-character', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  code: code,
                  skin: pick.skin,
                  ethnicity: pick.ethnicity,
                  age: pick.age,
                  gender: pick.gender,
                  eye: pick.eye,
                  haircolor: pick.haircolor,
                  hairstyle: pick.hairstyle,
                  extra_detail: `Change ONLY the character's outfit/clothing to: ${desc}. Keep the character's face, hair, skin tone, and body proportions completely unchanged. The character's arms, hands, and legs must remain fully visible and intact — do not crop, hide, or omit any part of the body. IMPORTANT: The character's feet must ALWAYS be covered by appropriate footwear that matches the described outfit (for example: boots for an astronaut or superhero suit, sneakers for sporty outfits, dress shoes for formal wear, sandals only if explicitly described). Even if the outfit description does not mention footwear, you must still generate suitable shoes that match the outfit's style — never leave the character's feet bare, exposed, or without shoes under any circumstances. If the described outfit includes sleeves (long sleeves, short sleeves, etc.), the sleeves must be rendered exactly as described and must fully cover the arm to the described length — never shorten, remove, or convert sleeves to sleeveless.`,
                  base_image_url: customCharacterUrl || undefined,
                }),
              })
                .then(function (r) {
                  return r.json().catch(function () {
                    return {};
                  });
                })
                .then(function (out) {
                  if (out && out.ok && out.imageUrl) {
                    customCharacterUrl = out.imageUrl;
                    pick.outfit = 'custom';
                    saveCharacter();
                  } else {
                    optWrap.innerHTML =
                      '<div style="text-align:center;padding:40px 20px;color:#b42318;font-weight:700;">' +
                      (ttLang2 === 'es'
                        ? 'No pudimos crear ese atuendo — por favor regresa e intenta de nuevo.'
                        : "Couldn't create that outfit — please go back and try again.") +
                      '</div>';
                  }
                })
                .catch(function () {
                  optWrap.innerHTML =
                    '<div style="text-align:center;padding:40px 20px;color:#b42318;font-weight:700;">' +
                    (pt2('somethingWrong') || 'Something went wrong — please go back and try again.') +
                    '</div>';
                });
            }
          } else if (c.type === 'lineup') {
            var parts = [pick.skin, pick.ethnicity, pick.age, pick.gender, pick.eye, pick.haircolor];
            var prefix = 'char-' + parts.join('-') + '-';
            var lineWrap = document.createElement('div');
            lineWrap.className = 'ttq-lineup';
            var track = document.createElement('div');
            track.className = 'ttq-track';
            var dots = document.createElement('div');
            dots.className = 'ttq-ldots';
            var selToken = pick.hairstyle || null;
            var slides = [];

            c.items.forEach(function (it, idx) {
              function makeSlide(variantSuffix, isVariant) {
                var url = ASSET_BASE + '/' + prefix + it.t + variantSuffix + '.jpg';
                var slide = document.createElement('div');
                slide.className = 'ttq-slide';
                slide.dataset.token = it.t;
                slide.innerHTML =
                  '<div class="ttq-slide-card' +
                  (selToken === it.t ? ' sel' : '') +
                  '">' +
                  '<div class="ttq-slide-skel"></div>' +
                  '<img alt="' +
                  it.l +
                  '" loading="lazy">' +
                  '<span class="ttq-slide-chk">✓</span>' +
                  '</div>' +
                  '<div class="ttq-slide-label">' +
                  it.l +
                  '</div>';
                var img = slide.querySelector('img');
                img.addEventListener('load', function () {
                  slide.querySelector('.ttq-slide-skel').style.display = 'none';
                  img.style.opacity = '1';
                });
                function removeSlide() {
                  slide.remove();
                  var i = slides.indexOf(slide);
                  if (i >= 0) slides.splice(i, 1);
                  buildDots();
                }
                function fetchMissingHairstyle(attempt) {
                  attempt = attempt || 1;
                  fetch(WORKER_BASE + '/generate-character', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      skin: pick.skin,
                      ethnicity: pick.ethnicity,
                      age: pick.age,
                      gender: pick.gender,
                      eye: pick.eye,
                      haircolor: pick.haircolor,
                      hairstyle: it.t,
                    }),
                  })
                    .then(function (r) {
                      return r.json().catch(function () {
                        return {};
                      });
                    })
                    .then(function (out) {
                      if (out && out.ok && out.done === true && out.imageUrl) {
                        var freshImg = new Image();
                        freshImg.onload = function () {
                          img.onerror = removeSlide;
                          img.src = out.imageUrl + '?_cb=' + Date.now();
                        };
                        freshImg.onerror = removeSlide;
                        freshImg.src = out.imageUrl + '?_cb=' + Date.now();
                      } else if (out && out.ok && out.generating && attempt < 8) {
                        setTimeout(function () {
                          fetchMissingHairstyle(attempt + 1);
                        }, 3000);
                      } else {
                        removeSlide();
                      }
                    })
                    .catch(removeSlide);
                }
                img.addEventListener('error', function () {
                  img.onerror = null;
                  if (isVariant) {
                    // optional bonus look — just drop it silently if this combo has no variant
                    removeSlide();
                  } else {
                    fetchMissingHairstyle();
                  }
                });
                img.src = url;
                slide.addEventListener('click', function () {
                  selToken = it.t;
                  Array.prototype.forEach.call(track.children, function (s) {
                    var card = s.querySelector('.ttq-slide-card');
                    if (card) card.classList.remove('sel');
                  });
                  slide.querySelector('.ttq-slide-card').classList.add('sel');
                  pickBtn.disabled = false;
                  pickBtn.textContent = pt2('thisIsTheOne') || 'This is the one →';
                  centerSlide(slide);
                });
                track.appendChild(slide);
                slides.push(slide);
              }

              makeSlide('', false);
              makeSlide('-v2', true);
            });

            var arrowL = document.createElement('button');
            arrowL.type = 'button';
            arrowL.className = 'ttq-arrow ttq-arrow-l';
            arrowL.innerHTML = '‹';
            arrowL.setAttribute('aria-label', 'Previous');
            var arrowR = document.createElement('button');
            arrowR.type = 'button';
            arrowR.className = 'ttq-arrow ttq-arrow-r';
            arrowR.innerHTML = '›';
            arrowR.setAttribute('aria-label', 'Next');
            arrowL.addEventListener('click', function () {
              track.scrollBy({ left: -Math.round(track.clientWidth * 0.7), behavior: 'smooth' });
            });
            arrowR.addEventListener('click', function () {
              track.scrollBy({ left: Math.round(track.clientWidth * 0.7), behavior: 'smooth' });
            });

            function centerSlide(slide) {
              track.scrollTo({
                left: slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2,
                behavior: 'smooth',
              });
            }
            function buildDots() {
              dots.innerHTML = '';
              slides.forEach(function (s, i) {
                var d = document.createElement('span');
                d.className = 'ttq-ldot';
                dots.appendChild(d);
              });
              updateDots();
            }
            function updateDots() {
              var center = track.scrollLeft + track.clientWidth / 2;
              var best = 0,
                bestD = 1e9;
              slides.forEach(function (s, i) {
                var c2 = s.offsetLeft + s.clientWidth / 2;
                var d = Math.abs(c2 - center);
                if (d < bestD) {
                  bestD = d;
                  best = i;
                }
              });
              Array.prototype.forEach.call(dots.children, function (d, i) {
                d.classList.toggle('on', i === best);
              });
            }
            track.addEventListener('scroll', function () {
              window.requestAnimationFrame(updateDots);
            });

            lineWrap.appendChild(arrowL);
            lineWrap.appendChild(track);
            lineWrap.appendChild(arrowR);
            optWrap.appendChild(lineWrap);
            optWrap.appendChild(dots);

            var pickBtn = document.createElement('button');
            pickBtn.type = 'button';
            pickBtn.className = 'ttq-primary';
            pickBtn.style.marginTop = '20px';
            pickBtn.disabled = !selToken;
            pickBtn.textContent = selToken
              ? pt2('thisIsTheOne') || 'This is the one →'
              : pt2('tapFavorite') || 'Tap your favorite';
            pickBtn.addEventListener('click', function () {
              if (!selToken) return;
              choose('hairstyle', selToken);
              goNext();
            });
            optWrap.appendChild(pickBtn);

            buildDots();
            setTimeout(function () {
              var target = selToken
                ? slides.filter(function (s) {
                    return s.dataset.token === selToken;
                  })[0]
                : slides[0];
              if (target) centerSlide(target);
            }, 60);
          } else {
            var grid = document.createElement('div');
            grid.className = 'ttq-cards two';
            c.items.forEach(function (it) {
              var el = document.createElement('button');
              el.type = 'button';
              el.className = 'ttq-card' + (pick[c.key] === it.t ? ' sel' : '');
              el.innerHTML =
                '<span class="ttq-card-emoji">' +
                (it.e || '🙂') +
                '</span><span class="ttq-card-label">' +
                it.l +
                '</span>' +
                (it.sub ? '<span class="ttq-card-sub">' + it.sub + '</span>' : '');
              el.addEventListener('click', function () {
                selectAndAdvance(c.key, it.t, el, grid);
              });
              grid.appendChild(el);
            });
            optWrap.appendChild(grid);
          }

          stepWrap.classList.remove('in');
          void stepWrap.offsetWidth;
          stepWrap.classList.add('in');
        }

        function selectAndAdvance(key, token, el, container) {
  if (key === 'gender' && entryLikenessWrap && entryLikenessWrap.style.display !== 'none') {
    entryLikenessWrap.style.display = 'none';
  }
  choose(key, token);
  Array.prototype.forEach.call(container.children, function (x) {
    x.classList.remove('sel');
  });
  el.classList.add('sel');
  setTimeout(goNext, 360);
}

        function choose(key, token) {
          customCharacterUrl = null;
          pick[key] = token;
          if (key === 'skin') {
            pick.ethnicity = pick.eye = pick.haircolor = pick.hairstyle = null;
          }
          if (key === 'ethnicity') {
            pick.eye = pick.haircolor = pick.hairstyle = null;
          }
          if (key === 'age' || key === 'gender') {
            pick.hairstyle = null;
          }
        }

        function goNext() {
             if (STEPS[si] === 'hairstyle') {
            // No review screen: the movie poster is their first look at the character
            showReveal();
            revealWrap.style.display = 'none';
            window.ttAutoApprove = true;
            document.dispatchEvent(new CustomEvent('ttCharacterSubmitted'));
            setTimeout(function () { var b = $('ttqToOutfit'); if (b) b.click(); }, 50); // themed → costume, others → save
            return;
          }
          si++;
          render();
        }

        back.addEventListener('click', function () {
          if (revealWrap.style.display !== 'none') {
            revealWrap.style.display = 'none';
            form.style.display = 'block';
            si = STEPS.indexOf('hairstyle');
            render();
            return;
          }
          if (si > 0) {
            si--;
            render();
          }
        });

                function showReveal() {
          form.style.display = 'none';
          var headerEl = document.getElementById('ttCharBuilderHeader');
          if (headerEl) headerEl.style.display = 'none';
          fill.style.width = '100%';
          var stem = baseStem(pick);
          var url = ASSET_BASE + '/' + stem + '.jpg';
          var nm = titleName();

          function getToOutfitLabel() {
  var displayName = titleName() || (ttLang2 === 'es' ? 'él/ella' : 'them');
  if (pageTheme === 'superhero')
    return pt2('toOutfitSuperhero')
      ? PT2_ES.toOutfitSuperhero(displayName)
      : '✨ Dress ' + displayName + ' as a Superhero&nbsp;→';
  if (pageTheme === 'halloween')
    return ttLang2 === 'es'
      ? '🎃 Ponerle su disfraz de ' + (String(pageThemeOutfitName || '').replace(/^custom:\s*/i, '') || 'Halloween') + '&nbsp;→'
      : '🎃 Put on ' + displayName + "'s " + (String(pageThemeOutfitName || '').replace(/^custom:\s*/i, '') || 'Halloween') + ' costume&nbsp;→';
  if (pageTheme === 'princess')
    return pt2('toOutfitPrincess')
      ? PT2_ES.toOutfitPrincess(displayName)
      : '✨ Dress ' + displayName + ' as a Princess&nbsp;→';
  return ttLang2 === 'es' ? '✓ Me encanta — continuar&nbsp;→' : '✓ Love it — continue&nbsp;→';
}

          revealWrap.innerHTML =
            '<div class="ttq-reveal-eyebrow">' +
            (pt2('sayHelloTo') || '✨ Say hello to') +
            '</div>' +
            '<div class="ttq-reveal-name">' +
            (nm ? escapeHtml(nm) : pt2('littleStarDefault') || 'Your little star') +
            '</div>' +
            '<div class="ttq-reveal-frame">' +
            '<div class="ttq-reveal-halo"></div>' +
            '<div class="ttq-reveal-portrait" id="ttqRevealPortrait"><img src="' +
            url +
            '" alt="Character" id="ttqRevealImg"></div>' +
            '<span class="ttq-spark" style="top:-6%;left:8%;animation-delay:.1s">✨</span>' +
            '<span class="ttq-spark" style="top:14%;right:-4%;animation-delay:.9s">✨</span>' +
            '<span class="ttq-spark" style="bottom:6%;left:-2%;animation-delay:1.6s">⭐</span>' +
            '<span class="ttq-spark" style="bottom:18%;right:6%;animation-delay:2.1s">✨</span>' +
            '</div>' +
            '<div class="ttq-reveal-actions">' +
                  '<div class="ttq-tweak-section" id="ttqTweakSection">' +
            '<button type="button" class="ttq-primary" id="ttqToOutfit">' + getToOutfitLabel() + '</button>' +
            '<button type="button" class="ttq-textlink" id="ttqTweakToggle" style="margin-top:12px;">✏️ ' + (ttLang2 === 'es' ? '¿Cambiar algo?' : 'Change something?') + '</button>' +
            '<div id="ttqTweakBox" style="display:none;margin-top:8px;">' +
            '<textarea id="ttqTweakInput" class="ttq-tweak-input"></textarea>' +
            '<button type="button" class="ttq-primary" id="ttqTweakSubmit" style="margin-top:10px;padding:12px 20px;font-size:14px;background:linear-gradient(135deg,#f0b429,#e0a000);">' +
            (pt2('tweakUpdateBtn') || 'Update character') +
            '</button>' +
            '</div>' +
            '</div>' +
            '<button type="button" class="ttq-textlink" id="ttqRedo" style="margin-top:16px;">' +
            (pt2('startOver') || 'Start over') +
            '</button>' +
            '</div>';
          revealWrap.style.display = 'block';
          back.classList.add('show');

          var imgEl = $('ttqRevealImg');
          var portraitEl = $('ttqRevealPortrait');

          function showGenerating(label) {
            portraitEl.classList.add('working');
            var sub = document.createElement('div');
            sub.id = 'ttqGenStatus';
            sub.style.cssText = 'margin-top:10px;font-size:13px;font-weight:700;color:#3c8ab3;';
            sub.innerHTML =
              '<span class="ttq-loading-dot"></span> ' +
              (label || pt2('creatingCharacter') || 'Creating their character...');
            portraitEl.parentNode.insertBefore(sub, portraitEl.nextSibling);
            try {
              portraitEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } catch (e) {}
          }
          function hideGenerating() {
            portraitEl.classList.remove('working');
            var sub = $('ttqGenStatus');
            if (sub) sub.remove();
          }

          function requestCharacter(extraDetail, onDone) {
            showGenerating(
              extraDetail
                ? pt2('updatingLook')
                  ? PT2_ES.updatingLook(titleName() || 'su')
                  : 'Updating ' + (titleName() || 'their') + "'s look..."
                : pt2('creatingCharacter') || 'Creating their character...'
            );
            fetch(WORKER_BASE + '/generate-character', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                code: code,
                skin: pick.skin,
                ethnicity: pick.ethnicity,
                age: pick.age,
                gender: pick.gender,
                eye: pick.eye,
                haircolor: pick.haircolor,
                hairstyle: pick.hairstyle,
                extra_detail: extraDetail || undefined,
                base_image_url: customCharacterUrl || undefined,
              }),
            })
              .then(function (r) {
                return r.json().catch(function () {
                  return {};
                });
              })
              .then(function (out) {
                hideGenerating();
                if (out && out.ok && out.imageUrl) {
                  imgEl.src = out.imageUrl + '?_cb=' + Date.now();
                  if (onDone) onDone(true, out.imageUrl);
                } else {
                  var sub = document.createElement('div');
                  sub.style.cssText = 'margin-top:10px;font-size:13px;font-weight:700;color:#b42318;';
                  sub.textContent =
                    pt2('couldntCreateCharacter') || "Couldn't create the character — please try again.";
                  portraitEl.parentNode.insertBefore(sub, portraitEl.nextSibling);
                  if (onDone) onDone(false);
                }
              })
              .catch(function () {
                hideGenerating();
                if (onDone) onDone(false);
              });
          }

          // Cache-miss fallback — fires automatically if the base image 404s
          imgEl.addEventListener(
            'error',
            function () {
              imgEl.onerror = null; // prevent loop if the generated one also fails
              requestCharacter(null);
            },
            { once: true }
          );

              function goToOutfitStep() {
            if (pageTheme === 'superhero' || pageTheme === 'princess' || pageTheme === 'halloween') {
              dressThemedCharacterAndSave();
              return;
            }
             pick.outfit = 'keep'; // outfit changes are offered after checkout
            saveCharacter();
            if (window.ttAutoApprove) approveCharacter('standard', approveBtn, likenessBtn);
          }

          function dressThemedCharacterAndSave() {
                    const isHalloweenTheme = pageTheme === 'halloween';
            const themeLabelEN = isHalloweenTheme
              ? (String(pageThemeOutfitName || '').replace(/^custom:\s*/i, '') || 'Halloween')
              : pageTheme === 'superhero' ? 'Superhero' : 'Princess';
            const themeLabel = isHalloweenTheme
              ? themeLabelEN
              : ttLang2 === 'es' ? (pageTheme === 'superhero' ? PT2_ES.heroLabel : PT2_ES.princessLabel) : themeLabelEN;
            const baseUrl = effectiveBaseUrl();
            const stem = effectiveBaseStem();

            form.style.display = 'none';
            revealWrap.style.display = 'none';
            $('ttCharbSavedImg').src = baseUrl;
            $('ttCharbSavedName').textContent = titleName() || pt2('allSet') || 'All set!';
            $('ttCharbSub').innerHTML =
              '<span class="ttq-loading-dot"></span> ' +
              (pt2('dressingThem')
                ? PT2_ES.dressingThem(titleName() || pt2('them') || 'them', themeLabel)
                : 'Dressing ' + (titleName() || 'them') + ' as a ' + themeLabel + '…');
            savedWrap.style.display = 'block';
            savedWrap.classList.add('working');

            const dressFrame = document.querySelector('#ttCharbSaved .ttq-saved-frame');
            if (dressFrame) {
              dressFrame.classList.add('tt-dressing-loading');
              const overlay = document.createElement('div');
              overlay.className = 'tt-dressing-overlay';
              overlay.id = 'ttDressingOverlay';
              overlay.innerHTML =
                '<div class="tt-dressing-spinner"></div><div class="tt-dressing-overlay-text">' +
                (pt2('puttingOnCostume')
                  ? PT2_ES.puttingOnCostume(themeLabel.toLowerCase())
                  : 'Putting on their ' + themeLabelEN.toLowerCase() + ' costume…') +
                '</div>';
              dressFrame.appendChild(overlay);
            }

            try {
              const cardTop = document.getElementById('ttCharBuilder');
              if (cardTop && cardTop.scrollIntoView) cardTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch (e) {}

            fetch(WORKER_BASE + '/apply-theme-outfit-grok', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                code: code,
                outfit_id: pageThemeOutfitName,
                theme: pageTheme,
                base_image_url: baseUrl,
                outfit_image_url: isHalloweenTheme ? halloweenCostumeUrl() : undefined,
              }),
            })
              .then((r) => r.json().catch(() => ({})))
              .then((out) => {
                savedWrap.classList.remove('working');
                const overlayEl = document.getElementById('ttDressingOverlay');
                if (overlayEl) overlayEl.remove();
                if (out && out.ok && out.imageUrl) {
                  const img = $('ttCharbSavedImg');
                  if (img) img.src = out.imageUrl + '?_cb=' + Date.now();
                  const frame = document.querySelector('#ttCharbSaved .ttq-saved-frame');
                  if (frame) {
                    frame.classList.add('is-dressed');
                    frame.classList.remove('tt-dressing-loading');
                  }
                  $('ttCharbSub').textContent = pt2('readyForReveal') || '✓ Ready for their big reveal! 🎬';
                  try {
                    window.savedCharacterId = stem;
                    window.savedCharacterUrl = out.imageUrl;
                    window.ttOutfit = pageThemeOutfitName;
                  } catch (e) {}
                  if (typeof window.updateVideoCta === 'function') window.updateVideoCta();
                  if (typeof window.applyCharacterToPlayer === 'function') window.applyCharacterToPlayer();
                  document.dispatchEvent(
                    new CustomEvent('ttCharacterSaved', {
                      detail: {
                        character_id: stem,
                        url: out.imageUrl,
                        outfit: pageThemeOutfitName,
                        gender: pick.gender,
                        base_character: stem,
                      },
                    })
                  );
                  document.dispatchEvent(new CustomEvent('ttCharacterDressed', { detail: { url: out.imageUrl } }));

                  window._ttCharacterSavePromise = trackedSave({
                    code: code,
                    character_id: stem,
                    character_label: pick.ethnicity + ' ' + pick.hairstyle,
                    look_label: pick.skin,
                    age_group: pick.age,
                    gender: pick.gender,
                    outfit: pageThemeOutfitName,
                    outfit_name: pageThemeOutfitName,
                    base_character: stem,
                    character_image_url: out.imageUrl,
                    child_name: getChildName() || '',
                    character_is_final: true,
                    }).catch((err) => console.error('[TT] themed final save failed:', err));
                  if (window.ttAutoApprove) approveCharacter('standard', approveBtn, likenessBtn);
                } else {
                  const frame2 = document.querySelector('#ttCharbSaved .ttq-saved-frame');
                  if (frame2) frame2.classList.remove('tt-dressing-loading');
                  $('ttCharbSub').innerHTML =
                    pt2('couldntCreateCostume') ||
                    '⚠️ Couldn\'t create the costume — <button type="button" id="ttcThemeRetry" style="background:none;border:none;color:#3c8ab3;font-weight:900;text-decoration:underline;cursor:pointer;padding:0;font-size:inherit;">tap to retry</button>';
                  const rb = document.getElementById('ttcThemeRetry');
                  if (rb) rb.addEventListener('click', dressThemedCharacterAndSave);
                }
              })
              .catch(() => {
                savedWrap.classList.remove('working');
                const overlayEl2 = document.getElementById('ttDressingOverlay');
                if (overlayEl2) overlayEl2.remove();
                const frame3 = document.querySelector('#ttCharbSaved .ttq-saved-frame');
                if (frame3) frame3.classList.remove('tt-dressing-loading');
                $('ttCharbSub').innerHTML =
                  pt2('couldntCreateCostume') ||
                  '⚠️ Couldn\'t create the costume — <button type="button" id="ttcThemeRetry" style="background:none;border:none;color:#3c8ab3;font-weight:900;text-decoration:underline;cursor:pointer;padding:0;font-size:inherit;">tap to retry</button>';
                const rb = document.getElementById('ttcThemeRetry');
                if (rb) rb.addEventListener('click', dressThemedCharacterAndSave);
              });
          }
          function bindToOutfitBtn() {
            var btn = $('ttqToOutfit');
            if (btn) btn.addEventListener('click', goToOutfitStep);
          }
          bindToOutfitBtn();
          $('ttqRedo').addEventListener('click', resetAll);
          var tweakToggle = $('ttqTweakToggle');
          if (tweakToggle) tweakToggle.addEventListener('click', function () {
            var box = $('ttqTweakBox');
            var open = box.style.display === 'none';
            box.style.display = open ? 'block' : 'none';
            if (open) setTimeout(function () { var ti = $('ttqTweakInput'); if (ti) ti.focus(); }, 50);
          });

          var MAX_TWEAKS = 2;
          var tweakAttempts = 0;
          var remainingEl = $('ttqTweakRemaining');
          var tweakInput = $('ttqTweakInput');

          var PLACEHOLDER_EXAMPLES = pt2('tweakPlaceholders') || [
            'e.g. give her curly red hair',
            'e.g. add round glasses and freckles',
            'e.g. make the hair darker',
            'e.g. change eye color to hazel',
            'e.g. add a little birthmark near her eye',
            'e.g. give him a bigger smile',
          ];
          var phIndex = 0;
          if (tweakInput) tweakInput.setAttribute('placeholder', PLACEHOLDER_EXAMPLES[0]);
          var phTimer = setInterval(function () {
            if (!tweakInput || document.activeElement === tweakInput || tweakInput.value) return;
            phIndex = (phIndex + 1) % PLACEHOLDER_EXAMPLES.length;
            tweakInput.setAttribute('placeholder', PLACEHOLDER_EXAMPLES[phIndex]);
          }, 2200);

          function updateRemaining() {
            if (!remainingEl) return;
            var left = MAX_TWEAKS - tweakAttempts;
            remainingEl.textContent =
              left > 0
                ? pt2('tweakRemaining')
                  ? PT2_ES.tweakRemaining(left)
                  : left + ' free adjustment' + (left === 1 ? '' : 's') + ' remaining'
                : '';
          }
          updateRemaining();

          function lockTweakSection() {
            clearInterval(phTimer);
            var sec = $('ttqTweakSection');
            if (!sec) return;
            sec.innerHTML =
              '<div class="ttq-tweak-prompt">' +
              (pt2('tweakLockedTitle') || '✨ Made it their own') +
              '</div>' +
              '<div class="ttq-tweak-locked">' +
              (pt2('tweakLockedSub') || "You've used your free adjustment.") +
              '</div>' +
              '<button type="button" class="ttq-primary" id="ttqToOutfit" style="margin-top:12px;">' +
              getToOutfitLabel() +
              '</button>';
            bindToOutfitBtn();
          }

          $('ttqTweakSubmit').addEventListener('click', function () {
            if (tweakAttempts >= MAX_TWEAKS) return;
            var text = (tweakInput.value || '').trim();
            if (!text) return;
            tweakAttempts++;
            updateRemaining();
            requestCharacter(text, function (success, imageUrl) {
              if (success) {
                tweakInput.value = '';
                customCharacterUrl = imageUrl;
              }
              if (tweakAttempts >= MAX_TWEAKS) lockTweakSection();
            });
          });
        }

        function resetAll() {
  saveGeneration++;
  pick = {
    gender: null,
    age: null,
    skin: null,
    ethnicity: null,
    eye: null,
    haircolor: null,
    hairstyle: null,
    outfit: null,
  };
          customCharacterUrl = null;
          pendingDetectedEntities = null;
          pendingEntityCode = null;
          pendingEntitySkin = null;
          var frameReset = document.querySelector('#ttCharbSaved .ttq-saved-frame');
          if (frameReset) frameReset.classList.remove('is-dressed');
                    revealWrap.style.display = 'none';
          savedWrap.style.display = 'none';
          if (entryLikenessWrap) entryLikenessWrap.style.display = '';
          form.style.display = 'none';
          var headerElReset = document.getElementById('ttCharBuilderHeader');
          if (headerElReset) headerElReset.style.display = '';
          si = 0;
          render();
        }

        function postCharacterSaveWithRetry(payload, maxAttempts) {
          maxAttempts = maxAttempts || 3;
          function attempt(n) {
            return fetch(WORKER_BASE + '/save-character', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
            })
              .then(function (r) {
                if (!r.ok) throw new Error('save-character HTTP ' + r.status);
                return r.json().catch(function () {
                  return {};
                });
              })
              .then(function (out) {
                if (out && out.ok === false) throw new Error(out.error || 'save-character returned ok:false');
                return out;
              })
              .catch(function (err) {
                if (n < maxAttempts) {
                  return new Promise(function (res) {
                    setTimeout(res, 900 * n);
                  }).then(function () {
                    return attempt(n + 1);
                  });
                }
                throw err;
              });
          }
          return attempt(1);
        }

                var ENTITY_CAROUSEL_STEPS_PERSON = [
          { key: 'gender', title: 'Gender', type: 'pills', options: ['Male', 'Female'] },
          { key: 'age', title: 'Age range', type: 'pills', options: ['0-2', '2-4', '5-9', '10-13', '14-19', '20-49', '50-59', '60-69', '70+'] },
          { key: 'body', title: 'Body type', type: 'pills', options: ['Slim', 'Average', 'Athletic', 'Heavyset'] },
          { key: 'skin', title: 'Skin tone', type: 'swatch' },
          { key: 'haircolor', title: 'Hair color', type: 'pills', options: ['Black', 'Brown', 'Blonde', 'Red', 'Gray', 'White', 'Bald / No hair'] },
          { key: 'hairlength', title: 'Hair length', type: 'pills', options: ['Short', 'Medium', 'Long'], skipIf: function (sel) { return sel.haircolor === 'Bald / No hair'; } },
              { key: 'ethnicity', title: 'Ethnicity', type: 'pills', options: ['White', 'Black', 'Hispanic', 'Asian', 'Mixed', 'Skip'] },
          { key: 'extra', title: 'Anything else?', type: 'text', placeholder: 'e.g. Curly red hair, glasses, beard, freckles, always wears a hat' },
        ];
               var ENTITY_CAROUSEL_STEPS_PET = [
          { key: 'species', title: 'What kind of pet?', type: 'pills', options: ['Dog', 'Cat', 'Horse', 'Other'] },
          { key: 'size', title: 'Size', type: 'pills', options: ['Small', 'Medium', 'Large'] },
          { key: 'furcolor', title: 'Fur color', type: 'pills', options: ['Black', 'White', 'Brown', 'Golden / Tan', 'Gray', 'Spotted / Mixed'] },
          { key: 'furlength', title: 'Fur length', type: 'pills', options: ['Short', 'Medium', 'Long'] },
          { key: 'extra', title: 'Anything else?', type: 'text', placeholder: 'e.g. breed, floppy ears, one blue eye, etcl' },
        ];
               var ENTITY_CAROUSEL_STEPS_HORSE = [
          { key: 'coatcolor', title: 'Coat color', type: 'pills', options: ['Chestnut', 'Bay', 'Black', 'Palomino', 'White / Gray', 'Brown', 'Spotted / Pinto'] },
          { key: 'manecolor', title: 'Mane & tail color', type: 'pills', options: ['Black', 'Brown', 'Blonde / Flaxen', 'White / Gray', 'Same as coat'] },
          { key: 'markings', title: 'Any markings?', type: 'pills', options: ['None', 'White blaze/stripe on face', 'White socks/legs', 'Spots'] },
          { key: 'extra', title: 'Anything else?', type: 'text', placeholder: 'e.g. long flowing mane, saddle and bridle, always has a red ribbon' },
        ];

        var ENTITY_SKIN_SWATCHES = [
  ['porcelain', 'Porcelain', '#F5DCC6'],
  ['fair', 'Fair', '#EAC29B'],
  ['light', 'Light', '#D9A876'],
  ['lightmedium', 'Light Medium', '#C08858'],
  ['medium', 'Medium', '#A36A42'],
  ['mediumdeep', 'Medium Deep', '#8B5A34'],
  ['deep', 'Deep', '#6B4226'],
  ['richdeep', 'Rich Deep', '#4A2C17'],
];

       function ageRangeToGroup(rangeStr) {
  var map = {
    '0-2': 'baby', '2-4': 'toddler', '5-9': 'young_child', '10-13': 'preteen', '14-19': 'teen',
    '20-49': 'adult', '50-59': 'senior50', '60-69': 'senior60', '70+': 'senior70plus',
  };
  return map[rangeStr] || '';
}

                   function compileEntityDescription(kind, sel) {
          if (kind === 'pet') {
            return {
              petType: sel.species || '',
              breed: [sel.size, sel.furlength ? sel.furlength + ' fur' : ''].filter(Boolean).join(', '),
              color: [sel.furcolor, sel.extra].filter(Boolean).join(' — '),
            };
          }
          if (kind === 'horse') {
            return {
              petType: 'horse',
              breed: sel.manecolor ? (sel.manecolor + ' mane and tail') : '',
              color: [sel.coatcolor, sel.markings && sel.markings !== 'None' ? sel.markings : '', sel.extra].filter(Boolean).join(' — '),
            };
          }
          var parts = [];
          if (sel.gender) parts.push(sel.gender);
          if (sel.age) parts.push('around ' + sel.age + ' years old');
          if (sel.body) parts.push(sel.body + ' build');
                   if (sel.skinHexLabel) parts.push(sel.skinHexLabel.toLowerCase() + ' skin tone (approximate reference color ' + (sel.skinHex || '') + ')');
          if (sel.haircolor === 'Bald / No hair') parts.push('bald / no hair');
          else if (sel.hairlength && sel.haircolor) parts.push(sel.hairlength.toLowerCase() + ' ' + sel.haircolor.toLowerCase() + ' hair');
              var desc = parts.join(', ');
    if (sel.extra) desc = sel.extra.trim().replace(/[.\s]+$/, '') + (desc ? '. ' + desc : '');
          return { description: desc, ageGroup: sel.age ? ageRangeToGroup(sel.age) : '' };
        }

        function ensureEntityModalStyles() {
          if (document.getElementById('ttEntityModalStyles')) return;
          var s = document.createElement('style');
          s.id = 'ttEntityModalStyles';
          s.textContent =
            '.tt-em-overlay{display:none;position:fixed;inset:0;background:rgba(2,6,23,.6);backdrop-filter:blur(8px);z-index:10050;align-items:center;justify-content:center;padding:16px;box-sizing:border-box}' +
            '.tt-em-box{width:100%;max-width:420px;max-height:85vh;overflow-y:auto;background:#fff;border-radius:22px;padding:26px 22px;box-shadow:0 24px 60px rgba(15,23,42,.2);position:relative;text-align:center}' +
            '.tt-em-close{position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:9px;border:1px solid rgba(15,23,42,.10);background:#fff;color:#0f172a;cursor:pointer;font-size:18px;line-height:1}' +
            '.tt-em-progress{height:4px;border-radius:999px;background:rgba(26,58,92,.08);overflow:hidden;max-width:260px;margin:4px auto 18px}' +
            '.tt-em-progress-fill{height:100%;background:linear-gradient(90deg,#4fa3d1,#f0b429);transition:width .3s ease}' +
            '.tt-em-title{font-family:\'Fraunces\',serif;font-weight:600;font-size:20px;color:#16324a;margin-bottom:16px}' +
            '.tt-em-pills{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-bottom:18px}' +
            '.tt-em-pill{padding:10px 16px;border-radius:999px;border:2px solid rgba(26,58,92,.12);background:#f8fbfd;font-family:\'Nunito\',sans-serif;font-size:13px;font-weight:800;color:#374151;cursor:pointer;transition:all .15s}' +
            '.tt-em-pill:hover{border-color:rgba(79,163,209,.5)}' +
            '.tt-em-pill.sel{border-color:#4fa3d1;background:#e8f4fb;color:#3c8ab3}' +
            '.tt-em-text{width:100%;min-height:70px;border-radius:12px;border:2px solid rgba(79,163,209,.25);padding:12px 14px;font-family:\'Nunito\',sans-serif;font-size:14px;margin-bottom:16px;resize:vertical}' +
            '.tt-em-nav{display:flex;gap:10px;justify-content:center}' +
            '.tt-em-back{background:none;border:none;color:#9aa5b1;font-weight:800;font-size:13px;cursor:pointer;padding:10px;visibility:hidden}' +
            '.tt-em-next{background:linear-gradient(135deg,#4fa3d1,#3c8ab3);color:#fff;border:none;border-radius:12px;padding:12px 26px;font-weight:900;font-size:14px;cursor:pointer}' +
            '.tt-em-next:disabled{opacity:.4;cursor:default}' +
            '.tt-em-consent-box{display:flex;align-items:flex-start;gap:10px;text-align:left;background:#f8fbfd;border:1px solid rgba(79,163,209,.2);border-radius:14px;padding:14px;margin:14px 0}';
          document.head.appendChild(s);
        }

              function openEntityCarousel(entityKey, entityKind, entityLabel, onComplete) {
          ensureEntityModalStyles();
                    var steps = entityKind === 'pet' ? ENTITY_CAROUSEL_STEPS_PET : entityKind === 'horse' ? ENTITY_CAROUSEL_STEPS_HORSE : ENTITY_CAROUSEL_STEPS_PERSON;
          var sel = {};
          var si2 = 0;
          var switchedToHorse = false;

              // Lock gender + valid ages for relationship slots (prevents "mom" built as a young boy)
    var SLOT_RULES = {
      mom:     { gender: 'Female', ages: ['20-49', '50-59', '60-69', '70+'] },
      dad:     { gender: 'Male',   ages: ['20-49', '50-59', '60-69', '70+'] },
      grandma: { gender: 'Female', ages: ['20-49', '50-59', '60-69', '70+'] },
      grandpa: { gender: 'Male',   ages: ['20-49', '50-59', '60-69', '70+'] },
      aunt:    { gender: 'Female' },
      uncle:   { gender: 'Male' },
      sister:  { gender: 'Female' },
      brother: { gender: 'Male' }
    };
    var slotRule = (entityKind !== 'pet' && entityKind !== 'horse') ? SLOT_RULES[String(entityKey || '').toLowerCase()] : null;
    if (slotRule) {
      if (slotRule.gender) sel.gender = slotRule.gender;
      steps = steps
        .filter(function (s) { return !(slotRule.gender && s.key === 'gender'); })
        .map(function (s) {
          if (s.key === 'age' && slotRule.ages) {
            return Object.assign({}, s, { options: s.options.filter(function (o) { return slotRule.ages.indexOf(o) !== -1; }) });
          }
          return s;
        });
    }

          var overlay = document.createElement('div');
          overlay.className = 'tt-em-overlay';
          overlay.style.display = 'flex';
          overlay.innerHTML = '<div class="tt-em-box"><button type="button" class="tt-em-close">×</button><div class="tt-em-progress"><div class="tt-em-progress-fill"></div></div><div class="tt-em-title"></div><div class="tt-em-body"></div><div class="tt-em-nav"><button type="button" class="tt-em-back">‹ Back</button><button type="button" class="tt-em-next">Next →</button></div></div>';
          document.body.appendChild(overlay);

          var fillEl = overlay.querySelector('.tt-em-progress-fill');
          var titleEl = overlay.querySelector('.tt-em-title');
          var bodyEl = overlay.querySelector('.tt-em-body');
          var backBtn = overlay.querySelector('.tt-em-back');
          var nextBtn = overlay.querySelector('.tt-em-next');
          var closeBtn = overlay.querySelector('.tt-em-close');

          function visibleSteps() {
            return steps.filter(function (st) { return !st.skipIf || !st.skipIf(sel); });
          }

          function render() {
            var vs = visibleSteps();
            if (si2 >= vs.length) si2 = vs.length - 1;
            var step = vs[si2];
            fillEl.style.width = Math.round(((si2 + 1) / vs.length) * 100) + '%';
            titleEl.textContent = (entityLabel ? entityLabel + ' — ' : '') + step.title;
            backBtn.style.visibility = si2 > 0 ? 'visible' : 'hidden';

                      if (step.type === 'text') {
              bodyEl.innerHTML = '<textarea class="tt-em-text" placeholder="' + escapeHtml(step.placeholder || '') + '">' + escapeHtml(sel[step.key] || '') + '</textarea>';
              nextBtn.disabled = false;
              nextBtn.textContent = si2 === vs.length - 1 ? 'Done ✓' : 'Next →';
              var ta = bodyEl.querySelector('textarea');
              ta.addEventListener('input', function () { sel[step.key] = ta.value; });
            } else if (step.type === 'swatch') {
              bodyEl.innerHTML = '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:6px;"></div>';
              var swGrid = bodyEl.firstChild;
              ENTITY_SKIN_SWATCHES.forEach(function (s) {
                var swEl = document.createElement('div');
                var isSel = sel[step.key] === s[0];
                swEl.style.cssText = 'cursor:pointer;text-align:center;';
                                               swEl.innerHTML =
                  '<div style="width:44px;height:44px;margin:0 auto;border-radius:50%;background-color:' + s[2] + ';border:' + (isSel ? '3px solid #4fa3d1' : '2px solid rgba(15,23,42,.1)') + ';box-shadow:' + (isSel ? '0 0 0 3px rgba(79,163,209,.25)' : '0 2px 6px rgba(0,0,0,.08)') + ';transition:all .15s;display:block;"></div>' +
                  '<div style="font-size:10.5px;font-weight:700;color:#374151;margin-top:5px;font-family:\'Nunito\',sans-serif;">' + s[1] + '</div>';
                               swEl.addEventListener('click', function () {
                  sel[step.key] = s[0];
                  sel[step.key + 'HexLabel'] = s[1];
                  sel[step.key + 'Hex'] = s[2];
                  nextBtn.disabled = false;
                  setTimeout(function () { goNext(); }, 220);
                });
                swGrid.appendChild(swEl);
              });
              nextBtn.disabled = !sel[step.key];
              nextBtn.textContent = si2 === vs.length - 1 ? 'Done ✓' : 'Next →';
            } else {
              var pillsHtml = step.options.map(function (opt) {
                return '<button type="button" class="tt-em-pill' + (sel[step.key] === opt ? ' sel' : '') + '" data-v="' + escapeHtml(opt) + '">' + escapeHtml(opt) + '</button>';
              }).join('');
              bodyEl.innerHTML = '<div class="tt-em-pills">' + pillsHtml + '</div>';
                    Array.prototype.forEach.call(bodyEl.querySelectorAll('.tt-em-pill'), function (btn) {
                btn.addEventListener('click', function () {
                  sel[step.key] = btn.dataset.v;
                  Array.prototype.forEach.call(bodyEl.querySelectorAll('.tt-em-pill'), function (b) { b.classList.remove('sel'); });
                  btn.classList.add('sel');
                  nextBtn.disabled = false;
                  if (step.key === 'species' && btn.dataset.v === 'Horse' && !switchedToHorse) {
                    switchedToHorse = true;
                    steps = ENTITY_CAROUSEL_STEPS_HORSE;
                    si2 = -1;
                  } else if (step.key === 'species' && btn.dataset.v !== 'Horse' && switchedToHorse) {
                    switchedToHorse = false;
                    steps = ENTITY_CAROUSEL_STEPS_PET;
                  }
                  setTimeout(function () { goNext(); }, 220);
                });
              });
              nextBtn.disabled = !sel[step.key];
              nextBtn.textContent = si2 === vs.length - 1 ? 'Done ✓' : 'Next →';
            }
          }

          function goNext() {
            var vs = visibleSteps();
            if (si2 < vs.length - 1) { si2++; render(); }
            else { overlay.remove(); onComplete(sel); }
          }
          function goBack() { if (si2 > 0) { si2--; render(); } }

          nextBtn.addEventListener('click', goNext);
          backBtn.addEventListener('click', goBack);
          closeBtn.addEventListener('click', function () { overlay.remove(); });
          overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });

          render();
        }

                function askEntityGender(entityLabel, onChosen) {
          ensureEntityModalStyles();
          var overlay = document.createElement('div');
          overlay.className = 'tt-em-overlay';
          overlay.style.display = 'flex';
          overlay.innerHTML =
            '<div class="tt-em-box">' +
            '<button type="button" class="tt-em-close">×</button>' +
            '<div class="tt-em-title">Is ' + escapeHtml(entityLabel || 'this person') + ' male or female?</div>' +
            '<div class="tt-em-pills">' +
            '<button type="button" class="tt-em-pill" data-v="female">Female</button>' +
            '<button type="button" class="tt-em-pill" data-v="male">Male</button>' +
            '</div></div>';
          document.body.appendChild(overlay);
          overlay.querySelector('.tt-em-close').addEventListener('click', function () { overlay.remove(); onChosen(''); });
          Array.prototype.forEach.call(overlay.querySelectorAll('[data-v]'), function (btn) {
            btn.addEventListener('click', function () {
              var val = btn.dataset.v;
              overlay.remove();
              onChosen(val);
            });
          });
        }

                       function askEntityAge(entityLabel, onChosen) {
          ensureEntityModalStyles();
                   var AGE_OPTIONS = [
            ['0-2', 'Baby'], ['2-4', 'Toddler'], ['5-9', 'Young child'],
            ['10-13', 'Preteen'], ['14-19', 'Teen'], ['20-49', 'Adult'],
            ['50-59', '50s'], ['60-69', '60s'], ['70+', '70+'],
          ];
          var overlay = document.createElement('div');
          overlay.className = 'tt-em-overlay';
          overlay.style.display = 'flex';
          overlay.innerHTML =
            '<div class="tt-em-box">' +
            '<button type="button" class="tt-em-close">×</button>' +
            '<div class="tt-em-title">How old is ' + escapeHtml(entityLabel || 'this person') + '?</div>' +
            '<div class="tt-em-pills">' +
            AGE_OPTIONS.map(function (o) { return '<button type="button" class="tt-em-pill" data-v="' + o[0] + '">' + o[1] + '</button>'; }).join('') +
            '</div></div>';
          document.body.appendChild(overlay);
          overlay.querySelector('.tt-em-close').addEventListener('click', function () { overlay.remove(); onChosen(''); });
          Array.prototype.forEach.call(overlay.querySelectorAll('[data-v]'), function (btn) {
            btn.addEventListener('click', function () {
              var val = btn.dataset.v;
              overlay.remove();
              onChosen(ageRangeToGroup(val));
            });
          });
        }

        // Combines gender + age into ONE screen instead of two sequential
        // full-screen modals — the two blocking questions before photo
        // upload were the actual source of overwhelm, not the consent step.
                function askEntityGenderAndAge(entityLabel, onChosen) {
          ensureEntityModalStyles();
          var AGE_OPTIONS = [
            ['0-2', 'Baby'], ['2-4', 'Toddler'], ['5-9', 'Young child'],
            ['10-13', 'Preteen'], ['14-19', 'Teen'], ['20-49', 'Adult'],
            ['50-59', '50s'], ['60-69', '60s'], ['70+', '70+'],
          ];
          var starName = String(window.ttChildName || '').trim() || 'your star';
          var sel = { gender: '', age: '', rel: '' };
          var overlay = document.createElement('div');
          overlay.className = 'tt-em-overlay';
          overlay.style.display = 'flex';
          overlay.innerHTML =
            '<div class="tt-em-box">' +
            '<button type="button" class="tt-em-close">×</button>' +
            '<div class="tt-em-title">Tell us about ' + escapeHtml(entityLabel || 'them') + '</div>' +
            '<div style="font-size:12px;font-weight:700;color:#9aa5b1;margin-bottom:8px;text-align:left;">Male or female?</div>' +
            '<div class="tt-em-pills">' +
            '<button type="button" class="tt-em-pill" data-g="female">Female</button>' +
            '<button type="button" class="tt-em-pill" data-g="male">Male</button>' +
            '</div>' +
            '<div style="font-size:12px;font-weight:700;color:#9aa5b1;margin:14px 0 8px;text-align:left;">About how old?</div>' +
            '<div class="tt-em-pills">' +
            AGE_OPTIONS.map(function (o) { return '<button type="button" class="tt-em-pill" data-a="' + o[0] + '">' + o[1] + '</button>'; }).join('') +
            '</div>' +
            '<div id="ttEmRelWrap" style="display:none;">' +
            '<div style="font-size:12px;font-weight:700;color:#9aa5b1;margin:14px 0 8px;text-align:left;">Compared to ' + escapeHtml(starName) + '?</div>' +
            '<div class="tt-em-pills">' +
            '<button type="button" class="tt-em-pill" data-r="younger">Younger &amp; smaller</button>' +
            '<button type="button" class="tt-em-pill" data-r="same">About the same</button>' +
            '<button type="button" class="tt-em-pill" data-r="older">Older &amp; bigger</button>' +
            '</div></div>' +
            '<button type="button" class="tt-em-next" id="ttEmGenderAgeContinue" style="width:100%;margin-top:16px;opacity:.5;cursor:not-allowed;" disabled>Continue →</button>' +
            '</div>';
          document.body.appendChild(overlay);

          var continueBtn = overlay.querySelector('#ttEmGenderAgeContinue');
          var relWrap = overlay.querySelector('#ttEmRelWrap');
          function needsRel() { return sel.age === '5-9'; }
          function checkReady() {
            var ready = !!sel.gender && !!sel.age && (!needsRel() || !!sel.rel);
            continueBtn.disabled = !ready;
            continueBtn.style.opacity = ready ? '1' : '.5';
            continueBtn.style.cursor = ready ? 'pointer' : 'not-allowed';
          }
          function pick(attr, key) {
            Array.prototype.forEach.call(overlay.querySelectorAll('[data-' + attr + ']'), function (btn) {
              btn.addEventListener('click', function () {
                sel[key] = btn.dataset[attr];
                Array.prototype.forEach.call(overlay.querySelectorAll('[data-' + attr + ']'), function (b) { b.classList.remove('sel'); });
                btn.classList.add('sel');
                if (key === 'age') {
                  relWrap.style.display = needsRel() ? 'block' : 'none';
                  if (!needsRel()) {
                    sel.rel = '';
                    Array.prototype.forEach.call(overlay.querySelectorAll('[data-r]'), function (b) { b.classList.remove('sel'); });
                  }
                }
                checkReady();
              });
            });
          }
          pick('g', 'gender');
          pick('a', 'age');
          pick('r', 'rel');
          overlay.querySelector('.tt-em-close').addEventListener('click', function () { overlay.remove(); onChosen('', ''); });
          continueBtn.addEventListener('click', function () {
            overlay.remove();
            var group = ageRangeToGroup(sel.age);
            if (group === 'young_child' && sel.rel === 'younger') group = 'young_child_younger';
            if (group === 'young_child' && sel.rel === 'older') group = 'young_child_older';
            onChosen(sel.gender, group);
          });
        }

                function askPetSpecies(entityLabel, onChosen) {
          ensureEntityModalStyles();
          var overlay = document.createElement('div');
          overlay.className = 'tt-em-overlay';
          overlay.style.display = 'flex';
          overlay.innerHTML =
            '<div class="tt-em-box">' +
            '<button type="button" class="tt-em-close">×</button>' +
            '<div class="tt-em-title">What kind of pet is ' + escapeHtml(entityLabel || 'this') + '?</div>' +
            '<div class="tt-em-pills">' +
            '<button type="button" class="tt-em-pill" data-v="dog">🐶 Dog</button>' +
            '<button type="button" class="tt-em-pill" data-v="cat">🐱 Cat</button>' +
            '<button type="button" class="tt-em-pill" data-v="horse">🐴 Horse</button>' +
            '<button type="button" class="tt-em-pill" data-v="other">🐾 Other</button>' +
            '</div></div>';
          document.body.appendChild(overlay);
          overlay.querySelector('.tt-em-close').addEventListener('click', function () { overlay.remove(); onChosen(''); });
          Array.prototype.forEach.call(overlay.querySelectorAll('[data-v]'), function (btn) {
            btn.addEventListener('click', function () {
              var val = btn.dataset.v;
              overlay.remove();
              onChosen(val);
            });
          });
        }

               function openEntityPhotoConsent(entityLabel, onAuthorized, onDeclined) {
          // One-time consent for ALL additional-character photo uploads this
          // session — grandma, the dog, a cousin, etc. never re-prompted once
          // given. This is separate from the main character's own consent
          // (ttConsentModal), which stays its own one-time gate untouched.
          if (window.ttEntityPhotoConsentGiven) {
            onAuthorized();
            return;
          }
          ensureEntityModalStyles();
          var overlay = document.createElement('div');
          overlay.className = 'tt-em-overlay';
          overlay.style.display = 'flex';
                            overlay.innerHTML =
            '<div class="tt-em-box" style="text-align:left">' +
            '<button type="button" class="tt-em-close" style="position:absolute;top:12px;right:12px;">×</button>' +
            '<div class="tt-em-title" style="text-align:center">📸 Uploading photos of family, friends, or pets</div>' +
            '<div style="text-align:center;font-size:12px;font-weight:800;color:#b8860b;background:#fff8ea;border:1px solid rgba(240,180,41,.35);border-radius:10px;padding:8px 12px;margin-bottom:14px;">You get 1 upload plus 1 retry per photo — pick a clear one if you can!</div>' +
            '<div class="tt-em-consent-box">' +
            '<input type="checkbox" id="ttEmConsentCheck" style="width:19px;height:19px;margin-top:2px;flex-shrink:0;accent-color:#4fa3d1;">' +
            '<label for="ttEmConsentCheck" style="font-size:13px;font-weight:700;color:#374151;line-height:1.5;cursor:pointer;">I confirm that I have permission for every photo I upload in this section and authorize TinyTunes to use each person\'s or pet\'s photo and likeness to create an animated character. I\'ve read the <a href="/pages/photo-likeness-biometric-privacy-notice" target="_blank" style="color:#4fa3d1;">Photo Likeness &amp; Biometric Privacy Notice</a>. This covers every photo I add here — I won\'t be asked again.</label>' +
            '</div>' +
            '<button type="button" class="tt-em-next" id="ttEmConsentContinue" style="width:100%;opacity:.5;cursor:not-allowed;" disabled>Continue to Upload Photo</button>' +
            '<button type="button" id="ttEmConsentDecline" style="display:block;margin:14px auto 0;background:none;border:none;color:#9aa5b1;text-decoration:underline;font-size:12px;font-weight:700;cursor:pointer;text-align:center;width:100%;">I can\'t authorize this — describe them with words instead</button>' +
            '</div>';
          document.body.appendChild(overlay);

          var checkEl = overlay.querySelector('#ttEmConsentCheck');
          var continueBtn = overlay.querySelector('#ttEmConsentContinue');
          var declineBtn = overlay.querySelector('#ttEmConsentDecline');
          var closeBtn = overlay.querySelector('.tt-em-close');

          checkEl.addEventListener('change', function () {
            continueBtn.disabled = !checkEl.checked;
            continueBtn.style.opacity = checkEl.checked ? '1' : '.5';
            continueBtn.style.cursor = checkEl.checked ? 'pointer' : 'not-allowed';
          });
          continueBtn.addEventListener('click', function () {
            window.ttEntityPhotoConsentGiven = true;
            overlay.remove();
            onAuthorized();
          });
          declineBtn.addEventListener('click', function () { overlay.remove(); onDeclined(); });
          closeBtn.addEventListener('click', function () { overlay.remove(); });
        }
                        function uploadEntityPhotoFile(entityKey, entityKind, entityLabel, codeForSave, file, statusEl, ageGroup, gender, species, onSuccess) {
          statusEl.innerHTML = '<span class="ttq-loading-dot"></span> Preparing photo…';
          readAndResizeImageFile(file, 1600, 0.85, function (dataUrl) {
            statusEl.innerHTML = '<span class="ttq-loading-dot"></span> Creating their character…';
            fetch(WORKER_BASE + '/upload-entity-photo', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                code: codeForSave, entity_key: entityKey, entity_label: entityLabel,
                kind: entityKind, photo: dataUrl, consent_confirmed: true,
                age_group: ageGroup || '', gender: gender || '', species: species || '',
              }),
            })
              .then(function (r) { return r.json().catch(function () { return {}; }); })
                           .then(function (out) {
                if (out && out.ok) {
                  if (typeof onSuccess === 'function') onSuccess(out.imageUrl || '');
                  else statusEl.innerHTML = '<div style="font-size:12.5px;font-weight:800;color:#16a34a;">✓ Photo added — ' + escapeHtml(entityLabel) + ' will appear in the video</div>';
                } else {
                  var remaining = typeof out?.attemptsRemaining === 'number' ? out.attemptsRemaining : null;
                  var errMsg = escapeHtml((out && out.error) || "Couldn't upload — please try again.");
                  if (remaining === 0) errMsg += ' No more retries for this photo — this is the version we\'ll use.';
                  else if (remaining === 1) errMsg += ' You have 1 more try for this photo.';
                  statusEl.innerHTML = '<div style="font-size:12.5px;font-weight:700;color:#b42318;">' + errMsg + '</div>';
                }
              })
              .catch(function () {
                statusEl.innerHTML = '<div style="font-size:12.5px;font-weight:700;color:#b42318;">Something went wrong — please try again.</div>';
              });
          }, function () {
            statusEl.innerHTML = '<div style="font-size:12.5px;font-weight:700;color:#b42318;">Couldn\'t read that photo — please try a different one.</div>';
          });
        }

                    function collapseEntityCard(card, label, kind, onCollapsed) {
          var msg = escapeHtml(label) + ' is ready for show time!';
          var startHeight = card.scrollHeight;
          card.style.overflow = 'hidden';
          card.style.maxHeight = startHeight + 'px';
          card.style.transition = 'max-height .4s ease, padding .4s ease, margin .4s ease';
          void card.offsetHeight; // force reflow so the transition actually animates from startHeight
          card.innerHTML =
            '<div style="display:flex;align-items:center;gap:10px;">' +
              '<div style="flex-shrink:0;width:30px;height:30px;border-radius:50%;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:16px;color:#16a34a;">✓</div>' +
              '<div style="font-family:\'Nunito\',sans-serif;font-weight:800;font-size:13.5px;color:#16324a;line-height:1.35;">' + msg + '</div>' +
            '</div>';
                  requestAnimationFrame(function () {
            var endHeight = card.scrollHeight;
            card.style.maxHeight = endHeight + 'px';
            setTimeout(function () { card.style.maxHeight = 'none'; }, 420);
          });
          if (typeof onCollapsed === 'function') onCollapsed();
        }

         function renderEntityPromptOld(container, afterEl, entities, codeForSave, mainSkinToken) {
          if (!entities || !entities.length) return;

          var wrap = document.createElement('div');
          wrap.id = 'ttEntityPrompt';
          wrap.style.cssText =
            'position:relative;margin:20px 0 4px;padding:24px 18px 20px;border-radius:22px;' +
            'background:linear-gradient(135deg,#f9c846,#f0a800);box-shadow:0 12px 28px rgba(240,168,0,.28);';
              wrap.innerHTML =
      '<div style="position:absolute;top:-13px;left:18px;background:linear-gradient(135deg,#111827,#2d3748);color:#fff;font-size:11px;font-weight:900;letter-spacing:.05em;padding:6px 16px;border-radius:999px;box-shadow:0 6px 14px rgba(0,0,0,.3);">🎬 BONUS FEATURE — INCLUDED FREE</div>' +
           '<div style="position:absolute;top:-24px;right:12px;transform:rotate(9deg);width:76px;height:76px;border-radius:50%;background:radial-gradient(circle at 35% 30%,#fff7d6,#ffd93d 55%,#f0a800 100%);box-shadow:0 8px 18px rgba(0,0,0,.32),0 0 0 3px #fff,0 0 0 5px #e0a000;display:flex;flex-direction:column;align-items:center;justify-content:center;font-family:\'Nunito\',sans-serif;z-index:5;text-align:center;">' +
        '<span style="font-size:9px;font-weight:900;color:#7a4b00;letter-spacing:.02em;line-height:1;">$10 VALUE</span>' +
        '<span style="font-size:13px;font-weight:950;color:#5c2e00;line-height:1.15;margin-top:2px;">INCLUDED<br>FREE</span>' +
        '<span style="font-size:8px;font-weight:900;color:#7a4b00;letter-spacing:.02em;line-height:1;margin-top:2px;">LIMITED TIME</span>' +
      '</div>' +
            '<div style="text-align:center;color:#111827;font-family:\'Fraunces\',serif;font-weight:600;font-size:20px;margin-bottom:6px;">Cast the rest of the family in their movie</div>' +
            '<div style="text-align:center;color:rgba(17,24,39,.75);font-family:\'Nunito\',sans-serif;font-size:13px;font-weight:700;margin-bottom:18px;">We spotted more characters in the lyrics — bring them to life, free with your video</div>' +
            '<div id="ttEntityCards" style="display:grid;gap:12px;"></div>' +
            '<button type="button" id="ttEntityDoneBtn" style="display:block;margin:16px auto 0;background:#111827;color:#fff;font-family:\'Nunito\',sans-serif;font-size:13px;font-weight:900;padding:11px 24px;border-radius:999px;border:none;cursor:pointer;">Continue →</button>';

                    if (afterEl && afterEl.nextSibling) container.insertBefore(wrap, afterEl.nextSibling);
          else container.appendChild(wrap);

          var cardsWrap = wrap.querySelector('#ttEntityCards');
          var doneBtnEl = wrap.querySelector('#ttEntityDoneBtn');
          var pendingLabels = entities.map(function (e) { return e.label; });

          function updateDoneBtnLabel() {
            if (!doneBtnEl) return;
            if (!pendingLabels.length) {
              doneBtnEl.textContent = 'Continue →';
              return;
            }
            if (pendingLabels.length === 1) {
              doneBtnEl.textContent = 'Continue without ' + pendingLabels[0] + ' →';
              return;
            }
            if (pendingLabels.length === 2) {
              doneBtnEl.textContent = 'Continue without ' + pendingLabels[0] + ' & ' + pendingLabels[1] + ' →';
              return;
            }
            doneBtnEl.textContent = 'Continue without ' + pendingLabels.length + ' characters →';
          }
          updateDoneBtnLabel();

          entities.forEach(function (e) {
            var isPet = e.kind === 'pet';
            var isUnknownKind = e.kind === 'unknown';
            var resolvedKind = isPet ? 'pet' : (isUnknownKind ? null : 'person');

            var card = document.createElement('div');
            card.style.cssText = 'background:#fff;border-radius:14px;padding:14px 16px;';
            card.dataset.key = e.key;

                         var kindPicker = isUnknownKind
              ? '<div class="tt-em-pills" style="margin-bottom:10px;justify-content:flex-start;"><button type="button" class="tt-em-pill" data-kind="person">🧑 Person</button><button type="button" class="tt-em-pill" data-kind="pet">🐾 Pet</button></div>'
              : '';

                        var mainUsedPhotoLikeness = window.ttCharacterMode === 'photo_likeness';
            var photoBtnHtml = mainUsedPhotoLikeness
              ? '<button type="button" class="ttEntityPhotoBtn" style="flex:1;min-width:140px;background:#f8fbfd;border:2px solid rgba(240,180,41,.4);border-radius:12px;padding:12px;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:13px;color:#b8860b;cursor:pointer;">📸 Upload their photo</button>'
              : '';

            card.innerHTML =
              '<div style="font-weight:900;font-size:15px;color:#16324a;margin-bottom:10px;">' + escapeHtml(e.label) + (isPet ? ' 🐾' : '') + '</div>' +
              kindPicker +
              '<div style="display:flex;gap:10px;flex-wrap:wrap;">' +
              '<button type="button" class="ttEntityTextBtn" style="flex:1;min-width:140px;background:#f8fbfd;border:2px solid rgba(79,163,209,.3);border-radius:12px;padding:12px;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:13px;color:#3c8ab3;cursor:pointer;">✍️ Describe with words</button>' +
              photoBtnHtml +
              '</div>' +
              '<div class="ttEntityStatus" style="margin-top:10px;font-size:12.5px;font-weight:700;color:#7c8a99;"></div>' +
              '<input type="file" accept="image/*" class="ttEntityFileInput" style="display:none;">';

            var statusEl = card.querySelector('.ttEntityStatus');
            var fileInput = card.querySelector('.ttEntityFileInput');

            if (isUnknownKind) {
              ensureEntityModalStyles();
              Array.prototype.forEach.call(card.querySelectorAll('[data-kind]'), function (btn) {
                btn.addEventListener('click', function () {
                  resolvedKind = btn.dataset.kind;
                  Array.prototype.forEach.call(card.querySelectorAll('[data-kind]'), function (b) { b.classList.remove('sel'); });
                  btn.classList.add('sel');
                });
              });
            }

                   function saveTextDescription(sel) {
              var finalKind = (sel && sel.species === 'Horse') ? 'horse' : (resolvedKind || 'person');
              var compiled = compileEntityDescription(finalKind, sel);
              var payloadDesc = Object.assign({ key: e.key, kind: finalKind }, compiled);
              statusEl.innerHTML = '<span class="ttq-loading-dot"></span> Saving…';
              fetch(WORKER_BASE + '/save-entity-descriptions', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code: codeForSave, descriptions: [payloadDesc] }),
              })
                            .then(function () {
                  collapseEntityCard(card, e.label, 'text', function () {
                    var idx = pendingLabels.indexOf(e.label);
                    if (idx !== -1) pendingLabels.splice(idx, 1);
                    updateDoneBtnLabel();
                  });
                })
                .catch(function () {
                  statusEl.innerHTML = '<div style="font-size:12.5px;font-weight:700;color:#b42318;">Couldn\'t save — try again</div>';
                });
            }

                        card.querySelector('.ttEntityTextBtn').addEventListener('click', function () {
              if (isUnknownKind && !resolvedKind) { statusEl.innerHTML = '<strong>Pick person or pet first ↑</strong>'; return; }
              openEntityCarousel(e.key, resolvedKind || 'person', e.label, saveTextDescription);
            });

                       var photoBtnEl = card.querySelector('.ttEntityPhotoBtn');
            if (photoBtnEl) {
                           photoBtnEl.addEventListener('click', function () {
                if (isUnknownKind && !resolvedKind) { statusEl.innerHTML = '<strong>Pick person or pet first ↑</strong>'; return; }
                              function proceedToConsent(ageGroup, gender) {
                  fileInput.dataset.ageGroup = ageGroup || '';
                  fileInput.dataset.gender = gender || '';
                  openEntityPhotoConsent(e.label,
                    function onAuthorized() { fileInput.click(); },
                    function onDeclined() { openEntityCarousel(e.key, resolvedKind || 'person', e.label, saveTextDescription); }
                  );
                }
                                                          if ((resolvedKind || 'person') === 'pet' || (resolvedKind || 'person') === 'horse') {
                  askPetSpecies(e.label, function (species) {
                    fileInput.dataset.species = species || '';
                    proceedToConsent('', '');
                  });
                } else {
                  askEntityGenderAndAge(e.label, function (gender, ageGroup) { proceedToConsent(ageGroup, gender); });
                }
              });
            }

                       fileInput.addEventListener('change', function () {
              var file = fileInput.files && fileInput.files[0];
              if (!file) return;
                         uploadEntityPhotoFile(e.key, resolvedKind || 'person', e.label, codeForSave, file, statusEl, fileInput.dataset.ageGroup || '', fileInput.dataset.gender || '', fileInput.dataset.species || '', function () {
                collapseEntityCard(card, e.label, 'photo', function () {
                  var idx = pendingLabels.indexOf(e.label);
                  if (idx !== -1) pendingLabels.splice(idx, 1);
                  updateDoneBtnLabel();
                });
              });
            });

            cardsWrap.appendChild(card);
          });

          wrap.querySelector('#ttEntityDoneBtn').addEventListener('click', function () {
            var loadingHtml =
              '<div style="text-align:center;padding:50px 20px;">' +
              '<div style="width:44px;height:44px;margin:0 auto 18px;border-radius:50%;border:4px solid rgba(240,180,41,.25);border-top-color:#f0b429;animation:ttSpin .8s linear infinite;"></div>' +
              '<div style="font-family:\'Fraunces\',serif;font-weight:600;font-size:18px;color:#16324a;">Bringing their characters to life…</div>' +
              '</div>';
            wrap.innerHTML = loadingHtml;

            fetch(WORKER_BASE + '/generate-entity-previews', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ code: codeForSave, entities: entities.map(function (e) { return { key: e.key, label: e.label, kind: e.kind }; }) }),
            })
              .then(function (r) { return r.json().catch(function () { return {}; }); })
              .then(function (out) {
                if (out && out.ok && out.entities && out.entities.length) {
                  renderEntityRevealCarousel(wrap, out.entities);
                } else {
                  wrap.remove();
                  try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
                }
              })
              .catch(function () {
                wrap.remove();
                try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
              });
          });
        }

        // ============ INLINE CAST EDITOR (replaces the pop-up chain) ============
        var TT_FEMALE_RE = /\b(grand ?ma|grandmother|nana|nanna|memaw|mamaw|meemaw|mimi|gigi|granny|gran|mom|mommy|mother|mama|aunt|auntie|aunty|tia|sister|sis|niece|daughter|wife)\b/i;
        var TT_MALE_RE = /\b(grand ?pa|grandfather|papa|pawpaw|poppy|pop|pops|grandad|granddad|dad|daddy|father|uncle|tio|brother|bro|nephew|son|husband)\b/i;
        var TT_ADULT_RE = /\b(grand ?ma|grandmother|nana|nanna|memaw|mamaw|meemaw|mimi|gigi|granny|gran|grand ?pa|grandfather|papa|pawpaw|poppy|grandad|granddad|mom|mommy|mother|mama|dad|daddy|father|aunt|auntie|aunty|uncle|tia|tio)\b/i;
        var TTIC_AGES = [['0-2', 'Baby'], ['2-4', 'Toddler'], ['5-9', 'Kid'], ['10-13', 'Preteen'], ['14-19', 'Teen'], ['20-49', 'Adult'], ['50-59', '50s'], ['60-69', '60s'], ['70+', '70+']];
        var TTIC_ADULT_AGES = ['20-49', '50-59', '60-69', '70+'];

        function ttGuessGender(label) {
          var s = String(label || '');
          if (TT_FEMALE_RE.test(s)) return 'Female';
          if (TT_MALE_RE.test(s)) return 'Male';
          return '';
        }

        function ensureInlineCastStyles() {
          if (document.getElementById('ttInlineCastStyles')) return;
          var s = document.createElement('style');
          s.id = 'ttInlineCastStyles';
          s.textContent =
            '.ttic-section{position:relative;margin:24px 0 8px;padding:26px 16px 16px;border-radius:22px;background:linear-gradient(180deg,#fffdf7,#fff6e3);border:1.5px solid rgba(240,180,41,.4);box-shadow:0 12px 30px rgba(240,168,0,.14);scroll-margin-top:16px}' +
            '.ttic-badge{position:absolute;top:-12px;left:16px;background:#111827;color:#fff;font-family:Nunito,sans-serif;font-size:10.5px;font-weight:900;letter-spacing:.06em;padding:6px 14px;border-radius:999px}' +
            '.ttic-title{font-family:Fraunces,serif;font-weight:600;font-size:21px;color:#16324a;text-align:center}' +
            '.ttic-sub{font-family:Nunito,sans-serif;font-size:13px;font-weight:700;line-height:1.45;color:#6b7280;text-align:center;margin:4px 0 8px}' +
            '.ttic-progress{text-align:center;font-family:Nunito,sans-serif;font-size:12px;font-weight:900;color:#b8860b;margin-bottom:12px}' +
            '.ttic-cards{display:grid;gap:10px}' +
            '.ttic-card{background:#fff;border:1.5px solid rgba(26,58,92,.1);border-radius:16px;padding:14px;text-align:left}' +
            '.ttic-card.is-done{border-color:rgba(22,163,74,.35);background:#f7fdf9}' +
            '.ttic-head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:10px}' +
            '.ttic-name{font-family:Nunito,sans-serif;font-size:16px;font-weight:900;color:#16324a}' +
            '.ttic-actions{display:flex;gap:8px}' +
            '.ttic-btn{flex:1;border:none;border-radius:12px;padding:13px 10px;font-family:Nunito,sans-serif;font-size:14px;font-weight:900;cursor:pointer}' +
            '.ttic-photo{background:linear-gradient(135deg,#f9c846,#f0a800);color:#111827}' +
            '.ttic-desc{background:#e8f4fb;color:#3c8ab3}' +
            '.ttic-q{font-family:Nunito,sans-serif;font-size:12px;font-weight:800;color:#7c8a99;margin:12px 0 6px}' +
            '.ttic-chips{display:flex;flex-wrap:wrap;gap:6px}' +
            '.ttic-chip{border:1.5px solid rgba(26,58,92,.14);background:#f8fbfd;border-radius:999px;padding:8px 12px;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;color:#374151;cursor:pointer}' +
            '.ttic-chip.sel{border-color:#4fa3d1;background:#e8f4fb;color:#3c8ab3}' +
            '.ttic-sw{width:34px;height:34px;border-radius:50%;border:2px solid rgba(15,23,42,.1);cursor:pointer;padding:0}' +
            '.ttic-sw.sel{border:3px solid #4fa3d1;box-shadow:0 0 0 3px rgba(79,163,209,.25)}' +
            '.ttic-text{width:100%;min-height:54px;border-radius:12px;border:1.5px solid rgba(79,163,209,.3);padding:10px 12px;font-family:Nunito,sans-serif;font-size:14px;box-sizing:border-box;resize:vertical}' +
            '.ttic-save{width:100%;margin-top:14px;border:none;border-radius:12px;padding:14px;background:linear-gradient(135deg,#4fa3d1,#3c8ab3);color:#fff;font-family:Nunito,sans-serif;font-size:15px;font-weight:900;cursor:pointer}' +
            '.ttic-save:disabled{opacity:.45;cursor:default}' +
            '.ttic-link{background:none;border:none;color:#9aa5b1;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;text-decoration:underline;cursor:pointer;padding:4px}' +
            '.ttic-consent{display:flex;gap:8px;align-items:flex-start;background:#f8fbfd;border:1px solid rgba(79,163,209,.2);border-radius:12px;padding:10px;font-family:Nunito,sans-serif;font-size:12px;font-weight:700;line-height:1.45;color:#374151;margin-bottom:4px}' +
            '.ttic-filebtn{display:block;text-align:center;margin-top:14px;border-radius:12px;padding:14px;background:linear-gradient(135deg,#f9c846,#f0a800);color:#111827;font-family:Nunito,sans-serif;font-size:15px;font-weight:900;cursor:pointer}' +
            '.ttic-filebtn.off{opacity:.45;pointer-events:none}' +
            '.ttic-preview{display:block;width:140px;height:140px;object-fit:cover;border-radius:50%;border:4px solid #f0b429;margin:6px auto 10px}' +
            '.ttic-done{display:flex;align-items:center;gap:10px}' +
            '.ttic-done img{width:46px;height:46px;border-radius:50%;object-fit:cover;object-position:center 15%;border:2px solid #16a34a}' +
            '.ttic-done-ico{width:46px;height:46px;border-radius:50%;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0}' +
            '.ttic-done-text{flex:1;font-family:Nunito,sans-serif;font-size:13px;font-weight:800;line-height:1.35;color:#16324a}' +
            '.ttic-check{color:#16a34a;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:900}' +
            '.ttic-status{margin-top:8px;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:700;color:#7c8a99;text-align:center}' +
            '.ttic-footer{position:sticky;bottom:0;margin:14px -16px -16px;padding:12px 16px calc(12px + env(safe-area-inset-bottom,0px));background:linear-gradient(to top,#fff6e3 70%,rgba(255,246,227,0));border-radius:0 0 22px 22px;text-align:center;z-index:2}' +
            '.ttic-continue{width:100%;border:none;border-radius:14px;padding:15px;background:#111827;color:#fff;font-family:Nunito,sans-serif;font-size:15px;font-weight:900;cursor:pointer}' +
            '.ttic-skip{margin-top:6px;background:none;border:none;color:#9aa5b1;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;text-decoration:underline;cursor:pointer}' +
            '.ttic-toast{position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:10070;background:#111827;color:#fff;font-family:Nunito,sans-serif;font-size:13px;font-weight:900;padding:10px 16px;border-radius:999px;box-shadow:0 10px 24px rgba(0,0,0,.25);transition:opacity .4s}';
          document.head.appendChild(s);
        }

              function ttShowFamilyTip(entities) {
          if (window.ttBuildingForMovie) return; // family is added in the reveal now
          if (window.ttFamilyTipShown) return;
          window.ttFamilyTipShown = true;
          var anchor = document.getElementById('ttCharBuilder');
          if (!anchor || !anchor.parentNode) return;
          var es = ttLang2 === 'es';
          var star = titleName() || '';
          var names = (entities || []).map(function (e) { return String(e.label || '').trim(); }).filter(Boolean).slice(0, 4);
          var who = names.length
            ? (names.length === 1 ? names[0] : names.slice(0, -1).join(', ') + (es ? ' y ' : ' & ') + names[names.length - 1])
            : '';

          // Their character image: saved URL first, then the builder's saved image
          var img = window.savedCharacterUrl || '';
          if (!img || /UPLOAD_PHOTO_LATER/.test(img)) {
            var si = document.getElementById('ttCharbSavedImg');
            img = si && si.src && !/UPLOAD_PHOTO_LATER/.test(si.src) ? si.src : '';
          }

          if (!document.getElementById('ttReadyCardStyles')) {
            var st = document.createElement('style');
            st.id = 'ttReadyCardStyles';
            st.textContent = [
              '#ttCastNotice{position:relative;overflow:hidden;margin:18px 0 20px;padding:22px 22px 24px;border-radius:24px;pointer-events:auto;cursor:default;user-select:none;-webkit-tap-highlight-color:transparent;scroll-margin-top:16px;',
              'background:radial-gradient(120% 90% at 0% 0%,rgba(240,180,41,.18),transparent 55%),linear-gradient(160deg,#16243d 0%,#0f1a2e 100%);',
              'border:1.5px solid rgba(240,180,41,.55);box-shadow:0 0 0 5px rgba(240,180,41,.08),0 22px 50px rgba(15,26,46,.35);',
              'opacity:0;transform:translateY(10px) scale(.98);transition:opacity .45s ease,transform .45s cubic-bezier(.22,1,.36,1)}',
              '#ttCastNotice.on{opacity:1;transform:none}',
              '.ttrc-row{display:flex;align-items:center;gap:20px}',
              '.ttrc-portrait{position:relative;flex-shrink:0;width:104px;height:128px;border-radius:18px;padding:3px;background:linear-gradient(140deg,#fff3d0,#e9b949 45%,#b8860b)}',
              '.ttrc-portrait-in{width:100%;height:100%;border-radius:15px;overflow:hidden;background:#eef3f8;display:flex;align-items:center;justify-content:center;font-size:40px}',
              '.ttrc-portrait-in img{width:100%;height:100%;object-fit:cover;object-position:center 15%;display:block}',
              '.ttrc-check{position:absolute;right:-8px;bottom:-8px;width:30px;height:30px;border-radius:50%;background:#16a34a;color:#fff;font-family:Nunito,sans-serif;font-size:16px;font-weight:900;display:flex;align-items:center;justify-content:center;border:3px solid #0f1a2e;box-shadow:0 4px 10px rgba(0,0,0,.3)}',
              '.ttrc-text{flex:1;min-width:0}',
              '.ttrc-eyebrow{font-family:Nunito,sans-serif;font-size:11px;font-weight:900;letter-spacing:.18em;color:#f0c75e;margin-bottom:6px}',
              '.ttrc-title{font-family:Fraunces,Georgia,serif;font-weight:600;font-size:clamp(20px,5vw,24px);line-height:1.2;color:#fff;margin-bottom:10px}',
                '.ttrc-next{font-family:Nunito,sans-serif;font-size:14.5px;font-weight:900;color:#fff3d0;line-height:1.45}',
              '.ttrc-cast{display:flex;gap:8px;margin-top:10px;flex-wrap:wrap}',
              '.ttrc-chip{display:flex;align-items:center;gap:7px;padding:4px 12px 4px 4px;border-radius:999px;background:rgba(255,255,255,.06);border:1px solid rgba(240,180,41,.3)}',
              '.ttrc-av{width:26px;height:26px;border-radius:50%;border:1.5px dashed #f0c75e;color:#f0c75e;font-family:Nunito,sans-serif;font-size:12px;font-weight:900;display:flex;align-items:center;justify-content:center}',
              '.ttrc-nm{font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;color:#fff}',
              '.ttrc-bar{position:absolute;left:0;right:0;bottom:0;height:3px;background:rgba(240,180,41,.15)}',
               '.ttrc-bar span{display:block;height:100%;width:100%;background:linear-gradient(90deg,#f0c75e,#e9b949);animation:ttrcBar 8s linear forwards}',
              '@keyframes ttrcBar{from{width:100%}to{width:0}}',
                  '.ttrc-spark{position:absolute;color:#f0c75e;font-size:12px;opacity:.7}',
              '#ttCastNotice.shake{animation:ttrcShake .45s ease}',
              '@keyframes ttrcShake{0%,100%{transform:translateX(0)}20%{transform:translateX(-7px)}40%{transform:translateX(7px)}60%{transform:translateX(-5px)}80%{transform:translateX(5px)}}',
              '.ttrc-toast{position:absolute;left:50%;top:50%;z-index:5;width:max-content;max-width:88%;transform:translate(-50%,-40%);background:linear-gradient(135deg,#fff3d0,#f0c75e);color:#3a2400;font-family:Nunito,sans-serif;font-size:15px;font-weight:900;line-height:1.35;text-align:center;padding:12px 18px;border-radius:14px;box-shadow:0 12px 30px rgba(0,0,0,.4);opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none}',
              '.ttrc-toast.on{opacity:1;transform:translate(-50%,-50%)}',
              '@media (max-width:440px){.ttrc-row{flex-direction:column;text-align:center;gap:16px}.ttrc-cast{justify-content:center}}',
              '@media (prefers-reduced-motion:reduce){#ttCastNotice{transition:none}.ttrc-bar span{animation:none}}',
            ].join('');
            document.head.appendChild(st);
          }

          var title = es
            ? (star ? '¡' + star + ' está listo/a para su gran momento!' : '¡Listo/a para su gran momento!')
            : (star ? star + ' is ready for the big screen!' : 'Ready for the big screen!');
          var next = who
            ? (es ? '🎬 Agrega después de comprar:' : '🎬 Add after checkout:')
            : (es ? 'Su película está lista para filmarse 🎬' : 'Their movie is ready to be made 🎬');

          var card = document.createElement('div');
          card.id = 'ttCastNotice'; // the approval code already scrolls to this id
          card.setAttribute('role', 'status');
          card.innerHTML =
            '<span class="ttrc-spark" style="top:12px;right:18px;">✦</span>' +
            '<span class="ttrc-spark" style="bottom:18px;right:40%;font-size:9px;">✦</span>' +
            '<div class="ttrc-row">' +
              '<div class="ttrc-portrait"><div class="ttrc-portrait-in">' +
                (img ? '<img src="' + img + '" alt="">' : '⭐') +
              '</div><div class="ttrc-check">✓</div></div>' +
              '<div class="ttrc-text">' +
                '<div class="ttrc-eyebrow">' + (es ? '✓ PERSONAJE CONFIRMADO' : '✓ CAST CONFIRMED') + '</div>' +
                '<div class="ttrc-title">' + escapeHtml(title) + '</div>' +
                '<div class="ttrc-next">' + escapeHtml(next) + '</div>' +
                (names.length
                  ? '<div class="ttrc-cast">' + names.map(function (n) {
                      return '<div class="ttrc-chip"><div class="ttrc-av">' + escapeHtml(n.charAt(0).toUpperCase()) + '</div><span class="ttrc-nm">' + escapeHtml(n) + '</span></div>';
                    }).join('') + '</div>'
                  : '') +
              '</div>' +
            '</div>' +
            '<div class="ttrc-bar"><span></span></div>';
          anchor.parentNode.insertBefore(card, anchor);
          requestAnimationFrame(function () { card.classList.add('on'); });

          // Tapped it? Shake + a quick reminder that family is added after checkout
          if (who) {
            card.addEventListener('click', function () {
              card.classList.remove('shake');
              void card.offsetWidth; // restart the shake on every tap
              card.classList.add('shake');
              var old = card.querySelector('.ttrc-toast');
              if (old) old.remove();
              var tip = document.createElement('div');
              tip.className = 'ttrc-toast';
              tip.textContent = es ? '🎬 Agrega a ' + who + ' después de comprar' : '🎬 Add ' + who + ' after checkout';
              card.appendChild(tip);
              requestAnimationFrame(function () { tip.classList.add('on'); });
              setTimeout(function () {
                tip.classList.remove('on');
                setTimeout(function () { tip.remove(); }, 300);
              }, 3000);
            });
          }

          setTimeout(function () {
            card.classList.remove('on');
            setTimeout(function () { card.remove(); ttScrollToPlayer(); }, 450);
             }, 8000);
        }
        function ttShowCastNotice(anchorEl, entities) {
          return false; // notice turned off — approving the character goes straight back to the player
          if (!entities || !entities.length || !anchorEl || !anchorEl.parentNode) return false;
          if (document.getElementById('ttCastNotice')) return true;
          var names = entities.map(function (e) { return String(e.label || '').trim(); }).filter(Boolean).slice(0, 5);
          if (!names.length) return false;
          var es = ttLang2 === 'es';

          var oldStyles = document.getElementById('ttCastNoticeStyles');
          if (oldStyles) oldStyles.remove();
          var s = document.createElement('style');
          s.id = 'ttCastNoticeStyles';
          s.textContent = [
            '#ttCastNotice{margin:16px 0 18px;padding:22px 18px 20px;border-radius:24px;text-align:center;background:linear-gradient(180deg,#ffffff,#f3f8fd);border:1.5px solid rgba(59,134,240,.25);box-shadow:0 14px 34px rgba(26,58,92,.10);animation:ttcnIn .5s cubic-bezier(.22,1,.36,1);transition:opacity .5s ease,transform .5s ease;overflow:hidden;position:relative;scroll-margin-top:16px}',
            '#ttCastNotice.out{opacity:0;transform:translateY(-8px)}',
            '@keyframes ttcnIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}',
            '.ttcn-badge{display:inline-block;margin:0 auto 12px;padding:6px 14px;border-radius:999px;background:linear-gradient(135deg,#ffe08a,#f0b429);color:#5c2e00;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:900;letter-spacing:.02em;box-shadow:0 4px 12px rgba(240,180,41,.35);transform:rotate(-2deg)}',
            '.ttcn-title{font-family:Nunito,sans-serif;font-weight:900;font-size:clamp(18px,4.6vw,22px);color:#16324a;line-height:1.3;margin:0 auto 16px;max-width:420px}',
            '.ttcn-row{display:flex;flex-wrap:wrap;justify-content:center;gap:14px 16px;margin-bottom:14px}',
            '.ttcn-p{display:flex;flex-direction:column;align-items:center;gap:6px;width:72px;opacity:0;animation:ttcnPop .5s cubic-bezier(.34,1.56,.64,1) forwards}',
            '@keyframes ttcnPop{from{opacity:0;transform:scale(.6)}to{opacity:1;transform:scale(1)}}',
            '.ttcn-ic{position:relative;width:60px;height:60px;border-radius:50%;border:2.5px dashed #9cc3f2;background:#eef5fd;display:flex;align-items:center;justify-content:center;box-sizing:border-box}',
            '.ttcn-ic svg{width:34px;height:34px;display:block}',
            '.ttcn-q{position:absolute;right:-4px;bottom:-2px;width:22px;height:22px;border-radius:50%;background:#3b86f0;color:#fff;font-family:Nunito,sans-serif;font-size:13px;font-weight:900;display:flex;align-items:center;justify-content:center;border:2px solid #fff;box-sizing:border-box}',
            '.ttcn-name{font-family:Nunito,sans-serif;font-size:13px;font-weight:900;color:#16324a;max-width:72px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
            '.ttcn-sub{font-family:Nunito,sans-serif;font-size:14.5px;font-weight:800;color:#4b5563;line-height:1.5;max-width:340px;margin:0 auto}',
            '.ttcn-bar{position:absolute;left:0;right:0;bottom:0;height:4px;background:rgba(59,134,240,.12)}',
             '.ttcn-bar span{display:block;height:100%;width:100%;background:linear-gradient(90deg,#3b86f0,#f0b429);animation:ttcnBar 20s linear forwards}',
            '@keyframes ttcnBar{from{width:100%}to{width:0}}',
            '@media (prefers-reduced-motion:reduce){#ttCastNotice,.ttcn-p{animation:none;opacity:1}}',
          ].join('\n');
          document.head.appendChild(s);

          var joined = names.length === 1 ? names[0] : names.slice(0, -1).join(', ') + (es ? ' y ' : ' & ') + names[names.length - 1];
          var badge = es ? '🎁 Incluido gratis con la compra' : '🎁 Included free after purchase';
          var title = es ? 'Compra la película para agregar a ' + joined : 'Buy the movie to add ' + joined;
          var sub = es
            ? 'Los convertiremos en personajes estilo Pixar para la película'
            : "We'll turn them into Pixar-style characters for the movie";
          var silhouette =
            '<svg viewBox="0 0 24 24" width="34" height="34" fill="none" aria-hidden="true"><circle cx="12" cy="8" r="4" fill="#9cc3f2"/><path d="M4 20c0-4.4 3.6-7 8-7s8 2.6 8 7" fill="#9cc3f2"/></svg>';

          var wrap = document.createElement('div');
          wrap.id = 'ttCastNotice';
          wrap.setAttribute('role', 'status');
          wrap.innerHTML =
            '<div class="ttcn-badge">' + badge + '</div>' +
            '<div class="ttcn-title">' + escapeHtml(title) + '</div>' +
            '<div class="ttcn-row">' +
            names.map(function (nm, i) {
              return '<div class="ttcn-p" style="animation-delay:' + (0.15 + i * 0.12).toFixed(2) + 's">' +
                '<div class="ttcn-ic">' + silhouette + '<span class="ttcn-q">?</span></div>' +
                '<div class="ttcn-name">' + escapeHtml(nm) + '</div></div>';
            }).join('') +
            '</div>' +
            '<div class="ttcn-sub">' + escapeHtml(sub) + '</div>' +
            '<div class="ttcn-bar"><span></span></div>';
          anchorEl.parentNode.insertBefore(wrap, anchorEl);

          setTimeout(function () {
            wrap.classList.add('out');
            setTimeout(function () {
              wrap.remove();
              ttScrollToPlayer();
            }, 500);
                 }, 20000);
          return true;
        }

        // The ONLY automatic scroll: back to the song player, once, when they finish.
        function ttScrollToPlayer(msg) {
          // Go all the way up to the logo + title, so they see the full header above the player
          var header = document.querySelector('.tt-preview-header');
          try {
            window.scrollTo({
              top: header ? Math.max(0, header.getBoundingClientRect().top + window.pageYOffset - 12) : 0,
              behavior: 'smooth',
            });
          } catch (e) {}
          if (msg) {
            ensureInlineCastStyles();
            var t = document.createElement('div');
            t.className = 'ttic-toast';
            t.textContent = msg;
            document.body.appendChild(t);
            setTimeout(function () { t.style.opacity = '0'; }, 2200);
            setTimeout(function () { t.remove(); }, 2700);
          }
        }

        function ticChips(field, options, current) {
          return (
            '<div class="ttic-chips">' +
            options
              .map(function (o) {
                return (
                  '<button type="button" class="ttic-chip' + (current === o[0] ? ' sel' : '') + '" data-f="' + field + '" data-v="' +
                  escapeHtml(o[0]) + '">' + escapeHtml(o[1]) + '</button>'
                );
              })
              .join('') +
            '</div>'
          );
        }
        function ticQ(text) {
          return '<div class="ttic-q">' + text + '</div>';
        }
        function ticOpts(arr) {
          return arr.map(function (x) { return [x, x]; });
        }

        function buildInlineEntityCard(ent, opts) {
          ensureInlineCastStyles();
          var card = document.createElement('div');
          card.className = 'ttic-card';
          card.dataset.key = ent.key;
          var kind = ent.kind === 'pet' || ent.kind === 'horse' ? 'pet' : ent.kind === 'unknown' ? '' : 'person';
          var guessed = ttGuessGender(ent.label);
          var adultOnly = TT_ADULT_RE.test(String(ent.label || ''));
          // Parents/aunts/uncles → adult, grandparents → 60s. No need to ask.
          var GRAND_RE = /\b(grand ?ma|grandmother|nana|nanna|memaw|mamaw|meemaw|mimi|gigi|granny|gran|grand ?pa|grandfather|papa|pawpaw|poppy|grandad|granddad)\b/i;
          var autoAge = adultOnly ? (GRAND_RE.test(String(ent.label || '')) ? '60-69' : '20-49') : '';
          var sel = { body: 'Average', ethnicity: 'Skip' };
          if (guessed) sel.gender = guessed;
          if (autoAge) sel.age = autoAge;
          var ph = { gender: guessed ? guessed.toLowerCase() : '', age: autoAge, rel: '', species: '', file: null, preview: '' };
          var state = 'choose';
          var thumb = '';
          var statusMsg = '';
          var label = escapeHtml(ent.label);

          function ages() {
            return adultOnly
              ? TTIC_AGES.filter(function (a) { return TTIC_ADULT_AGES.indexOf(a[0]) !== -1; })
              : TTIC_AGES;
          }
          function head(right) {
            return '<div class="ttic-head"><div class="ttic-name">' + label + (kind === 'pet' ? ' 🐾' : '') + '</div>' + (right || '') + '</div>';
          }
          function isHorse() {
            return sel.species === 'Horse';
          }
          function describeReady() {
            if (kind === 'pet') return !!sel.species && (isHorse() ? !!sel.coatcolor : !!sel.furcolor);
            return !!sel.gender && !!sel.age && !!sel.skin && !!sel.haircolor && (sel.haircolor === 'Bald / No hair' || !!sel.hairlength);
          }
          function photoReady() {
            if (!window.ttEntityPhotoConsentGiven) return false;
            if (kind === 'pet') return !!ph.species;
            return !!ph.gender && !!ph.age && (ph.age !== '5-9' || !!ph.rel);
          }

          function render() {
            var h = '';
            card.classList.toggle('is-done', state === 'done');
            if (state === 'done') {
              h =
                head('<span class="ttic-check">✓ Added</span>') +
                '<div class="ttic-done">' +
                (thumb ? '<img src="' + thumb + '" alt="">' : '<span class="ttic-done-ico">✍️</span>') +
                '<div class="ttic-done-text">' +
                (thumb ? label + ' is ready for the movie!' : 'Saved — we\'ll bring ' + label + ' to life next') +
                '</div><button type="button" class="ttic-link" data-act="edit">Edit</button></div>';
            } else if (state === 'choose') {
              h = head();
              if (!kind) {
                h += ticQ('Is ' + label + ' a person or a pet?') + ticChips('_kind', [['person', '🧑 Person'], ['pet', '🐾 Pet']], '');
              } else {
                h +=
                  '<div class="ttic-actions">' +
                  (opts.allowPhoto ? '<button type="button" class="ttic-btn ttic-photo" data-act="photo">📸 Use a photo</button>' : '') +
                  '<button type="button" class="ttic-btn ttic-desc" data-act="describe">✍️ Describe</button></div>';
              }
            } else if (state === 'describe') {
              h = head('<button type="button" class="ttic-link" data-act="back">‹ Back</button>');
              if (kind === 'pet') {
                h += ticQ('What kind of pet?') + ticChips('species', [['Dog', '🐶 Dog'], ['Cat', '🐱 Cat'], ['Horse', '🐴 Horse'], ['Other', '🐾 Other']], sel.species);
                if (isHorse()) {
                  h += ticQ('Coat color') + ticChips('coatcolor', ticOpts(['Chestnut', 'Bay', 'Black', 'Palomino', 'White / Gray', 'Brown', 'Spotted / Pinto']), sel.coatcolor);
                  h += ticQ('Mane & tail') + ticChips('manecolor', ticOpts(['Black', 'Brown', 'Blonde / Flaxen', 'White / Gray', 'Same as coat']), sel.manecolor);
                  h += ticQ('Markings') + ticChips('markings', ticOpts(['None', 'White blaze/stripe on face', 'White socks/legs', 'Spots']), sel.markings);
                } else if (sel.species) {
                  h += ticQ('Size') + ticChips('size', ticOpts(['Small', 'Medium', 'Large']), sel.size);
                  h += ticQ('Fur color') + ticChips('furcolor', ticOpts(['Black', 'White', 'Brown', 'Golden / Tan', 'Gray', 'Spotted / Mixed']), sel.furcolor);
                  h += ticQ('Fur length') + ticChips('furlength', ticOpts(['Short', 'Medium', 'Long']), sel.furlength);
                }
                h += ticQ('Anything else? (optional)') + '<textarea class="ttic-text" data-f="extra" placeholder="e.g. breed, floppy ears, one blue eye">' + escapeHtml(sel.extra || '') + '</textarea>';
              } else {
                if (!guessed) h += ticQ('Male or female?') + ticChips('gender', ticOpts(['Female', 'Male']), sel.gender);
                if (!autoAge) h += ticQ('Age') + ticChips('age', ages(), sel.age);
                h +=
                  ticQ('Skin tone') +
                  '<div class="ttic-chips">' +
                  ENTITY_SKIN_SWATCHES.map(function (sw) {
                    return '<button type="button" class="ttic-sw' + (sel.skin === sw[0] ? ' sel' : '') + '" data-f="skin" data-v="' + sw[0] + '" title="' + sw[1] + '" style="background:' + sw[2] + ';"></button>';
                  }).join('') +
                  '</div>';
                h += ticQ('Hair color') + ticChips('haircolor', ticOpts(['Black', 'Brown', 'Blonde', 'Red', 'Gray', 'White', 'Bald / No hair']), sel.haircolor);
                if (sel.haircolor !== 'Bald / No hair') h += ticQ('Hair length') + ticChips('hairlength', ticOpts(['Short', 'Medium', 'Long']), sel.hairlength);
                h += ticQ('Build') + ticChips('body', ticOpts(['Slim', 'Average', 'Athletic', 'Heavyset']), sel.body);
                h += ticQ('Ethnicity (optional)') + ticChips('ethnicity', ticOpts(['White', 'Black', 'Hispanic', 'Asian', 'Mixed', 'Skip']), sel.ethnicity);
                h += ticQ('Anything else? (optional)') + '<textarea class="ttic-text" data-f="extra" placeholder="e.g. glasses, beard, curly hair, always wears a hat">' + escapeHtml(sel.extra || '') + '</textarea>';
              }
              h += '<button type="button" class="ttic-save" data-act="save"' + (describeReady() ? '' : ' disabled') + '>Save ' + label + ' ✓</button>';
              if (statusMsg) h += '<div class="ttic-status">' + statusMsg + '</div>';
            } else if (state === 'photo') {
              h = head('<button type="button" class="ttic-link" data-act="back">‹ Back</button>');
              if (!window.ttEntityPhotoConsentGiven) {
                h +=
                  '<label class="ttic-consent"><input type="checkbox" class="ttic-consent-cb" style="width:18px;height:18px;flex-shrink:0;accent-color:#4fa3d1;margin-top:1px;">' +
                  '<span>I have permission for the photos I add here and authorize TinyTunes to turn them into animated characters (<a href="/pages/photo-likeness-biometric-privacy-notice" target="_blank" style="color:#4fa3d1;">privacy notice</a>). You\'ll only be asked once.</span></label>';
              }
              if (kind === 'pet') {
                h += ticQ('What kind of pet?') + ticChips('p_species', [['dog', '🐶 Dog'], ['cat', '🐱 Cat'], ['horse', '🐴 Horse'], ['other', '🐾 Other']], ph.species);
              } else {
                if (!guessed) h += ticQ('Male or female?') + ticChips('p_gender', [['female', 'Female'], ['male', 'Male']], ph.gender);
                if (!autoAge) h += ticQ('About how old?') + ticChips('p_age', ages(), ph.age);
                if (ph.age === '5-9') h += ticQ('Compared to ' + escapeHtml(titleName() || 'your star') + '?') + ticChips('p_rel', [['younger', 'Younger'], ['same', 'Same age'], ['older', 'Older']], ph.rel);
              }
              h += '<label class="ttic-filebtn' + (photoReady() ? '' : ' off') + '">📸 Choose ' + label + '\'s photo<input type="file" accept="image/*" class="ttic-file" style="display:none;"></label>';
              if (statusMsg) h += '<div class="ttic-status">' + statusMsg + '</div>';
            } else if (state === 'confirm') {
              h =
                head() +
                '<img class="ttic-preview" src="' + ph.preview + '" alt="">' +
                '<div style="text-align:center;font-family:Nunito,sans-serif;font-size:14px;font-weight:800;color:#16324a;margin-bottom:6px;">Is this ' + label + '?</div>' +
                '<button type="button" class="ttic-save" data-act="upload">✓ Yes, that\'s ' + label + '</button>' +
                '<div style="text-align:center;margin-top:6px;"><button type="button" class="ttic-link" data-act="photo">Pick a different photo</button></div>';
            } else if (state === 'working') {
              h =
                head() +
                '<div class="ttic-upload-status ttic-status" style="padding:12px 0;"></div>' +
                '<div style="text-align:center;"><button type="button" class="ttic-link" data-act="photo">Use a different photo</button></div>';
            }
            card.innerHTML = h;
          }

          function markDone(url) {
            thumb = url || '';
            state = 'done';
            statusMsg = '';
            render();
            if (opts.onDone) opts.onDone(ent.key, thumb);
          }

          function saveDescribe() {
            var finalKind = kind === 'pet' ? (isHorse() ? 'horse' : 'pet') : 'person';
            var compiled = compileEntityDescription(finalKind, sel);
            if (finalKind === 'person' && sel.ethnicity && sel.ethnicity !== 'Skip') {
              compiled.description = (compiled.description ? compiled.description + ', ' : '') + sel.ethnicity.toLowerCase() + ' ethnicity';
            }
            var payloadDesc = Object.assign({ key: ent.key, kind: finalKind }, compiled);
            statusMsg = '<span class="ttq-loading-dot"></span> Saving…';
            render();
            fetch(WORKER_BASE + '/save-entity-descriptions', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ code: opts.code, descriptions: [payloadDesc] }),
            })
              .then(function (r) {
                if (!r.ok) throw new Error('save failed');
                markDone('');
              })
              .catch(function () {
                statusMsg = '<span style="color:#b42318;">Couldn\'t save — tap Save to try again.</span>';
                render();
              });
          }

          function startUpload() {
            if (!ph.file) return;
            var finalKind = kind === 'pet' ? 'pet' : 'person';
            var group = '';
            if (finalKind === 'person') {
              group = ageRangeToGroup(ph.age);
              if (group === 'young_child' && ph.rel === 'younger') group = 'young_child_younger';
              if (group === 'young_child' && ph.rel === 'older') group = 'young_child_older';
            }
            var file = ph.file;
            var preview = ph.preview;
            state = 'working';
            render();
            var stEl = card.querySelector('.ttic-upload-status');
            uploadEntityPhotoFile(ent.key, finalKind, ent.label, opts.code, file, stEl, group, ph.gender || '', ph.species || '', function (url) {
              markDone(url || preview);
            });
          }

          card.addEventListener('click', function (ev) {
            var t = ev.target.closest('[data-act],[data-f]');
            if (!t || !card.contains(t) || t.tagName === 'TEXTAREA') return;
            var act = t.getAttribute('data-act');
            if (act) {
              if (act === 'edit' || act === 'back') { state = 'choose'; statusMsg = ''; render(); return; }
              if (act === 'describe') { state = 'describe'; statusMsg = ''; render(); return; }
              if (act === 'photo') { state = 'photo'; statusMsg = ''; ph.file = null; render(); return; }
              if (act === 'save') { if (describeReady()) saveDescribe(); return; }
              if (act === 'upload') { startUpload(); return; }
              return;
            }
            var f = t.getAttribute('data-f');
            var v = t.getAttribute('data-v');
            if (!f || v === null) return;
            if (f === '_kind') {
              kind = v;
              render();
              return;
            }
            if (f.indexOf('p_') === 0) {
              ph[f.slice(2)] = v;
              if (f === 'p_age' && v !== '5-9') ph.rel = '';
              render();
              return;
            }
            sel[f] = v;
            if (f === 'skin') {
              ENTITY_SKIN_SWATCHES.forEach(function (sw) {
                if (sw[0] === v) { sel.skinHexLabel = sw[1]; sel.skinHex = sw[2]; }
              });
            }
            if (f === 'haircolor' && v === 'Bald / No hair') sel.hairlength = '';
            render();
          });
          card.addEventListener('input', function (ev) {
            if (ev.target.getAttribute && ev.target.getAttribute('data-f') === 'extra') sel.extra = ev.target.value;
          });
          card.addEventListener('change', function (ev) {
            var t = ev.target;
            if (t.classList.contains('ttic-consent-cb')) {
              window.ttEntityPhotoConsentGiven = t.checked;
              render();
              return;
            }
            if (t.classList.contains('ttic-file')) {
              var file = t.files && t.files[0];
              if (!file) return;
              ph.file = file;
              try { ph.preview = URL.createObjectURL(file); } catch (e2) { ph.preview = ''; }
              state = 'confirm';
              render();
            }
          });

          render();
          return card;
        }

        function renderEntityPrompt(container, afterEl, entities, codeForSave, mainSkinToken) {
          if (!entities || !entities.length) return;
          ensureInlineCastStyles();
          var prior = document.getElementById('ttEntityPrompt');
          if (prior) prior.remove();
          var starName = titleName() || 'your star';
          var possessive = /s$/i.test(starName) ? starName + "'" : starName + "'s";

          var wrap = document.createElement('div');
          wrap.id = 'ttEntityPrompt';
          wrap.className = 'ttic-section';
          wrap.innerHTML =
            '<div class="ttic-badge">🎬 BONUS — INCLUDED FREE</div>' +
            '<div class="ttic-title">Cast the rest of the family</div>' +
            '<div class="ttic-sub">We spotted more people in ' + escapeHtml(possessive) + ' song. Add them and they\'ll star in the movie too.</div>' +
            '<div class="ttic-progress"></div>' +
            '<div class="ttic-cards"></div>' +
            '<div class="ttic-footer">' +
            '<button type="button" class="ttic-continue">Continue →</button>' +
            '<button type="button" class="ttic-skip">Skip — just use ' + escapeHtml(starName) + '</button>' +
            '</div>';
          if (afterEl && afterEl.nextSibling) container.insertBefore(wrap, afterEl.nextSibling);
          else container.appendChild(wrap);

          var cardsEl = wrap.querySelector('.ttic-cards');
          var countEl = wrap.querySelector('.ttic-progress');
          var contBtn = wrap.querySelector('.ttic-continue');
          var skipBtn = wrap.querySelector('.ttic-skip');
          var doneKeys = {};
          var allowPhoto = window.ttCharacterMode === 'photo_likeness';

          function updateCount() {
            var n = Object.keys(doneKeys).length;
            countEl.textContent = n + ' of ' + entities.length + ' added';
            var pending = entities.filter(function (x) { return !doneKeys[x.key]; }).map(function (x) { return x.label; });
            contBtn.textContent = !pending.length
              ? 'Continue →'
              : pending.length === 1
              ? 'Continue without ' + pending[0] + ' →'
              : pending.length === 2
              ? 'Continue without ' + pending[0] + ' & ' + pending[1] + ' →'
              : 'Continue without ' + pending.length + ' characters →';
          }

          entities.forEach(function (ent) {
            cardsEl.appendChild(
              buildInlineEntityCard(ent, {
                code: codeForSave,
                allowPhoto: allowPhoto,
                onDone: function (k) {
                  doneKeys[k] = true;
                  updateCount();
                },
              })
            );
          });
          updateCount();

          skipBtn.addEventListener('click', function () {
            wrap.remove();
            if (typeof window.ttRefreshCastStrip === 'function') window.ttRefreshCastStrip();
            ttScrollToPlayer();
          });

          contBtn.addEventListener('click', function () {
            // Switch to the gold reveal styling the results carousel was designed for
            wrap.className = '';
            wrap.style.cssText =
              'position:relative;margin:20px 0 4px;padding:24px 18px 20px;border-radius:22px;background:linear-gradient(135deg,#f9c846,#f0a800);box-shadow:0 12px 28px rgba(240,168,0,.28);scroll-margin-top:16px;';
            wrap.innerHTML =
              '<div style="text-align:center;padding:50px 20px;">' +
              '<div style="width:44px;height:44px;margin:0 auto 18px;border-radius:50%;border:4px solid rgba(255,255,255,.35);border-top-color:#fff;animation:ttSpin .8s linear infinite;"></div>' +
              '<div style="font-family:Fraunces,serif;font-weight:600;font-size:18px;color:#16324a;">Bringing their characters to life…</div>' +
              '</div>';
            try { wrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}

            fetch(WORKER_BASE + '/generate-entity-previews', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                code: codeForSave,
                entities: entities.map(function (x) { return { key: x.key, label: x.label, kind: x.kind }; }),
              }),
            })
              .then(function (r) { return r.json().catch(function () { return {}; }); })
              .then(function (out) {
                if (out && out.ok && out.entities && out.entities.length) {
                  renderEntityRevealCarousel(wrap, out.entities);
                } else {
                  wrap.remove();
                  if (typeof window.ttRefreshCastStrip === 'function') window.ttRefreshCastStrip();
                  ttScrollToPlayer('✓ Cast saved — back to the song');
                }
              })
              .catch(function () {
                wrap.remove();
                ttScrollToPlayer();
              });
          });
        }

        // Tapping "+" on the Supporting Cast strip opens the same inline card under the strip
        function ttOpenStripEditor(stripEl, ent) {
          var prior = document.getElementById('ttCastInline');
          if (prior) {
            var sameOne = prior.dataset.key === ent.key;
            prior.remove();
            if (sameOne) return;
          }
          var panel = document.createElement('div');
          panel.id = 'ttCastInline';
          panel.dataset.key = ent.key;
          panel.style.cssText = 'margin-top:14px;';
          var stripCode = window.ttUnfinishedEntityCode || code;
          panel.appendChild(
            buildInlineEntityCard(ent, {
              code: stripCode,
              allowPhoto: window.ttCharacterMode === 'photo_likeness',
              onDone: function (k, url) {
                function refresh() {
                  if (typeof window.ttRefreshCastStrip === 'function') window.ttRefreshCastStrip();
                }
                if (url) {
                  setTimeout(refresh, 1500);
                  return;
                }
                fetch(WORKER_BASE + '/generate-entity-previews', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ code: stripCode, entities: [{ key: ent.key, label: ent.label, kind: ent.kind }] }),
                })
                  .catch(function () {})
                  .then(refresh);
              },
            })
          );
          stripEl.appendChild(panel);
        }
        // The movie reveal uses this to add family right in the offer
        window.ttBuildFamilyCard = function (ent, onDone) {
          var famCode = window.ttUnfinishedEntityCode || code;
          return buildInlineEntityCard(ent, {
            code: famCode,
            allowPhoto: window.ttCharacterMode === 'photo_likeness',
            onDone: function (k, url) {
              function finish(u) {
                if (u) { window.ttEntityImages = window.ttEntityImages || {}; window.ttEntityImages[k] = u; }
                if (typeof onDone === 'function') onDone(k, u || '');
              }
              if (url) { finish(url); return; }
              // Described with words → create their character image now
              fetch(WORKER_BASE + '/generate-entity-previews', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code: famCode, entities: [{ key: ent.key, label: ent.label, kind: ent.kind }] }),
              })
                .then(function (r) { return r.json().catch(function () { return {}; }); })
                .then(function (out) {
                  var hit = out && out.entities && out.entities.filter(function (x) { return x.key === k; })[0];
                  finish(hit && hit.imageUrl);
                })
                .catch(function () { finish(''); });
            },
          });
        };
        // ============ END INLINE CAST EDITOR ============

                function renderEntityRevealCarousel(wrap, entities) {
          ensureEntityModalStyles();

          if (!document.getElementById('ttEntityRevealStyles')) {
            var rs = document.createElement('style');
            rs.id = 'ttEntityRevealStyles';
            rs.textContent =
              '@keyframes ttRevealPortraitIn{0%{opacity:0;transform:scale(.75) translateY(14px)}60%{opacity:1;transform:scale(1.04) translateY(-2px)}100%{opacity:1;transform:scale(1) translateY(0)}}' +
              '@keyframes ttRevealSpark{0%{opacity:0;transform:scale(.3) translateY(4px) rotate(0deg)}30%{opacity:1;transform:scale(1) translateY(-4px) rotate(12deg)}70%{opacity:1;transform:scale(1) translateY(-10px) rotate(-8deg)}100%{opacity:0;transform:scale(.4) translateY(-18px) rotate(18deg)}}' +
              '@keyframes ttRevealGlow{0%,100%{opacity:.55;transform:scale(1)}50%{opacity:1;transform:scale(1.08)}}' +
              '@keyframes ttRevealNameIn{0%{opacity:0;transform:translateY(8px)}100%{opacity:1;transform:translateY(0)}}' +
              '.tt-er-slide{opacity:0;animation:ttRevealPortraitIn .7s cubic-bezier(.22,1,.36,1) forwards}' +
              '.tt-er-frame{position:relative}' +
              '.tt-er-glow{position:absolute;inset:-14% -14% -8%;border-radius:26px;background:radial-gradient(circle,rgba(255,255,255,.55),rgba(255,255,255,.12) 55%,transparent 75%);filter:blur(10px);animation:ttRevealGlow 3.2s ease-in-out infinite;pointer-events:none}' +
              '.tt-er-eyebrow{opacity:0;animation:ttRevealNameIn .5s ease forwards .35s}' +
              '.tt-er-name{opacity:0;animation:ttRevealNameIn .5s ease forwards .48s}';
            document.head.appendChild(rs);
          }

                  function retryEntityWithPhoto(entityKey, entityKind, entityLabel, slideImgEl, statusEl) {
          var tempInput = document.createElement('input');
          tempInput.type = 'file';
          tempInput.accept = 'image/*';
          tempInput.style.display = 'none';
          document.body.appendChild(tempInput);

          function proceedToConsent(ageGroup, gender) {
            tempInput.dataset.ageGroup = ageGroup || '';
            tempInput.dataset.gender = gender || '';
            openEntityPhotoConsent(entityLabel,
              function onAuthorized() { tempInput.click(); },
              function onDeclined() { tempInput.remove(); }
            );
          }
                if (entityKind === 'pet' || entityKind === 'horse') {
            proceedToConsent('', '');
          } else {
            askEntityGenderAndAge(entityLabel, function (gender, ageGroup) { proceedToConsent(ageGroup, gender); });
          }

          tempInput.addEventListener('change', function () {
            var file = tempInput.files && tempInput.files[0];
            if (!file) { tempInput.remove(); return; }
            if (statusEl) { statusEl.style.display = 'block'; statusEl.innerHTML = '<span class="ttq-loading-dot"></span> Preparing photo…'; }
            readAndResizeImageFile(file, 1600, 0.85, function (dataUrl) {
              if (statusEl) statusEl.innerHTML = '<span class="ttq-loading-dot"></span> Creating their character…';
              fetch(WORKER_BASE + '/upload-entity-photo', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  code: code, entity_key: entityKey, entity_label: entityLabel, kind: entityKind,
                  photo: dataUrl, consent_confirmed: true,
                  age_group: tempInput.dataset.ageGroup || '', gender: tempInput.dataset.gender || '',
                }),
              })
                .then(function (r) { return r.json().catch(function () { return {}; }); })
                           .then(function (out) {
                  if (out && out.ok && out.imageUrl) {
                    if (slideImgEl) {
                      slideImgEl.src = out.imageUrl + '?_cb=' + Date.now();
                    } else {
                      // Failed card had no <img> at all — build one now that a real image exists
                      var frameEl = statusEl.closest('.tt-er-slide').querySelector('.tt-er-frame > div:last-child');
                      if (frameEl) frameEl.innerHTML = '<img class="tt-er-img" src="' + out.imageUrl + '?_cb=' + Date.now() + '" style="width:100%;height:100%;object-fit:cover;object-position:center 15%;display:block;">';
                    }
                    if (statusEl) statusEl.innerHTML = '<div style="font-size:11.5px;font-weight:800;color:#16a34a;">✓ Updated from photo</div>';
                  } else if (statusEl) {
                    statusEl.innerHTML = '<div style="font-size:11.5px;font-weight:700;color:#b42318;">' + escapeHtml((out && out.error) || "Couldn't upload — try again.") + '</div>';
                  }
                })
                .catch(function () {
                  if (statusEl) statusEl.innerHTML = '<div style="font-size:11.5px;font-weight:700;color:#b42318;">Something went wrong — try again.</div>';
                });
            }, function () {
              if (statusEl) statusEl.innerHTML = '<div style="font-size:11.5px;font-weight:700;color:#b42318;">Couldn\'t read that photo.</div>';
            });
            tempInput.remove();
          });
        }

                    // Center the row when everything fits on screen at once; only
          // switch to a left-aligned scrolling track once there are enough
          // cards to actually overflow the container. Recalculated after
          // the cards are in the DOM, once real widths are known.
          var track = document.createElement('div');
          track.style.cssText = 'display:flex;gap:16px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:14px 4px 10px;justify-content:center;';

          entities.forEach(function (e, i) {
            var slide = document.createElement('div');
            slide.className = 'tt-er-slide';
            slide.style.cssText = 'flex:0 0 205px;scroll-snap-align:center;text-align:center;animation-delay:' + (i * 0.18) + 's;';

            var sparkles = '';
            var sparkGlyphs = ['✨', '⭐', '💫'];
            for (var s = 0; s < 5; s++) {
              var left = 6 + Math.random() * 82;
              var top = 4 + Math.random() * 78;
              var delay = (i * 0.18 + 0.5 + Math.random() * 1.8).toFixed(2);
              var dur = (2.2 + Math.random() * 1.4).toFixed(2);
              sparkles += '<span style="position:absolute;left:' + left + '%;top:' + top + '%;font-size:' + (12 + Math.random() * 8).toFixed(0) + 'px;opacity:0;animation:ttRevealSpark ' + dur + 's ease-in-out ' + delay + 's infinite;pointer-events:none;">' + sparkGlyphs[s % sparkGlyphs.length] + '</span>';
            }

                            var hasImage = !!e.imageUrl;
            slide.innerHTML =
              '<div class="tt-er-eyebrow" style="font-family:\'Nunito\',sans-serif;font-size:10.5px;font-weight:900;letter-spacing:.16em;text-transform:uppercase;color:rgba(17,24,39,.55);margin-bottom:6px;animation-delay:' + (i * 0.18 + 0.35) + 's;">✨ Starring ✨</div>' +
              '<div class="tt-er-frame" style="width:205px;height:250px;margin:0 auto;">' +
              '<div class="tt-er-glow" style="animation-delay:' + (i * 0.3) + 's;"></div>' +
              sparkles +
              '<div style="position:relative;width:100%;height:100%;border-radius:20px;overflow:hidden;background:#fff;box-shadow:0 16px 34px rgba(0,0,0,.22),0 0 0 3px rgba(255,255,255,.6);' + (hasImage ? '' : 'display:flex;align-items:center;justify-content:center;flex-direction:column;gap:8px;padding:16px;text-align:center;') + '">' +
              (hasImage
                ? '<img class="tt-er-img" src="' + e.imageUrl + '" alt="' + escapeHtml(e.label) + '" style="width:100%;height:100%;object-fit:cover;object-position:center 15%;display:block;">'
                : '<div style="font-size:34px;">😕</div><div style="font-family:\'Nunito\',sans-serif;font-size:12.5px;font-weight:800;color:#7c8a99;">We couldn\'t create their character</div>')
              +
              '</div>' +
              '</div>' +
              '<div class="tt-er-name" style="margin-top:12px;font-family:\'Fraunces\',serif;font-weight:600;font-size:19px;color:#fff;text-shadow:0 2px 8px rgba(0,0,0,.3);animation-delay:' + (i * 0.18 + 0.48) + 's;">' + (hasImage ? 'Meet ' + escapeHtml(e.label) + '!' : escapeHtml(e.label)) + '</div>' +
                            '<button type="button" class="tt-er-retry" style="margin-top:8px;background:rgba(255,255,255,.14);border:1px solid rgba(255,255,255,.28);color:rgba(255,255,255,.88);font-family:\'Nunito\',sans-serif;font-size:11px;font-weight:800;padding:6px 12px;border-radius:999px;cursor:pointer;">📸 ' + (hasImage ? 'Or upload a photo instead' : 'Upload their photo to fix this') + '</button>' +
              '<div class="tt-er-retry-status" style="display:none;margin-top:6px;"></div>';
            track.appendChild(slide);

                    var retryBtnEl = slide.querySelector('.tt-er-retry');
            var slideImgEl = slide.querySelector('.tt-er-img'); // may be null for a failed card — handled below
            var retryStatusEl = slide.querySelector('.tt-er-retry-status');
            if (retryBtnEl) {
              retryBtnEl.addEventListener('click', function () {
                retryBtnEl.style.display = 'none';
                retryEntityWithPhoto(e.key, e.kind === 'unknown' ? 'person' : e.kind, e.label, slideImgEl, retryStatusEl);
              });
            }
          });

          var doneBtn = document.createElement('button');
          doneBtn.type = 'button';
          doneBtn.textContent = 'Continue →';
          doneBtn.style.cssText = 'display:block;margin:18px auto 0;background:#111827;color:#fff;font-family:\'Nunito\',sans-serif;font-size:13px;font-weight:900;padding:12px 26px;border-radius:999px;border:none;cursor:pointer;box-shadow:0 6px 16px rgba(0,0,0,.25);';
                   doneBtn.addEventListener('click', function () {
            wrap.remove();
            window.ttRefreshCastStrip();
            ttScrollToPlayer('✓ Cast saved — back to the song');
          });

               wrap.innerHTML =
            '<div style="position:absolute;top:-13px;left:18px;background:linear-gradient(135deg,#111827,#2d3748);color:#fff;font-size:11px;font-weight:900;letter-spacing:.05em;padding:6px 16px;border-radius:999px;box-shadow:0 6px 14px rgba(0,0,0,.3);">🎬 BONUS FEATURE — INCLUDED FREE</div>' +
            '<div style="text-align:center;color:#111827;font-family:\'Fraunces\',serif;font-weight:600;font-size:20px;margin-bottom:4px;">Their supporting cast is ready! 🎉</div>' +
            '<div style="text-align:center;color:rgba(17,24,39,.68);font-family:\'Nunito\',sans-serif;font-size:13px;font-weight:700;margin-bottom:2px;">We\'ll use these characters in the video — or upload a photo for an exact likeness</div>';
                    wrap.appendChild(track);
          wrap.appendChild(doneBtn);

          // After layout, check whether the cards actually overflow the
          // available width. If they do, switch to left-aligned scrolling
          // (centering a scrollable overflowed row looks broken/cut-off);
          // if they don't, keep it centered with no scroll at all.
          requestAnimationFrame(function () {
            var overflowing = track.scrollWidth > track.clientWidth + 4;
            track.style.justifyContent = overflowing ? 'flex-start' : 'center';
            track.style.overflowX = overflowing ? 'auto' : 'visible';
          });
        }

        function checkDemoClipOnce(codeForCheck, wrap) {
          fetch(WORKER_BASE + '/status-by-code?code=' + encodeURIComponent(codeForCheck), { cache: 'no-store' })
            .then(function (r) {
              return r.json().catch(function () {
                return {};
              });
            })
            .then(function (data) {
              var clipUrl = data && (data.demo_clip_url || (data.fields && data.fields.demo_clip_url));
              if (clipUrl) {
                try {
                  window.ttDemoClipUrl = clipUrl;
                } catch (e) {}
                if (typeof window.ttApplyPersonalDemoClip === 'function') window.ttApplyPersonalDemoClip(clipUrl);
                if (typeof window.ttWarmDemoClip === 'function') window.ttWarmDemoClip(clipUrl);
                wrap.innerHTML =
                  '<video id="ttEntityDemoClip" src="' +
                  clipUrl +
                  '" autoplay muted loop playsinline ' +
                  'style="width:200px;border-radius:14px;box-shadow:0 10px 26px rgba(26,58,92,.18);margin:0 auto;display:block;opacity:1;transition:opacity 1s ease;"></video>';
                setTimeout(function () {
                  var clipEl = document.getElementById('ttEntityDemoClip');
                  if (clipEl) clipEl.style.opacity = '0';
                  setTimeout(function () {
                    var mediaStage = document.getElementById('ttMediaStage');
                    if (mediaStage) {
                      try {
                        var top1 = mediaStage.getBoundingClientRect().top + window.pageYOffset - 16;
                        window.scrollTo({ top: top1, behavior: 'smooth' });
                      } catch (e) {}
                    }
                  }, 1000);
                }, 20000);
              } else {
                setTimeout(function () {
                  wrap.remove();
                  var mediaStage2 = document.getElementById('ttMediaStage');
                  if (mediaStage2) {
                    try {
                      var top2 = mediaStage2.getBoundingClientRect().top + window.pageYOffset - 16;
                      window.scrollTo({ top: top2, behavior: 'smooth' });
                    } catch (e) {}
                  }
                }, 1200);
              }
            })
            .catch(function () {
              setTimeout(function () {
                wrap.remove();
                var mediaStage3 = document.getElementById('ttMediaStage');
                if (mediaStage3) {
                  try {
                    var top3 = mediaStage3.getBoundingClientRect().top + window.pageYOffset - 16;
                    window.scrollTo({ top: top3, behavior: 'smooth' });
                  } catch (e) {}
                }
              }, 1200);
            });
        }

        function saveCharacter() {
  if (!code) {
    alert(pt2('missingCode') || 'Missing preview code. Please refresh.');
    return;
  }
  if (window._ttExpired) {
    alert(pt2('expiredPreview') || 'This preview has expired. Please make a new one to continue.');
    return;
  }
  saveGeneration++;
  var myGeneration = saveGeneration;
  var stableStem = baseStem(pick);
          var stem = effectiveBaseStem();
          var url = ASSET_BASE + '/' + stem + '.jpg';
          var character_id = stableStem;
          var frameClear = document.querySelector('#ttCharbSaved .ttq-saved-frame');
          if (frameClear) frameClear.classList.remove('is-dressed');

          var initialPayload = {
            code: code,
            character_id: character_id,
            character_label: pick.ethnicity + ' ' + pick.hairstyle,
            look_label: pick.skin,
            age_group: pick.age,
            gender: pick.gender,
            outfit: pick.outfit,
            outfit_name: OUTFIT_SAVE[pick.outfit] || pick.outfit,
            base_character: stem,
            character_image_url: url,
            child_name: getChildName() || '',
            // Only final if no dressing step is coming. For a picked outfit the dressed
            // save (in pollDressed) flips this to true — until then the worker will wait
            // and, if needed, dress the character itself with the right outfit.
            character_is_final: pick.outfit === 'keep' || pick.outfit === 'custom',
          };

          window._ttCharacterSavePromise = trackedSave(initialPayload)
            .then(function (out) {
              if (out && Array.isArray(out.detected_entities) && out.detected_entities.length) {
                pendingDetectedEntities = out.detected_entities;
                pendingEntityCode = code;
                pendingEntitySkin = pick.skin;
              }
              return out;
            })
            .catch(function (err) {
              console.error('[TT] character save failed after retries:', err);
              var sub = $('ttCharbSub');
              if (sub) {
                sub.innerHTML =
                  '⚠️ Outfit choice may not have saved — <button type="button" id="ttCharbRetrySave" style="background:none;border:none;color:#3c8ab3;font-weight:900;text-decoration:underline;cursor:pointer;padding:0;font-size:inherit;">tap to retry</button>';
                var retryBtn = document.getElementById('ttCharbRetrySave');
                if (retryBtn)
                  retryBtn.addEventListener('click', function () {
                    sub.innerHTML = '<span class="ttq-loading-dot"></span> Retrying…';
                    postCharacterSaveWithRetry(initialPayload)
                      .then(function () {
                        sub.textContent = '✓ Ready for their big reveal! 🎬';
                      })
                      .catch(function () {
                        sub.innerHTML =
                          '⚠️ Still couldn\'t save — <button type="button" id="ttCharbRetrySave2" style="background:none;border:none;color:#3c8ab3;font-weight:900;text-decoration:underline;cursor:pointer;padding:0;font-size:inherit;">try again</button>';
                        var retryBtn2 = document.getElementById('ttCharbRetrySave2');
                        if (retryBtn2)
                          retryBtn2.addEventListener('click', function () {
                            retryBtn.click();
                          });
                      });
                  });
              }
            });

          if (pick.outfit === 'keep') {
            form.style.display = 'none';
            revealWrap.style.display = 'none';
            $('ttCharbSavedImg').src = url;
            fitFrameToImage($('ttCharbSavedImg'), document.querySelector('#ttCharbSaved .ttq-saved-frame'));
            $('ttCharbSavedName').textContent = titleName() || pt2('allSet') || 'All set!';
            var vbName = $('ttCharbVideoBtnName');
            if (vbName) vbName.textContent = titleName() || pt2('them') || 'Them';
            $('ttCharbSub').textContent = pt2('readyForReveal') || '✓ Ready for their big reveal! 🎬';
            savedWrap.style.display = 'block';
            try {
              var cardTopK = document.getElementById('ttCharBuilder');
              if (cardTopK && cardTopK.scrollIntoView) cardTopK.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch (e) {}
            try {
              window.savedCharacterId = character_id;
              window.savedCharacterUrl = url;
              window.ttOutfit = 'keep';
            } catch (e) {}
            if (typeof window.updateVideoCta === 'function') window.updateVideoCta();
            if (typeof window.applyCharacterToPlayer === 'function') window.applyCharacterToPlayer();
            document.dispatchEvent(
              new CustomEvent('ttCharacterSaved', {
                detail: {
                  character_id: character_id,
                  url: url,
                  outfit: 'keep',
                  gender: pick.gender,
                  base_character: stem,
                },
              })
            );
            document.dispatchEvent(new CustomEvent('ttCharacterDressed', { detail: { url: url } }));
            return;
          }
          if (pick.outfit === 'custom' && customCharacterUrl) {
            var customUrl = customCharacterUrl;
            form.style.display = 'none';
            revealWrap.style.display = 'none';
            $('ttCharbSavedImg').src = customUrl;
            fitFrameToImage($('ttCharbSavedImg'), document.querySelector('#ttCharbSaved .ttq-saved-frame'));
            $('ttCharbSavedName').textContent = titleName() || pt2('allSet') || 'All set!';
            var vbNameC = $('ttCharbVideoBtnName');
            if (vbNameC) vbNameC.textContent = titleName() || pt2('them') || 'Them';
            $('ttCharbSub').textContent = pt2('readyForReveal') || '✓ Ready for their big reveal! 🎬';
            savedWrap.style.display = 'block';
            try {
              var cardTopC = document.getElementById('ttCharBuilder');
              if (cardTopC && cardTopC.scrollIntoView) cardTopC.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch (e) {}
            try {
              window.savedCharacterId = character_id;
              window.savedCharacterUrl = customUrl;
              window.ttOutfit = 'custom';
            } catch (e) {}
            if (typeof window.updateVideoCta === 'function') window.updateVideoCta();
            if (typeof window.applyCharacterToPlayer === 'function') window.applyCharacterToPlayer();
            document.dispatchEvent(
              new CustomEvent('ttCharacterSaved', {
                detail: {
                  character_id: character_id,
                  url: customUrl,
                  outfit: 'custom',
                  gender: pick.gender,
                  base_character: stem,
                },
              })
            );
            document.dispatchEvent(new CustomEvent('ttCharacterDressed', { detail: { url: customUrl } }));
            return;
          }

         if (PRINCESS_DRESSES[pick.outfit] || SUPERHERO_OUTFITS[pick.outfit]) {
  // 🔒 Must go through Grok, not KIE (get-dressed-character) — KIE
  // flags these themed outfits as too sensitive.
  var isPrincessPick = !!PRINCESS_DRESSES[pick.outfit];
  var dressInfo = isPrincessPick ? PRINCESS_DRESSES[pick.outfit] : SUPERHERO_OUTFITS[pick.outfit];

  // Show this branch's own loading state instead of falling through
  // to the generic "dressing them" block below (that fall-through was
  // the bug: it overwrote the saved image back to the undressed base
  // and fired ttCharacterSaved with the wrong url).
  form.style.display = 'none';
  revealWrap.style.display = 'none';
  $('ttCharbSavedImg').src = url;
  $('ttCharbSavedName').textContent = titleName() || pt2('allSet') || 'All set!';
  $('ttCharbSub').innerHTML =
    '<span class="ttq-loading-dot"></span> ' +
    (ttLang2 === 'es' ? 'Vistiéndolo/a con su atuendo…' : 'Dressing them in their outfit…');
  savedWrap.style.display = 'block';
  savedWrap.classList.add('working');
  try {
    var cardTopP = document.getElementById('ttCharBuilder');
    if (cardTopP && cardTopP.scrollIntoView) cardTopP.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } catch (e) {}

  fetch(WORKER_BASE + '/apply-theme-outfit-grok', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      code: code,
      theme: isPrincessPick ? 'princess' : 'superhero',
      outfit_id: dressInfo.outfitId,
      base_image_url: url,
    }),
  })
    .then(function (r) {
      return r.json().catch(function () {
        return {};
      });
    })
    .then(function (out) {
      if (myGeneration !== saveGeneration) return;
      if (out && out.ok && out.imageUrl) {
        var finalUrl = out.imageUrl;
        var si2 = $('ttCharbSavedImg');
        if (si2) si2.src = finalUrl;
        var frame2 = document.querySelector('#ttCharbSaved .ttq-saved-frame');
        if (frame2) {
          frame2.classList.add('is-dressed');
          fitFrameToImage(si2, frame2);
        }
        try {
          window.savedCharacterUrl = finalUrl;
        } catch (e) {}
        var pl = document.getElementById('ttPlayerCharImg');
        if (pl) {
          pl.src = finalUrl;
          pl.style.display = 'block';
        }
        var gift = document.querySelector('#ttGiftReveal img');
        if (gift) gift.src = finalUrl;
        var sub = $('ttCharbSub');
        if (sub) sub.textContent = pt2('readyForReveal') || '✓ Ready for their big reveal! 🎬';
        savedWrap.classList.remove('working');
        var dressedPayload = {
          code: code,
          character_id: window.savedCharacterId || '',
          character_label: pick.ethnicity + ' ' + pick.hairstyle,
          look_label: pick.skin,
          age_group: pick.age,
          gender: pick.gender,
          outfit: pick.outfit,
          outfit_name: dressInfo.label,
          base_character: window.savedCharacterId || '',
          character_image_url: finalUrl,
          child_name: getChildName() || '',
          character_is_final: true,
        };
        trackedSave(dressedPayload).catch(function (err) {
          console.error('[TT] failed to save princess-dress image after retries:', err);
        });
        if (typeof window.applyCharacterToPlayer === 'function') window.applyCharacterToPlayer();
        document.dispatchEvent(
          new CustomEvent('ttCharacterSaved', {
            detail: {
              character_id: window.savedCharacterId || '',
              url: finalUrl,
              outfit: pick.outfit,
              gender: pick.gender,
              base_character: window.savedCharacterId || '',
            },
          })
        );
        document.dispatchEvent(new CustomEvent('ttCharacterDressed', { detail: { url: finalUrl } }));
      } else {
        var subErr = $('ttCharbSub');
        if (subErr)
          subErr.innerHTML =
            '⚠️ Couldn\'t create the outfit — <button type="button" id="ttCharbRetryPrincess" style="background:none;border:none;color:#3c8ab3;font-weight:900;text-decoration:underline;cursor:pointer;padding:0;font-size:inherit;">tap to retry</button>';
        savedWrap.classList.remove('working');
      }
    })
    .catch(function (err) {
      console.error('[TT] apply-theme-outfit-grok network error:', err);
      savedWrap.classList.remove('working');
    });

  return; // ← critical: stops execution from falling into the generic block below
} else {
  fetch(WORKER_BASE + '/get-dressed-character', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ base_character: stem, gender: pick.gender, outfit: pick.outfit, code: code }),
  })
    .then(function (r) {
      return r.json().catch(function () {
        return { parse_error: true, status: r.status };
      });
    })
    .then(function (out) {
      if (myGeneration !== saveGeneration) return;
      if (!out || out.ok !== true) {
        var sub = $('ttCharbSub');
        if (sub) sub.textContent = '✓ Character saved! (outfit finishing up…)';
      }
    })
    .catch(function (err) {
      console.error('[TT] get-dressed-character network error:', err);
    });

  var dressedUrl = ASSET_BASE + '/' + stem + '-' + pick.outfit + '.jpg';
  pollDressed(dressedUrl, myGeneration);
}

          form.style.display = 'none';
          revealWrap.style.display = 'none';
          $('ttCharbSavedImg').src = url;
          $('ttCharbSavedName').textContent = titleName() || pt2('allSet') || 'All set!';
          var vbName = $('ttCharbVideoBtnName');
          if (vbName) vbName.textContent = titleName() || pt2('them') || 'Them';
          $('ttCharbSub').innerHTML =
            '<span class="ttq-loading-dot"></span> ' +
            (ttLang2 === 'es' ? 'Vistiéndolo/a con su atuendo…' : 'Dressing them in their outfit…');
          savedWrap.style.display = 'block';
          savedWrap.classList.add('working');

          try {
            var cardTop = document.getElementById('ttCharBuilder');
            if (cardTop && cardTop.scrollIntoView) cardTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
            else window.scrollTo({ top: 0, behavior: 'smooth' });
          } catch (e) {
            try {
              window.scrollTo(0, 0);
            } catch (_) {}
          }

          try {
            window.savedCharacterId = character_id;
            window.savedCharacterUrl = url;
            window.ttOutfit = pick.outfit;
          } catch (e) {}
          if (typeof window.updateVideoCta === 'function') window.updateVideoCta();
          if (typeof window.applyCharacterToPlayer === 'function') window.applyCharacterToPlayer();
          document.dispatchEvent(
            new CustomEvent('ttCharacterSaved', {
              detail: {
                character_id: character_id,
                url: url,
                outfit: pick.outfit,
                gender: pick.gender,
                base_character: stem,
              },
            })
          );
        }

        var dressTimer = null;
function pollDressed(url, myGeneration) {
  var tries = 0;
  if (dressTimer) clearInterval(dressTimer);
  function tryLoad() {
    tries++;
    var probe = new Image();
    probe.onload = function () {
      if (myGeneration !== saveGeneration) {
        if (dressTimer) {
          clearInterval(dressTimer);
          dressTimer = null;
        }
        return;
      }
      if (dressTimer) {
        clearInterval(dressTimer);
        dressTimer = null;
      }
      var si2 = $('ttCharbSavedImg');
              if (si2) si2.src = url;
              var frame2 = document.querySelector('#ttCharbSaved .ttq-saved-frame');
              if (frame2) {
                frame2.classList.add('is-dressed');
                fitFrameToImage(si2, frame2);
              }
              try {
                window.savedCharacterUrl = url;
              } catch (e) {}
              var pl = document.getElementById('ttPlayerCharImg');
              if (pl) {
                pl.src = url;
                pl.style.display = 'block';
              }
              var gift = document.querySelector('#ttGiftReveal img');
              if (gift) gift.src = url;
              var sub = $('ttCharbSub');
              if (sub) sub.textContent = pt2('readyForReveal') || '✓ Ready for their big reveal! 🎬';
              savedWrap.classList.remove('working');
              var dressedPayload = {
                code: code,
                character_id: window.savedCharacterId || '',
                character_label: pick.ethnicity + ' ' + pick.hairstyle,
                look_label: pick.skin,
                age_group: pick.age,
                gender: pick.gender,
                outfit: pick.outfit,
                outfit_name: OUTFIT_SAVE[pick.outfit] || pick.outfit,
                base_character: window.savedCharacterId || '',
                character_image_url: url,
                child_name: getChildName() || '',
                character_is_final: true,
              };
              trackedSave(dressedPayload).catch(function (err) {
                console.error('[TT] failed to save dressed image after retries:', err);
                var sub2 = $('ttCharbSub');
                if (sub2) {
                  sub2.innerHTML =
                    '⚠️ Outfit may not have saved — <button type="button" id="ttCharbRetryDressed" style="background:none;border:none;color:#3c8ab3;font-weight:900;text-decoration:underline;cursor:pointer;padding:0;font-size:inherit;">tap to retry</button>';
                  var rb = document.getElementById('ttCharbRetryDressed');
                  if (rb)
                    rb.addEventListener('click', function () {
                      sub2.innerHTML = '<span class="ttq-loading-dot"></span> Retrying…';
                      postCharacterSaveWithRetry(dressedPayload)
                        .then(function () {
                          sub2.textContent = '✓ Ready for their big reveal! 🎬';
                        })
                        .catch(function () {
                          sub2.innerHTML = "⚠️ Still couldn't save — please refresh and try again.";
                        });
                    });
                }
              });
              document.dispatchEvent(new CustomEvent('ttCharacterDressed', { detail: { url: url } }));
            };
            probe.onerror = function () {};
            probe.src = url + '?_cb=' + Date.now();
          }
          tryLoad();
          dressTimer = setInterval(function () {
            if (tries > 60) {
              clearInterval(dressTimer);
              dressTimer = null;
              return;
            }
            tryLoad();
          }, 3000);
        }

        function fitFrameToImage(imgEl, frameEl) {
          if (!imgEl || !frameEl) return;
          function apply() {
            if (imgEl.naturalWidth && imgEl.naturalHeight) {
              frameEl.style.aspectRatio = imgEl.naturalWidth + ' / ' + imgEl.naturalHeight;
            }
          }
          if (imgEl.complete && imgEl.naturalWidth) apply();
          else imgEl.addEventListener('load', apply, { once: true });
        }

        function escapeHtml(s) {
          return String(s || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        }

                  function readAndResizeImageFile(file, maxDim, quality, onSuccess, onError) {
          maxDim = maxDim || 1600;
          quality = quality || 0.85;
          // Some in-app browsers (Facebook/Instagram) lack FileReader — read the photo another way
          if (typeof window.FileReader === 'undefined' && window.URL && URL.createObjectURL) {
            var objUrl = URL.createObjectURL(file);
            var img0 = new Image();
            img0.onload = function () {
              var w = img0.naturalWidth, h = img0.naturalHeight;
              if (w > maxDim || h > maxDim) {
                var sc = Math.min(maxDim / w, maxDim / h);
                w = Math.round(w * sc);
                h = Math.round(h * sc);
              }
              var cv = document.createElement('canvas');
              cv.width = w;
              cv.height = h;
              cv.getContext('2d').drawImage(img0, 0, 0, w, h);
              try { onSuccess(cv.toDataURL('image/jpeg', quality)); } catch (e) { onError && onError(e); }
              URL.revokeObjectURL(objUrl);
            };
            img0.onerror = function () { onError && onError(new Error('Image load failed')); };
            img0.src = objUrl;
            return;
          }
          var reader = new FileReader();
          reader.onload = function () {
            var img = new Image();
            img.onload = function () {
              var w = img.naturalWidth, h = img.naturalHeight;
              if (w > maxDim || h > maxDim) {
                var scale = Math.min(maxDim / w, maxDim / h);
                w = Math.round(w * scale);
                h = Math.round(h * scale);
              }
              var canvas = document.createElement('canvas');
              canvas.width = w;
              canvas.height = h;
              var ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, w, h);
              try {
                var dataUrl = canvas.toDataURL('image/jpeg', quality);
                onSuccess(dataUrl);
              } catch (e) {
                onError && onError(e);
              }
            };
            img.onerror = function () {
              onSuccess(reader.result);
            };
            img.src = reader.result;
          };
          reader.onerror = function () {
            onError && onError(new Error('File read failed'));
          };
          reader.readAsDataURL(file);
        }

        var editBtn = $('ttCharbEdit');
if (editBtn) editBtn.addEventListener('click', resetAll);

function approveCharacter(mode, btnEl, otherBtnEl) {
  btnEl.disabled = true;
  btnEl.style.opacity = '0.7';
  btnEl.querySelector('.ttq-choice-top').textContent = '✓ Selected';
  if (otherBtnEl) otherBtnEl.style.display = 'none';

   try {
    window.ttCharacterMode = mode;
    window.ttCharacterApproved = true;
    if (mode === 'photo_likeness') {
      var savedImgEl = document.getElementById('ttCharbSavedImg');
      if (savedImgEl) savedImgEl.src = LIKENESS_PLACEHOLDER_IMG;
    }
    fetch(WORKER_BASE + '/update-record', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code, character_mode: mode }),
    }).catch(function () {});
  } catch (e) {}

  var savePromise = window._ttCharacterSavePromise || Promise.resolve();
  savePromise
    .then(function () {
      fetch(WORKER_BASE + '/start-character-demo-clip', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code }),
      }).catch(function () {});

      var builderRoot = document.getElementById('ttCharBuilder');

       // Cast is added AFTER purchase now — keep the names for the modal teaser only
      if (pendingDetectedEntities && pendingDetectedEntities.length) {
        window.ttDetectedCast = pendingDetectedEntities;
        pendingDetectedEntities = null;
        ttShowCastNotice(builderRoot, window.ttDetectedCast);
      }

            if (builderRoot) builderRoot.style.display = 'none';

            window.ttRefreshCastStrip();
         ttShowFamilyTip(window.ttDetectedCast || window.ttAllCastEntities || []);
      var entityPrompt = document.getElementById('ttEntityPrompt') || document.getElementById('ttCastNotice');
      if (entityPrompt) {
        setTimeout(function () {
          try { entityPrompt.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        }, 200);
      } else {
        setTimeout(function () {
          try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
        }, 200);
      }
    })
    .catch(function () {});
}
var approveBtn = $('ttCharbApproveBtn');
var likenessBtn = $('ttCharbLikenessBtn');
var entryLikenessWrap = $('ttCharbEntryLikenessWrap');
var entryLikenessBtn = $('ttCharbEntryLikenessBtn');
var entryStandardBtn = $('ttCharbEntryStandardBtn');
var consentSource = 'saved';

if (entryStandardBtn) {
  entryStandardBtn.addEventListener('click', function () {
    if (entryLikenessWrap) entryLikenessWrap.style.display = 'none';
    if (form) form.style.display = 'block';
  });
}

var tryPhotoLink = $('ttncTryPhotoLink');
if (tryPhotoLink) {
  tryPhotoLink.addEventListener('click', function () {
    consentSource = 'entry';
    var consentModal = document.getElementById('ttConsentModal');
    if (consentModal) consentModal.style.display = 'flex';
  });
}

if (approveBtn) {
  approveBtn.addEventListener('click', function () {
    approveCharacter('standard', approveBtn, likenessBtn);
  });
}
if (likenessBtn) {
  likenessBtn.addEventListener('click', function () {
    consentSource = 'saved';
    var consentModal = document.getElementById('ttConsentModal');
    if (consentModal) consentModal.style.display = 'flex';
  });
}
if (entryLikenessBtn) {
  entryLikenessBtn.addEventListener('click', function () {
    consentSource = 'entry';
    var consentModal = document.getElementById('ttConsentModal');
    if (consentModal) consentModal.style.display = 'flex';
  });
}

var consentCheck = document.getElementById('ttConsentCheck');
var consentContinueBtn = document.getElementById('ttConsentContinueBtn');
var consentModalEl = document.getElementById('ttConsentModal');
var NOTICE_URL = '/pages/photo-likeness-biometric-privacy-notice'; // ← use your actual slug
var noticeModalEl = document.getElementById('ttNoticeModal');
var noticeBodyEl = document.getElementById('ttNoticeBody');
var noticeCloseBtn = document.getElementById('ttNoticeCloseBtn');
var noticeLoaded = false;

function openNoticeModal() {
  if (noticeModalEl) noticeModalEl.style.display = 'flex';
  if (noticeLoaded) return;
  fetch(NOTICE_URL)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content =
        doc.querySelector('.shopify-policy__body') ||
        doc.querySelector('main') ||
        doc.body;
      if (noticeBodyEl && content) {
        noticeBodyEl.innerHTML = content.innerHTML;
        noticeLoaded = true;
      }
    })
    .catch(function () {
      if (noticeBodyEl) {
        noticeBodyEl.innerHTML =
          '<div style="text-align:center;padding:20px 0;color:#b42318;">Couldn\'t load the notice — <a href="' +
          NOTICE_URL +
          '" target="_blank" style="color:#4fa3d1;">open it in a new tab</a> instead.</div>';
      }
    });
}

if (noticeCloseBtn) {
  noticeCloseBtn.addEventListener('click', function () {
    noticeModalEl.style.display = 'none';
  });
}
if (noticeModalEl) {
  noticeModalEl.addEventListener('click', function (e) {
    if (e.target === noticeModalEl) noticeModalEl.style.display = 'none';
  });
}
var noticeLinkInModal = document.querySelector('#ttConsentModal a[href="' + NOTICE_URL + '"]');
if (noticeLinkInModal) {
  noticeLinkInModal.removeAttribute('target');
  noticeLinkInModal.addEventListener('click', function (e) {
    e.preventDefault();
    openNoticeModal();
  });
}

if (consentCheck) {
  consentCheck.addEventListener('change', function () {
    consentContinueBtn.disabled = !this.checked;
    consentContinueBtn.style.background = this.checked ? 'linear-gradient(135deg,#4fa3d1,#3c8ab3)' : '#cbd5e1';
    consentContinueBtn.style.cursor = this.checked ? 'pointer' : 'not-allowed';
  });
}

var consentDeclineBtn = document.getElementById('ttConsentDeclineBtn');
if (consentDeclineBtn) {
  consentDeclineBtn.addEventListener('click', function () {
    consentModalEl.style.display = 'none';
    if (consentSource === 'entry') {
      if (entryLikenessWrap) entryLikenessWrap.style.display = 'none';
      if (form) form.style.display = 'block';
    } else {
      approveCharacter('standard', approveBtn, likenessBtn);
    }
  });
}

function ensureLikenessMagicStyles() {
  if (document.getElementById('ttLikenessMagicStyles')) return;
  var s = document.createElement('style');
  s.id = 'ttLikenessMagicStyles';
  s.textContent =
    '.tt-mg-stage{position:relative;min-height:300px;border-radius:24px;overflow:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:30px 16px;background:#0f0a2e;isolation:isolate}' +
    '.tt-mg-blob{position:absolute;width:70%;aspect-ratio:1;border-radius:50%;filter:blur(40px);opacity:.75;mix-blend-mode:screen;animation:ttMgFloat 7s ease-in-out infinite}' +
    '.tt-mg-blob.b1{background:#ff4fd8;top:-20%;left:-15%}' +
    '.tt-mg-blob.b2{background:#4f7bff;bottom:-25%;right:-20%;animation-delay:-2.3s}' +
    '.tt-mg-blob.b3{background:#ffcc33;top:30%;left:35%;width:45%;animation-delay:-4.6s;opacity:.55}' +
    '@keyframes ttMgFloat{0%,100%{transform:translate(0,0) scale(1)}33%{transform:translate(12%,8%) scale(1.15)}66%{transform:translate(-10%,6%) scale(.9)}}' +
    '.tt-mg-p{position:absolute;bottom:-10px;border-radius:50%;opacity:0;animation:ttMgRise linear infinite}' +
    '@keyframes ttMgRise{0%{transform:translateY(0) scale(.6);opacity:0}15%{opacity:1}100%{transform:translateY(-340px) scale(1.2);opacity:0}}' +
    '.tt-mg-orb{position:relative;width:120px;height:120px;margin-bottom:22px;z-index:2}' +
    '.tt-mg-ring{position:absolute;inset:0;border-radius:50%;background:conic-gradient(from 0deg,#ff4fd8,#ffcc33,#4fd1ff,#7c5cff,#ff4fd8);-webkit-mask:radial-gradient(farthest-side,transparent calc(100% - 6px),#000 calc(100% - 5px));mask:radial-gradient(farthest-side,transparent calc(100% - 6px),#000 calc(100% - 5px));animation:ttSpin 1.6s linear infinite;filter:drop-shadow(0 0 12px rgba(255,255,255,.55))}' +
    '.tt-mg-ring.r2{inset:16px;animation-duration:2.4s;animation-direction:reverse;opacity:.8}' +
    '.tt-mg-core{position:absolute;inset:34px;border-radius:50%;background:radial-gradient(circle,#fff,rgba(255,255,255,.2) 70%);display:flex;align-items:center;justify-content:center;font-size:26px;animation:ttMgPulse 1.4s ease-in-out infinite;box-shadow:0 0 40px rgba(255,255,255,.7)}' +
    '@keyframes ttMgPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.12)}}' +
    '.tt-mg-text{position:relative;z-index:2;font-family:\'Fraunces\',serif;font-weight:600;font-size:clamp(19px,4.5vw,24px);color:#fff;text-align:center;min-height:32px;transition:opacity .25s;text-shadow:0 2px 18px rgba(255,79,216,.6);padding:0 12px}' +
    '.tt-mg-bar{position:relative;z-index:2;width:70%;max-width:260px;height:6px;border-radius:999px;background:rgba(255,255,255,.15);overflow:hidden;margin-top:18px}' +
    '.tt-mg-bar-fill{position:absolute;inset:0;width:40%;border-radius:999px;background:linear-gradient(90deg,#ff4fd8,#ffcc33,#4fd1ff);animation:ttMgBar 1.6s ease-in-out infinite}' +
    '@keyframes ttMgBar{0%{transform:translateX(-100%)}100%{transform:translateX(260%)}}' +
    '.tt-rv-wrap{position:relative;max-width:340px;margin:0 auto;border-radius:22px;overflow:hidden;box-shadow:0 18px 44px rgba(26,58,92,.3)}' +
    '.tt-rv-img{display:block;width:100%;animation:ttRvIn 1s cubic-bezier(.22,1,.36,1) both}' +
    '@keyframes ttRvIn{0%{opacity:0;transform:scale(.85);filter:blur(14px) brightness(2)}60%{opacity:1;filter:blur(0) brightness(1.2)}100%{opacity:1;transform:scale(1);filter:none}}' +
    '.tt-rv-burst{position:absolute;inset:-40%;z-index:2;pointer-events:none;background:radial-gradient(circle,rgba(255,255,255,.95),rgba(255,204,51,.5) 25%,transparent 55%);animation:ttRvBurst 1.1s ease-out forwards}' +
    '@keyframes ttRvBurst{0%{opacity:1;transform:scale(.3)}100%{opacity:0;transform:scale(1.4)}}' +
    '.tt-rv-sheet{position:relative;max-width:340px;margin:14px auto 0;background:#fff;border:1px solid #eef2f6;border-radius:18px;padding:16px 16px 12px;box-shadow:0 10px 28px rgba(26,58,92,.12);text-align:center;transform:translateY(14px);opacity:0;transition:transform .45s cubic-bezier(.22,1,.36,1),opacity .35s;pointer-events:none}' +
    '.tt-rv-sheet.show{transform:translateY(0);opacity:1;pointer-events:auto}' +
    '.tt-rv-q{font-family:\'Fraunces\',serif;font-weight:600;font-size:18px;color:#16324a;margin-bottom:10px}' +
    '.tt-rv-love{display:block;width:100%;border:none;border-radius:14px;padding:13px;background:linear-gradient(135deg,#ff5fa2,#f0b429);color:#fff;font-family:\'Nunito\',sans-serif;font-weight:900;font-size:16px;cursor:pointer;box-shadow:0 8px 20px rgba(240,120,80,.35)}' +
    '.tt-rv-retry{display:block;margin:8px auto 0;background:none;border:none;color:#6b7280;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:12.5px;text-decoration:underline;cursor:pointer}' +
    '.tt-rv-pills{display:flex;flex-wrap:wrap;gap:6px;justify-content:center}' +
    '.tt-rv-pill{padding:9px 14px;border-radius:999px;border:2px solid rgba(26,58,92,.12);background:#fff;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:13px;color:#374151;cursor:pointer}' +
    '.tt-rv-pill.small{padding:7px 10px;font-size:11.5px}' +
       '.tt-rv-pill.sel{border-color:#4fa3d1;background:#e8f4fb;color:#3c8ab3}' +
    '.tt-rv-compact{padding:8px 10px 6px;left:8px;right:8px;bottom:8px}' +
    '.tt-rv-row{display:flex;align-items:center;justify-content:space-between;gap:10px}' +
    '.tt-rv-compact .tt-rv-q{margin:0;font-size:16px}' +
    '.tt-rv-compact .tt-rv-love{width:auto;padding:10px 18px;font-size:14.5px}' +
    '.tt-rv-compact .tt-rv-retry{margin:4px auto 0;font-size:11.5px}';
  document.head.appendChild(s);
}

// Before → after photos in the consent modal, matched to the order's theme.
function ensureRevealStageStyles() {
  if (document.getElementById('ttRevealStageStyles')) return;
  var s = document.createElement('style');
  s.id = 'ttRevealStageStyles';
  s.textContent =
    '.tt-rv-wrap{position:relative;max-width:340px;margin:0 auto;border-radius:26px;overflow:hidden;padding:3px;background:linear-gradient(135deg,#f6d77a,#fff4d1 40%,#e9b949);box-shadow:0 24px 60px rgba(26,58,92,.28)}' +
    '.tt-rv-stage{position:relative;border-radius:23px;overflow:hidden;aspect-ratio:4/5;background:radial-gradient(120% 80% at 50% 0%,#ffffff 0%,#e8f3fb 45%,#bfe0f3 100%)}' +
    '.tt-rv-theme-princess .tt-rv-stage{background:radial-gradient(120% 80% at 50% 0%,#ffffff 0%,#fde7f3 45%,#f3c4e0 100%)}' +
    '.tt-rv-theme-superhero .tt-rv-stage{background:radial-gradient(120% 80% at 50% 0%,#ffffff 0%,#e6eeff 45%,#c3d4ff 100%)}' +
    '.tt-rv-theme-halloween .tt-rv-stage{background:radial-gradient(120% 80% at 50% 0%,#fffaf2 0%,#ffe6cc 45%,#f7c396 100%)}' +
    '.tt-rv-spot{position:absolute;left:50%;top:-12%;width:95%;height:85%;transform:translateX(-50%);background:radial-gradient(ellipse at 50% 30%,rgba(255,255,255,.95),rgba(255,255,255,0) 65%);pointer-events:none}' +
    '.tt-rv-floor{position:absolute;left:50%;bottom:15%;width:56%;height:6%;transform:translateX(-50%);border-radius:50%;background:radial-gradient(ellipse,rgba(26,58,92,.30),rgba(26,58,92,0) 70%);filter:blur(2px)}' +
    '.tt-rv-img{position:absolute;left:6%;top:4%;width:88%;height:79%;object-fit:contain;mix-blend-mode:multiply;display:block}' +
    '.tt-rv-plate{position:absolute;left:0;right:0;bottom:0;z-index:3;padding:14px 12px 12px;background:linear-gradient(to top,rgba(255,255,255,.96) 55%,rgba(255,255,255,0));text-align:center;display:flex;flex-direction:column;gap:2px}' +
    '.tt-rv-plate-eyebrow{font-family:\'Nunito\',sans-serif;font-size:10px;font-weight:900;letter-spacing:.28em;text-transform:uppercase;color:#c9971c}' +
    '.tt-rv-plate-name{font-family:\'Fraunces\',serif;font-weight:600;font-size:24px;color:#16324a;line-height:1.1}' +
    '@keyframes ttRvTwinkle{0%,100%{opacity:0;transform:scale(.4)}50%{opacity:1;transform:scale(1)}}' +
       '.tt-rv-twinkle{position:absolute;z-index:2;color:#f5c542;font-size:16px;text-shadow:0 0 10px rgba(245,197,66,.8);animation:ttRvTwinkle 2.6s ease-in-out infinite;pointer-events:none}' +
    '.tt-rv-stage{background:#f3f4f6 !important;border-radius:23px 23px 0 0}' +
    '.tt-rv-spot,.tt-rv-floor{display:none}' +
    '.tt-rv-img{left:0;top:0;width:100%;height:100%;object-fit:cover;object-position:center 40%;mix-blend-mode:normal}' +
    '.tt-rv-plate{position:relative;background:#fff;border-radius:0 0 23px 23px;padding:12px 12px 14px}';
  document.head.appendChild(s);
}

function ensureTransformStyles() {
  if (document.getElementById('ttTransformStyles')) return;
  var s = document.createElement('style');
  s.id = 'ttTransformStyles';
  s.textContent =
    '.tt-tf-photo{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;animation:ttTfPaint 32s ease-in-out forwards}' +
    '@keyframes ttTfPaint{0%{filter:none}40%{filter:saturate(1.35) contrast(1.05) blur(.5px)}100%{filter:saturate(1.2) brightness(1.18) blur(5px)}}' +
    '.tt-tf-scan{position:absolute;left:0;right:0;height:30%;top:-32%;background:linear-gradient(to bottom,rgba(255,255,255,0),rgba(255,255,255,.6),rgba(255,236,170,0));mix-blend-mode:screen;animation:ttTfScan 2.4s ease-in-out infinite;pointer-events:none}' +
    '@keyframes ttTfScan{0%{top:-32%}100%{top:102%}}' +
    '.tt-tf-glow{position:absolute;inset:0;background:radial-gradient(circle at 50% 40%,rgba(255,255,255,0) 40%,rgba(245,197,66,.28) 100%);animation:ttTfPulse 2s ease-in-out infinite;pointer-events:none}' +
    '@keyframes ttTfPulse{0%,100%{opacity:.6}50%{opacity:1}}' +
    '.tt-tf-panel{max-width:340px;margin:14px auto 0;background:#fff;border:1px solid #eef2f6;border-radius:18px;padding:16px 18px 14px;box-shadow:0 10px 28px rgba(26,58,92,.12)}' +
    '.tt-tf-title{font-family:\'Fraunces\',serif;font-weight:600;font-size:18px;color:#16324a;text-align:center;margin-bottom:10px}' +
    '.tt-tf-bar{height:8px;border-radius:999px;background:#f1f4f8;overflow:hidden;margin-bottom:12px}' +
    '.tt-tf-bar-fill{height:100%;width:3%;border-radius:999px;background:linear-gradient(90deg,#f6d77a,#e9b949,#f0a800);transition:width 32s cubic-bezier(.2,.7,.3,1)}' +
    '.tt-tf-steps{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:7px}' +
    '.tt-tf-steps li{font-family:\'Nunito\',sans-serif;font-size:13.5px;font-weight:700;color:#b6c0cb;display:flex;align-items:center;gap:9px;transition:color .3s}' +
    '.tt-tf-steps li::before{content:"";width:16px;height:16px;border-radius:50%;border:2px solid #d9e0e8;flex-shrink:0;box-sizing:border-box;transition:all .3s}' +
    '.tt-tf-steps li.active{color:#16324a}' +
    '.tt-tf-steps li.active::before{border-color:#e9b949;border-top-color:transparent;animation:ttSpin .9s linear infinite}' +
    '.tt-tf-steps li.done{color:#4b5563}' +
    '.tt-tf-steps li.done::before{content:"✓";border:none;background:#e9b949;color:#fff;font-size:10px;font-weight:900;display:flex;align-items:center;justify-content:center}' +
    '.tt-tf-note{margin-top:12px;text-align:center;font-family:\'Nunito\',sans-serif;font-size:12px;font-weight:700;color:#9aa5b1}';
  document.head.appendChild(s);
}

function ensureUploadStyles() {
  if (document.getElementById('ttUploadStyles')) return;
  var s = document.createElement('style');
  s.id = 'ttUploadStyles';
  s.textContent =
    '.tt-up{max-width:340px;margin:0 auto}' +
    '.tt-up .tt-rv-wrap{cursor:pointer;transition:box-shadow .2s}' +
    '.tt-up-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center 30%}' +
    '.tt-up-after{animation:ttUpSwap 5s ease-in-out infinite}' +
    '@keyframes ttUpSwap{0%,35%{opacity:0}50%,85%{opacity:1}100%{opacity:0}}' +
    '.tt-up-chip{position:absolute;left:12px;bottom:12px;z-index:3;background:rgba(255,255,255,.94);color:#16324a;font-family:\'Nunito\',sans-serif;font-size:11.5px;font-weight:900;padding:6px 11px;border-radius:999px;box-shadow:0 4px 12px rgba(0,0,0,.12);animation:ttUpChipA 5s ease-in-out infinite}' +
    '.tt-up-chip-after{background:linear-gradient(135deg,#f6d77a,#e9b949);color:#3b2a00;animation-name:ttUpChipB}' +
    '@keyframes ttUpChipA{0%,35%{opacity:1}50%,85%{opacity:0}100%{opacity:1}}' +
    '@keyframes ttUpChipB{0%,35%{opacity:0}50%,85%{opacity:1}100%{opacity:0}}' +
    '.tt-up-over{box-shadow:0 0 0 4px rgba(233,185,73,.5),0 24px 60px rgba(26,58,92,.28) !important}' +
    '.tt-up-btn{display:flex !important;align-items:center;justify-content:center;gap:8px;margin-top:16px;cursor:pointer;text-align:center}' +
    '.tt-up-tips{display:flex;justify-content:center;flex-wrap:wrap;gap:6px 14px;margin-top:12px;font-family:\'Nunito\',sans-serif;font-size:12px;font-weight:800;color:#6b7280}' +
    '.tt-up-privacy{margin-top:8px;text-align:center;font-family:\'Nunito\',sans-serif;font-size:11.5px;font-weight:700;color:#9aa5b1}' +
    '.tt-rv-seg{display:flex;flex-wrap:nowrap;gap:0;background:#f3f5f8;border-radius:14px;padding:4px}' +
    '.tt-rv-seg .tt-rv-seg-btn{flex:1;min-width:0;border:none;background:transparent;border-radius:10px;padding:8px 2px;display:flex;flex-direction:column;align-items:center;gap:1px;box-shadow:none;transition:all .15s}' +
    '.tt-seg-num{font-family:\'Nunito\',sans-serif;font-size:14px;font-weight:900;color:#16324a;white-space:nowrap}' +
    '.tt-seg-word{font-family:\'Nunito\',sans-serif;font-size:10px;font-weight:800;color:#9aa5b1}' +
    '.tt-rv-seg .tt-rv-seg-btn.sel{background:#fff;box-shadow:0 2px 8px rgba(26,58,92,.15)}' +
    '.tt-rv-seg .tt-rv-seg-btn.sel .tt-seg-word{color:#3c8ab3}' +
    '.tt-rv-pill:focus,.tt-rv-seg-btn:focus{outline:none}' +
    '.tt-up .tt-rv-stage{aspect-ratio:1/1;border-radius:23px;background:radial-gradient(120% 90% at 50% 0%,#ffffff 0%,#fff8ea 55%,#fbe9c2 100%) !important}' +
    '.tt-up-dash{position:absolute;inset:14px;border:2px dashed rgba(201,151,28,.45);border-radius:18px;pointer-events:none}' +
    '.tt-up-center{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;text-align:center;padding:20px}' +
    '.tt-up-orb{position:relative;width:96px;height:96px;border-radius:50%;background:radial-gradient(circle at 35% 30%,#fff,#fff4d1 60%,#f6d77a);display:flex;align-items:center;justify-content:center;font-size:40px;margin-bottom:10px;animation:ttUpBreath 2.4s ease-in-out infinite}' +
    '@keyframes ttUpBreath{0%,100%{transform:scale(1);box-shadow:0 10px 30px rgba(233,185,73,.4),0 0 0 8px rgba(246,215,122,.22)}50%{transform:scale(1.06);box-shadow:0 14px 36px rgba(233,185,73,.55),0 0 0 14px rgba(246,215,122,.12)}}' +
    '.tt-up-plus{position:absolute;right:-2px;bottom:4px;width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#ff5fa2,#f0b429);color:#fff;font-family:\'Nunito\',sans-serif;font-size:18px;font-weight:900;display:flex;align-items:center;justify-content:center;border:2px solid #fff;box-shadow:0 4px 10px rgba(240,120,80,.4)}' +
    '.tt-up-cta{font-family:\'Fraunces\',serif;font-weight:600;font-size:20px;color:#16324a}' +
    '.tt-up-sub{font-family:\'Nunito\',sans-serif;font-size:12.5px;font-weight:700;color:#9aa5b1}';
  document.head.appendChild(s);
}

function setConsentBeforeAfter() {
  var PAIRS = {
    princess: [
      'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Princess_Regular.jpg?v=1790791945',
      'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Princess_Finished.jpg?v=1790792087',
    ],
    superhero: [
      'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/Super_hero_Basic.jpg?v=1790792205',
      'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/super_hero_done.jpg?v=1790792342',
    ],
    other: [
      'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/REGULAR_PHOTO.jpg?v=1790793811',
      'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/character_done.jpg?v=1790793976',
    ],
  };
  var p = PAIRS[pageTheme] || PAIRS.other;
  window.ttBeforeAfterPair = p;
  var b = document.getElementById('ttConsentBeforeImg');
  var a = document.getElementById('ttConsentAfterImg');
  if (b) b.src = p[0] + '&width=240';
    if (a) a.src = p[1] + '&width=240';
  var eb = document.getElementById('ttEntryBeforeImg');
  var ea = document.getElementById('ttEntryAfterImg');
  if (eb) eb.src = p[0] + '&width=240';
  if (ea) ea.src = p[1] + '&width=240';
}

function showLikenessUploadUI() {
  if (entryLikenessWrap) entryLikenessWrap.style.display = 'none';
  if (form) form.style.display = 'none';
  if (savedWrap) savedWrap.style.display = 'none';
  var headerElLikeness = document.getElementById('ttCharBuilderHeader');
  if (headerElLikeness) headerElLikeness.style.display = 'none';

  var existing = document.getElementById('ttLikenessUpload');
  if (existing) existing.remove();

  var wrap = document.createElement('div');
  wrap.id = 'ttLikenessUpload';
  wrap.style.cssText = 'text-align:center;padding:10px 16px 6px;margin-bottom:36px;';
    wrap.innerHTML =
    '<div id="ttLikenessTitle" style="font-family:\'Fraunces\',serif;font-weight:600;font-size:20px;color:#16324a;margin-bottom:6px;">Upload their photo</div>' +
    '<div id="ttLikenessIntro" style="font-size:13px;color:#6b7280;margin-bottom:20px;max-width:320px;margin-left:auto;margin-right:auto;">Choose a clear photo with just them in it — their face easy to see, no one else. We\'ll turn it into their animated character.</div>' +
    '<div id="ttLikenessStage"></div>';

    var builderCardEl = document.getElementById('ttCharBuilder');
  if (builderCardEl && builderCardEl.parentNode) {
    builderCardEl.insertAdjacentElement('afterend', wrap);
  }

  setTimeout(function () {
    try {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {}
  }, 80);

    var introEl = wrap.querySelector('#ttLikenessIntro');
  var stageEl = wrap.querySelector('#ttLikenessStage');
  var attemptsUsed = 0;
  var MAX_ATTEMPTS = 3;
  var pendingImageUrl = '';
  var funTimer = null;

   var LIKENESS_AGE_OPTIONS = [
    ['infant', '0-1', '🍼'],
    ['baby', '1-3', '👶'],
    ['toddler', '3-5', '🧸'],
    ['young_child', '6-8', '⭐'],
    ['young_child', '8-10', '🎈'],
    ['preteen', '11-13', '🎒'],
    ['teen', '14-18', '🎓'],
  ];

  function renderGeneratingWithAgeAsk(dataUrl) {
    var callFired = false;
    var ageTimeout = null;

    function fireUploadCall(ageGroup) {
      if (callFired) return;
      callFired = true;
      if (ageTimeout) clearTimeout(ageTimeout);
      renderGenerating();
              fetch(WORKER_BASE + '/upload-likeness-photo', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: code, photo: dataUrl, age_group: ageGroup || '' }),
        })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (out) {
          attemptsUsed++;
          stopFunLoop();
          if (out && out.ok && out.imageUrl) {
            pendingImageUrl = out.imageUrl;
            renderResult(out.imageUrl, typeof out.attemptsRemaining === 'number' ? out.attemptsRemaining : (MAX_ATTEMPTS - attemptsUsed));
          } else {
            var remaining = typeof out?.attemptsRemaining === 'number' ? out.attemptsRemaining : (MAX_ATTEMPTS - attemptsUsed);
            renderDropzone();
            var statusEl2 = stageEl.querySelector('#ttLikenessStatus');
            if (statusEl2) statusEl2.textContent = (out && out.error) || "Couldn't create the character — please try again.";
            if (remaining <= 0) {
              stageEl.innerHTML = '<div style="font-size:13px;font-weight:700;color:#7c8a99;">No attempts remaining. Please contact us for help.</div>';
            }
          }
        })
        .catch(function () {
          stopFunLoop();
          renderDropzone();
          var statusEl3 = stageEl.querySelector('#ttLikenessStatus');
          if (statusEl3) statusEl3.textContent = 'Something went wrong — please try again.';
        });
    }

    // Age is asked once and reused across retries within this session —
    // if we already have it, skip straight to the call, same as gender.
    if (window.ttLikenessAgeGroup) {
      fireUploadCall(window.ttLikenessAgeGroup);
      return;
    }

    if (introEl) introEl.style.display = 'none';
    var sparkles = ['✨', '⭐', '🌟', '💫'];
    var sparkleHtml = '';
    for (var i = 0; i < 14; i++) {
      var left = Math.round(Math.random() * 92) + 2;
      var top = Math.round(Math.random() * 78) + 6;
      var delay = (Math.random() * 2.4).toFixed(2);
      var dur = (2 + Math.random() * 1.6).toFixed(2);
      var size = 14 + Math.round(Math.random() * 14);
      var glyph = sparkles[i % sparkles.length];
      sparkleHtml +=
        '<span style="position:absolute;left:' + left + '%;top:' + top + '%;font-size:' + size + 'px;' +
        'opacity:0;animation:ttMagicTwinkle ' + dur + 's ease-in-out ' + delay + 's infinite;">' + glyph + '</span>';
    }
    stageEl.innerHTML =
      '<div style="position:relative;min-height:220px;display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden;">' +
        sparkleHtml +
        '<div style="position:relative;width:76px;height:76px;margin-bottom:12px;">' +
          '<div style="position:absolute;inset:0;border-radius:50%;background:radial-gradient(circle,rgba(249,200,70,.35),transparent 70%);animation:ttMagicPulse 1.8s ease-in-out infinite;"></div>' +
          '<div style="position:absolute;inset:9px;border-radius:50%;border:3.5px solid rgba(240,168,0,.18);"></div>' +
          '<div style="position:absolute;inset:9px;border-radius:50%;border:3.5px solid transparent;border-top-color:#e0a000;border-right-color:#f9c846;animation:ttSpin 1.1s linear infinite;"></div>' +
          '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:28px;">🎨</div>' +
        '</div>' +
        '<div style="position:relative;font-family:\'Fraunces\',serif;font-weight:600;font-size:16px;color:#16324a;margin-bottom:14px;text-align:center;">Quick — how old are they?</div>' +
        '<div style="position:relative;display:flex;flex-wrap:wrap;gap:7px;justify-content:center;max-width:320px;">' +
        LIKENESS_AGE_OPTIONS.map(function (o) {
          return '<button type="button" class="ttq-card ttLikenessAgeBtn" data-age="' + o[0] + '" style="padding:9px 11px;min-width:58px;">' +
            '<span class="ttq-card-emoji" style="font-size:18px;">' + o[2] + '</span><span class="ttq-card-label" style="font-size:11px;">' + o[1] + '</span>' +
          '</button>';
        }).join('') +
        '</div>' +
      '</div>';

    Array.prototype.forEach.call(stageEl.querySelectorAll('.ttLikenessAgeBtn'), function (btn) {
      btn.addEventListener('click', function () {
        window.ttLikenessAgeGroup = btn.dataset.age;
        fireUploadCall(btn.dataset.age);
      });
    });

    ageTimeout = setTimeout(function () {
      fireUploadCall('');
    }, 10000);
  }

   function startLikenessGeneration(dataUrl) {
    renderTransformLoading(dataUrl);
    document.dispatchEvent(new CustomEvent('ttCharacterSubmitted'));
    fetch(WORKER_BASE + '/upload-likeness-photo', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code, photo: dataUrl, age_group: window.ttLikenessAgeGroup || '' }),
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (out) {
        attemptsUsed++;
        stopFunLoop();
        var remaining = out && typeof out.attemptsRemaining === 'number' ? out.attemptsRemaining : (MAX_ATTEMPTS - attemptsUsed);
        if (out && out.ok && out.imageUrl) {
          pendingImageUrl = out.imageUrl;
          // First look at their character is the movie poster, so save straight away with no review screen
          proceedLikeness(out.imageUrl, window.ttLikenessGender || (pageTheme === 'princess' ? 'girl' : ''), window.ttLikenessAgeGroup || '', true);
          return;
        }
        document.dispatchEvent(new CustomEvent('ttCharacterFailed')); // back to the builder to try again
        if (remaining <= 0) {
          stageEl.innerHTML = '<div style="font-size:13px;font-weight:700;color:#7c8a99;">No attempts remaining. Please contact us for help.</div>';
          return;
        }
        renderDropzone();
        var s = stageEl.querySelector('#ttLikenessStatus');
        if (s) s.textContent = (out && out.error) || "Couldn't create the character — please try again.";
      })
      .catch(function () {
        stopFunLoop();
        renderDropzone();
        var s2 = stageEl.querySelector('#ttLikenessStatus');
        if (s2) s2.textContent = 'Something went wrong — please try again.';
      });
  }

  function renderTransformLoading(photoUrl) {
    ensureRevealStageStyles();
    ensureTransformStyles();
    if (introEl) introEl.style.display = 'none';
    var nm = titleName();
    var steps = ['Photo received', 'Finding their smile', 'Matching their hair & eyes', 'Painting their character', 'Adding the magic ✨'];
    stageEl.innerHTML =
      '<div class="tt-rv-wrap tt-rv-theme-' + (pageTheme || 'default') + '">' +
        '<div class="tt-rv-stage">' +
          '<img class="tt-tf-photo" src="' + photoUrl + '" alt="">' +
          '<div class="tt-tf-glow"></div>' +
          '<div class="tt-tf-scan"></div>' +
          '<span class="tt-rv-twinkle" style="top:12%;left:12%;">✦</span>' +
          '<span class="tt-rv-twinkle" style="top:24%;right:10%;animation-delay:.7s;">✦</span>' +
          '<span class="tt-rv-twinkle" style="top:55%;left:8%;animation-delay:1.4s;">✦</span>' +
          '<span class="tt-rv-twinkle" style="top:46%;right:12%;animation-delay:2.1s;">✦</span>' +
        '</div>' +
      '</div>' +
      '<div class="tt-tf-panel">' +
        '<div class="tt-tf-title">' + (nm ? 'Creating ' + escapeHtml(nm) + '\'s character…' : 'Creating their character…') + '</div>' +
        '<div class="tt-tf-bar"><div class="tt-tf-bar-fill"></div></div>' +
        '<ul class="tt-tf-steps">' + steps.map(function (st) { return '<li>' + st + '</li>'; }).join('') + '</ul>' +
        '<div class="tt-tf-note">Usually about 30 seconds — worth the wait ✨</div>' +
      '</div>';
    try { stageEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}

    // Progress bar eases toward 92% (it completes when the reveal takes over).
    var fill = stageEl.querySelector('.tt-tf-bar-fill');
    setTimeout(function () { if (fill) fill.style.width = '92%'; }, 50);

    // Tick through the steps; the last one stays "in progress" until the result arrives.
    var items = stageEl.querySelectorAll('.tt-tf-steps li');
    var idx = 0;
    items[0].classList.add('done');
    if (items[1]) items[1].classList.add('active');
    idx = 1;
    if (funTimer) clearInterval(funTimer);
    funTimer = setInterval(function () {
      if (idx >= items.length - 1) return;
      items[idx].classList.remove('active');
      items[idx].classList.add('done');
      idx++;
      items[idx].classList.add('active');
    }, 6500);
  }

  function renderMagicLoadingPro(messages) {
    ensureLikenessMagicStyles();
    if (introEl) introEl.style.display = 'none';
    var colors = ['#ff6ec7', '#7c5cff', '#4fd1ff', '#ffd166', '#6bff9e', '#ff8a5c'];
    var parts = '';
    for (var i = 0; i < 22; i++) {
      var c = colors[i % colors.length];
      var size = 4 + Math.round(Math.random() * 6);
      parts +=
        '<span class="tt-mg-p" style="left:' + (Math.round(Math.random() * 96) + 2) + '%;width:' + size + 'px;height:' + size + 'px;background:' + c +
        ';box-shadow:0 0 ' + size * 2 + 'px ' + c + ';animation-duration:' + (2.6 + Math.random() * 2.2).toFixed(2) + 's;animation-delay:' + (Math.random() * 3).toFixed(2) + 's;"></span>';
    }
    stageEl.innerHTML =
      '<div class="tt-mg-stage">' +
        '<div class="tt-mg-blob b1"></div><div class="tt-mg-blob b2"></div><div class="tt-mg-blob b3"></div>' +
        parts +
        '<div class="tt-mg-orb"><div class="tt-mg-ring"></div><div class="tt-mg-ring r2"></div><div class="tt-mg-core">✨</div></div>' +
        '<div id="ttLikenessFunText" class="tt-mg-text"></div>' +
        '<div class="tt-mg-bar"><div class="tt-mg-bar-fill"></div></div>' +
      '</div>';
    try { stageEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    startFunLoop(stageEl.querySelector('#ttLikenessFunText'), messages);
  }
    function ensureEyeFixStyles() {
    if (document.getElementById('ttEyeFixStyles')) return;
    var s = document.createElement('style');
    s.id = 'ttEyeFixStyles';
    s.textContent =
      '.tte-chips{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin:10px 0 4px}' +
      '.tte-chip{display:flex;align-items:center;gap:6px;padding:8px 12px;border-radius:999px;border:2px solid #e5e7eb;background:#fff;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:13px;color:#111827;cursor:pointer}' +
      '.tte-chip.sel{border-color:#3c8ab3;background:#eef7fc}' +
      '.tte-dot{width:14px;height:14px;border-radius:50%;box-shadow:inset 0 0 0 2px rgba(0,0,0,.12)}' +
      '.tte-ov{position:fixed;inset:0;z-index:10200;background:rgba(10,14,26,.92);display:flex;flex-direction:column;align-items:center;justify-content:center;padding:20px;gap:16px}' +
      '.tte-face{width:min(86vw,420px);aspect-ratio:1;border-radius:22px;background-color:#fff;background-repeat:no-repeat;background-size:260%;background-position:50% 15%;border:3px solid #fff;box-shadow:0 20px 60px rgba(0,0,0,.5)}' +
      '.tte-ov-txt{color:#fff;font-family:\'Nunito\',sans-serif;font-weight:800;font-size:15px;text-align:center}' +
      '.tte-ov-close{padding:13px 28px;border:none;border-radius:12px;background:#fff;color:#111827;font-family:\'Nunito\',sans-serif;font-weight:900;font-size:15px;cursor:pointer}';
    document.head.appendChild(s);
  }

  function renderReveal(imageUrl, attemptsRemaining) {
    ensureLikenessMagicStyles();
    ensureRevealStageStyles();
    ensureEyeFixStyles();
    if (introEl) introEl.style.display = 'none';
    var titleEl = wrap.querySelector('#ttLikenessTitle');
    if (titleEl) {
      var nm = titleName();
      titleEl.textContent = nm ? 'Meet ' + nm + '! ✨' : 'Here they are! ✨';
    }
    var nextLabel =
      pageTheme === 'superhero' || pageTheme === 'princess' ? 'Yes! Continue →'
      : pageTheme === 'halloween' ? 'Yes! Put on their costume →'
      : 'Yes! Continue →';
    var decided = false;
    var currentUrl = imageUrl; // updated if they fix the eye color — everything downstream uses this
    var EYE_COLORS = [
      ['brown', '#6b4423', 'Brown'], ['dark brown', '#3b2a1a', 'Dark Brown'], ['hazel', '#8a6b3b', 'Hazel'],
      ['green', '#5a8a5a', 'Green'], ['blue', '#5b8fc7', 'Blue'], ['gray', '#8a96a3', 'Gray'],
    ];

    stageEl.innerHTML =
      '<div class="tt-rv-wrap tt-rv-theme-' + (pageTheme || 'default') + '">' +
        '<div class="tt-rv-stage">' +
          '<div class="tt-rv-spot"></div>' +
          '<div class="tt-rv-floor"></div>' +
          '<img class="tt-rv-img" src="' + imageUrl + '" alt="">' +
          '<span class="tt-rv-twinkle" style="top:12%;left:12%;">✦</span>' +
          '<span class="tt-rv-twinkle" style="top:22%;right:10%;animation-delay:.7s;">✦</span>' +
          '<span class="tt-rv-twinkle" style="top:48%;left:7%;animation-delay:1.4s;">✦</span>' +
          '<span class="tt-rv-twinkle" style="top:40%;right:14%;animation-delay:2.1s;">✦</span>' +
        '</div>' +
        '<div class="tt-rv-plate"><span class="tt-rv-plate-eyebrow">Starring</span><span class="tt-rv-plate-name">' + escapeHtml(titleName() || 'Your Star') + '</span></div>' +
        '<div class="tt-rv-burst"></div>' +
      '</div>' +
      '<div class="tt-rv-sheet" id="ttRvSheet">' +
        '<div class="tt-rv-q">' + (titleName() ? 'Love ' + escapeHtml(titleName()) + '\'s character? 💛' : 'Love it? 💛') + '</div>' +
        '<button type="button" class="tt-rv-love" id="ttRvLove">' + nextLabel + '</button>' +
        '<button type="button" class="tt-rv-retry" id="ttRvEdit">👁️ Change eye color, hair or more?</button>' +
        '<div id="ttRvEditPanel" style="display:none;margin-top:10px;">' +
          '<textarea id="ttRvEditInput" maxlength="200" rows="2" placeholder="e.g. blue eyes, mousy blond hair, add glasses" style="width:100%;box-sizing:border-box;padding:12px 14px;border-radius:12px;border:1.5px solid rgba(148,163,184,.35);font-family:\'Nunito\',sans-serif;font-size:16px;resize:none;"></textarea>' +
          '<button type="button" class="tt-rv-love" id="ttRvEditGo" style="margin-top:8px;">Update ✨</button>' +
          '<div id="ttRvEditStatus" style="margin-top:8px;font-size:12.5px;font-weight:700;color:#4b5563;"></div>' +
        '</div>' +
        (attemptsRemaining > 0 ? '<button type="button" class="tt-rv-retry" id="ttRvRetry">Not quite right? Try another photo (' + attemptsRemaining + ' left)</button>' : '') +
      '</div>' +
      '<div id="ttLikenessStatus" style="margin-top:12px;font-size:13px;font-weight:700;color:#b42318;"></div>';
    try { stageEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}

    var sheet = stageEl.querySelector('#ttRvSheet');
    var imgEl = stageEl.querySelector('.tt-rv-img');
    var sheetTimer = null;
    function showSheet() {
      sheet.classList.add('show');
      try { sheet.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    }
    function onImgReady() { sheetTimer = setTimeout(showSheet, 900); }
    if (imgEl.complete) onImgReady();
    else {
      imgEl.addEventListener('load', onImgReady, { once: true });
      imgEl.addEventListener('error', onImgReady, { once: true });
    }

    // No tap at all → save automatically.
    var autoTimer = setTimeout(function () {
      if (decided) return;
      decided = true;
      proceedLikeness(currentUrl, '', '', true);
    }, 20000);
    function cancelTimers() { clearTimeout(sheetTimer); clearTimeout(autoTimer); }

    stageEl.querySelector('#ttRvLove').addEventListener('click', function () {
      if (decided) return;
      decided = true;
      cancelTimers();
      askGenderAge(currentUrl, sheet);
    });
    var retryEl = stageEl.querySelector('#ttRvRetry');
    if (retryEl) retryEl.addEventListener('click', function () {
      if (decided) return;
      decided = true;
      cancelTimers();
      renderDropzone();
    });

    // 🔍 Face close-up
    imgEl.style.cursor = 'zoom-in';
    imgEl.addEventListener('click', function () {
      cancelTimers(); // they're checking — don't auto-save under them
      var ov = document.createElement('div');
      ov.className = 'tte-ov';
      ov.innerHTML =
        '<div class="tte-face" style="background-image:url(\'' + currentUrl + '\')"></div>' +
        '<div class="tte-ov-txt">Check their eyes, hair &amp; smile 👀</div>' +
        '<button type="button" class="tte-ov-close">Looks good</button>';
      document.body.appendChild(ov);
      ov.addEventListener('click', function (e) {
        if (e.target === ov || e.target.classList.contains('tte-ov-close')) ov.remove();
      });
    });
    // ✏️ Change something (hair, eyes, glasses…)
    var editBtn = stageEl.querySelector('#ttRvEdit');
    var editPanel = stageEl.querySelector('#ttRvEditPanel');
    var editInput = stageEl.querySelector('#ttRvEditInput');
    var editGo = stageEl.querySelector('#ttRvEditGo');
    var editStatus = stageEl.querySelector('#ttRvEditStatus');
    editBtn.addEventListener('click', function () {
      cancelTimers();
      var open = editPanel.style.display === 'none';
      editPanel.style.display = open ? 'block' : 'none';
      if (open) setTimeout(function () { editInput.focus(); }, 50);
    });
    editGo.addEventListener('click', function () {
      var text = (editInput.value || '').trim();
      if (text.length < 3) { editInput.focus(); return; }
      editGo.disabled = true;
      editStatus.textContent = 'Updating… about 20 seconds ✨';
      imgEl.style.opacity = '.5';
      fetch(WORKER_BASE + '/edit-likeness', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code, image_url: currentUrl, instruction: text }),
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (d) {
          editGo.disabled = false;
          imgEl.style.opacity = '1';
          if (!d || !d.ok || !d.imageUrl) {
            editStatus.textContent = (d && d.error) || 'Something went wrong — please try again.';
            if (d && d.attemptsRemaining === 0) { editBtn.style.display = 'none'; editPanel.style.display = 'none'; }
            return;
          }
          currentUrl = d.imageUrl;
          pendingImageUrl = d.imageUrl;
          imgEl.src = d.imageUrl;
          editInput.value = '';
          editStatus.textContent = '✓ Updated! Tap their picture to check.' +
            (d.attemptsRemaining > 0 ? ' (' + d.attemptsRemaining + ' change' + (d.attemptsRemaining === 1 ? '' : 's') + ' left)' : '');
          if (d.attemptsRemaining === 0) { editBtn.style.display = 'none'; editInput.style.display = 'none'; editGo.style.display = 'none'; }
        })
        .catch(function () {
          editGo.disabled = false;
          imgEl.style.opacity = '1';
          editStatus.textContent = 'Something went wrong — please try again.';
        });
    });
  }

   function askGenderAge(imageUrl, sheet) {
    ensureUploadStyles();
       var themeGender = pageTheme === 'princess' ? 'girl' : '';
    var g = window.ttLikenessGender || themeGender;
    var a = window.ttLikenessAgeGroup || '';
    var nm = titleName() || 'your star';
    var done = false;
      sheet.classList.add('show');
    sheet.classList.remove('tt-rv-compact');
     sheet.innerHTML =
        '<div class="tt-rv-q" style="font-size:15px;">Is ' + escapeHtml(nm) + ' a boy or a girl?</div>' +
              '<div class="tt-rv-pills tt-rv-seg" data-grp="g">' +
        '<button type="button" class="tt-rv-pill tt-rv-seg-btn' + (g === 'girl' ? ' sel' : '') + '" data-v="girl"><span class="tt-seg-num">👧 Girl</span></button>' +
        '<button type="button" class="tt-rv-pill tt-rv-seg-btn' + (g === 'boy' ? ' sel' : '') + '" data-v="boy"><span class="tt-seg-num">👦 Boy</span></button>' +
      '</div>' +
      '<div class="tt-rv-q" style="font-size:13.5px;margin:10px 0 8px;">How old?</div>' +
          '<div class="tt-rv-pills tt-rv-seg" data-grp="a">' +
        [['baby', '0–2', 'Baby'], ['toddler', '3–5', 'Toddler'], ['young_child', '6–10', 'Kid'], ['preteen', '11–13', 'Tween'], ['teen', '14+', 'Teen']].map(function (o) {
          return '<button type="button" class="tt-rv-pill tt-rv-seg-btn' + (a === o[0] ? ' sel' : '') + '" data-v="' + o[0] + '"><span class="tt-seg-num">' + o[1] + '</span><span class="tt-seg-word">' + o[2] + '</span></button>';
        }).join('') +
      '</div>' +
      '<button type="button" class="tt-rv-love" id="ttRvContinue" style="margin-top:12px;">Continue →</button>';

    var idle = null;
    function go() {
      if (done) return;
      done = true;
      clearTimeout(idle);
      proceedLikeness(imageUrl, g, a, false);
    }
    function resetIdle() { clearTimeout(idle); idle = setTimeout(go, 15000); }

    Array.prototype.forEach.call(sheet.querySelectorAll('.tt-rv-pills'), function (grp) {
      Array.prototype.forEach.call(grp.querySelectorAll('.tt-rv-pill'), function (btn) {
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(grp.querySelectorAll('.tt-rv-pill'), function (b) { b.classList.remove('sel'); });
          btn.classList.add('sel');
          if (grp.dataset.grp === 'g') g = btn.dataset.v;
          else a = btn.dataset.v;
          resetIdle();
        });
      });
    });
    sheet.querySelector('#ttRvContinue').addEventListener('click', go);
    resetIdle();
  }

  function themedOutfitFor(name) {
    var n = String(name || '').toLowerCase().replace(/[^a-z]/g, '');
    var pools = [PRINCESS_DRESSES, SUPERHERO_OUTFITS];
    for (var p = 0; p < pools.length; p++) {
      for (var k in pools[p]) {
        var o = pools[p][k];
        if (k === n || String(o.outfitId).replace(/[^a-z]/g, '') === n || String(o.label).toLowerCase().replace(/[^a-z]/g, '') === n) return o;
      }
    }
    return null;
  }
  function autoDressLikeness(baseUrl) {
    var outfitUrl = '', desc = '';
    if (pageTheme === 'halloween') {
      var m = String(pageThemeOutfitName || '').match(/^custom:\s*(.+)$/i);
      if (m) desc = m[1]; else outfitUrl = halloweenCostumeUrl();
    } else {
      var o = themedOutfitFor(pageThemeOutfitName);
      if (o) outfitUrl = o.url;
    }
    function approve(url) {
      callApprove(url)
        .then(function (out) {
          if (out && out.ok) finishLikenessApproval(url, wrap, out.detected_entities);
          else document.dispatchEvent(new CustomEvent('ttCharacterFailed'));
        })
        .catch(function () { document.dispatchEvent(new CustomEvent('ttCharacterFailed')); });
    }
    if (!outfitUrl && !desc) { approve(baseUrl); return; }
    fetch(WORKER_BASE + '/dress-likeness-photo', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code, base_image_url: baseUrl, outfit_image_url: outfitUrl || undefined, custom_description: desc || undefined }),
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (out) { approve(out && out.ok && out.imageUrl ? out.imageUrl : baseUrl); })
      .catch(function () { approve(baseUrl); });
  }

  function proceedLikeness(imageUrl, gender, age, isAuto) {
var themeGender = pageTheme === 'princess' ? 'girl' : '';
    window.ttLikenessGender = gender || window.ttLikenessGender || themeGender || '';
    if (age) {
      window.ttLikenessAgeGroup = age;
      fetch(WORKER_BASE + '/update-record', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code, age_group: age, 'Main Character Age Group': age }),
      }).catch(function () {});
    }
    var sheet = stageEl.querySelector('#ttRvSheet');
    if (sheet) {
      sheet.classList.add('show');
      sheet.innerHTML = '<div class="tt-rv-q" style="margin:4px 0;"><span class="ttq-loading-dot"></span> Saving ' + escapeHtml(titleName() || 'their') + '\'s character…</div>';
    }

    // Halloween always goes to its costume; non-themed orders that tapped "Love it"
    // (and gave a gender) continue to the wardrobe. Everything else saves as-is.
       // Themed orders go straight into the costume they picked on the order form, then save
    if (pageTheme === 'halloween' || pageTheme === 'princess' || pageTheme === 'superhero') {
      autoDressLikeness(imageUrl);
      return;
    }

    function showSaveRetry() {
      var s = stageEl.querySelector('#ttLikenessStatus');
      if (s) s.textContent = "Couldn't save — please try again.";
      if (sheet) {
        sheet.innerHTML = '<button type="button" class="tt-rv-love" id="ttRvRetrySave">Try saving again</button>';
        sheet.querySelector('#ttRvRetrySave').addEventListener('click', function () {
          proceedLikeness(imageUrl, gender, age, isAuto);
        });
      }
    }
    callApprove(imageUrl)
      .then(function (out) {
        if (out && out.ok) finishLikenessApproval(imageUrl, wrap, out.detected_entities);
        else showSaveRetry();
      })
      .catch(showSaveRetry);
  }

  var GEN_MESSAGES = [
    '🎨 Mixing the perfect colors…',
    '✨ Sprinkling on some magic…',
    '🖌️ Painting their smile…',
    '🌟 Bringing them to life…',
    '🎬 Almost ready for their close-up…',
  ];
  var DRESS_MESSAGES = [
    '👗 Picking out threads…',
    '✂️ Tailoring the perfect fit…',
    '🧵 Stitching it all together…',
    '🎁 Wrapping up the look…',
  ];

  function startFunLoop(el, messages) {
    var i = 0;
    el.textContent = messages[0];
    funTimer = setInterval(function () {
      i = (i + 1) % messages.length;
      el.style.opacity = '0';
      setTimeout(function () {
        el.textContent = messages[i];
        el.style.opacity = '1';
      }, 200);
    }, 1600);
  }
  function stopFunLoop() {
    if (funTimer) clearInterval(funTimer);
    funTimer = null;
  }
  function renderDropzone() {
    ensureLikenessMagicStyles();
    ensureRevealStageStyles();
    ensureTransformStyles();
    ensureUploadStyles();
    if (introEl) introEl.style.display = 'none';
    var titleElD = wrap.querySelector('#ttLikenessTitle');
    if (titleElD) titleElD.textContent = 'Turn their photo into a character ✨';
    var pair = window.ttBeforeAfterPair || [
      'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/REGULAR_PHOTO.jpg?v=1790793811',
      'https://cdn.shopify.com/s/files/1/0701/2882/8527/files/character_done.jpg?v=1790793976',
    ];
    stageEl.innerHTML =
      '<div class="tt-up">' +
        '<div class="tt-rv-wrap tt-rv-theme-' + (pageTheme || 'default') + '" id="ttUpDrop">' +
               '<div class="tt-rv-stage">' +
            '<div class="tt-up-dash"></div>' +
            '<div class="tt-up-center">' +
              '<div class="tt-up-orb">📸<span class="tt-up-plus">+</span></div>' +
              '<div class="tt-up-cta">Tap to add ' + (titleName() ? escapeHtml(titleName()) + '\'s' : 'their') + ' photo</div>' +
              '<div class="tt-up-sub">From your camera roll or files</div>' +
            '</div>' +
            '<span class="tt-rv-twinkle" style="top:10%;left:10%;">✦</span>' +
            '<span class="tt-rv-twinkle" style="top:18%;right:11%;animation-delay:.8s;">✦</span>' +
            '<span class="tt-rv-twinkle" style="bottom:14%;left:14%;animation-delay:1.6s;">✦</span>' +
            '<span class="tt-rv-twinkle" style="bottom:20%;right:12%;animation-delay:2.2s;">✦</span>' +
          '</div>' +
        '</div>' +
        '<label id="ttLikenessChooseBtn" class="tt-rv-love tt-up-btn">📸 Choose their photo' +
          '<input type="file" id="ttLikenessFileInput" accept="image/*" style="display:none;">' +
        '</label>' +
        '<div class="tt-up-tips"><span>✓ Face clearly visible</span><span>✓ Just them</span><span>✓ Good light</span></div>' +
        '<div class="tt-up-privacy">🔒 Only used to create their character</div>' +
        '<div id="ttLikenessStatus" style="margin-top:12px;font-size:13px;font-weight:700;color:#b42318;text-align:center;"></div>' +
      '</div>';

    var fileInput = stageEl.querySelector('#ttLikenessFileInput');
    function handleFile(file) {
      if (!file) return;
      var statusPrep = stageEl.querySelector('#ttLikenessStatus');
      if (statusPrep) { statusPrep.style.color = '#7c8a99'; statusPrep.textContent = 'Preparing photo…'; }
      readAndResizeImageFile(file, 1600, 0.85, function (dataUrl) {
        startLikenessGeneration(dataUrl);
      }, function () {
        var s = stageEl.querySelector('#ttLikenessStatus');
        if (s) { s.style.color = '#b42318'; s.textContent = "Couldn't read that photo — please try a different one."; }
      });
    }
    fileInput.addEventListener('change', function () { handleFile(fileInput.files && fileInput.files[0]); });

    var drop = stageEl.querySelector('#ttUpDrop');
    drop.addEventListener('click', function () { fileInput.click(); });
    drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('tt-up-over'); });
    drop.addEventListener('dragleave', function () { drop.classList.remove('tt-up-over'); });
    drop.addEventListener('drop', function (e) {
      e.preventDefault();
      drop.classList.remove('tt-up-over');
      handleFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
    });
  }

    function renderMagicLoading(messages, emoji) {
    if (introEl) introEl.style.display = 'none';
    var sparkles = ['✨','⭐','🌟','💫'];
    var sparkleHtml = '';
    for (var i = 0; i < 14; i++) {
      var left = Math.round(Math.random() * 92) + 2;
      var top = Math.round(Math.random() * 78) + 6;
      var delay = (Math.random() * 2.4).toFixed(2);
      var dur = (2 + Math.random() * 1.6).toFixed(2);
      var size = 14 + Math.round(Math.random() * 14);
      var glyph = sparkles[i % sparkles.length];
      sparkleHtml +=
        '<span style="position:absolute;left:' + left + '%;top:' + top + '%;font-size:' + size + 'px;' +
        'opacity:0;animation:ttMagicTwinkle ' + dur + 's ease-in-out ' + delay + 's infinite;">' + glyph + '</span>';
    }

    stageEl.innerHTML =
      '<div style="position:relative;min-height:220px;display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden;">' +
        sparkleHtml +
        '<div style="position:relative;width:100px;height:100px;margin-bottom:20px;">' +
          '<div style="position:absolute;inset:0;border-radius:50%;background:radial-gradient(circle,rgba(249,200,70,.35),transparent 70%);animation:ttMagicPulse 1.8s ease-in-out infinite;"></div>' +
          '<div style="position:absolute;inset:14px;border-radius:50%;border:3.5px solid rgba(240,168,0,.18);"></div>' +
          '<div style="position:absolute;inset:14px;border-radius:50%;border:3.5px solid transparent;border-top-color:#e0a000;border-right-color:#f9c846;animation:ttSpin 1.1s linear infinite;"></div>' +
          '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:38px;">' + emoji + '</div>' +
        '</div>' +
        '<div id="ttLikenessFunText" style="position:relative;font-family:\'Fraunces\',serif;font-weight:600;font-size:clamp(20px,4.5vw,26px);color:#16324a;letter-spacing:-.01em;text-align:center;padding:0 20px;transition:opacity .25s ease;min-height:32px;text-shadow:0 2px 14px rgba(240,168,0,.25);"></div>' +
      '</div>';

    startFunLoop(stageEl.querySelector('#ttLikenessFunText'), messages);
  }

  function renderGenerating() {
    renderMagicLoadingPro(GEN_MESSAGES);
  }

        function renderResult(imageUrl, attemptsRemaining) {
    if (introEl) introEl.style.display = 'none';
    var titleEl = wrap.querySelector('#ttLikenessTitle');
    if (titleEl) {
      var childNm = titleName();
      titleEl.textContent = childNm ? 'Here\'s ' + childNm + '!' : 'Here they are!';
    }
    var preselectedGender = window.ttLikenessGender || '';
    stageEl.innerHTML =
      '<img src="' + imageUrl + '" style="width:100%;max-width:340px;border-radius:20px;box-shadow:0 16px 40px rgba(26,58,92,.28);margin-bottom:16px;">' +
      '<div style="font-size:13px;font-weight:800;color:#16324a;margin-bottom:10px;">Is this a boy or a girl?</div>' +
      '<div style="display:flex;gap:10px;justify-content:center;margin-bottom:16px;">' +
      '<button type="button" class="ttq-card ttLikenessGenderBtn' + (preselectedGender === 'girl' ? ' sel' : '') + '" data-g="girl" style="padding:14px 20px;">👧 Girl</button>' +
      '<button type="button" class="ttq-card ttLikenessGenderBtn' + (preselectedGender === 'boy' ? ' sel' : '') + '" data-g="boy" style="padding:14px 20px;">👦 Boy</button>' +
      '</div>' +
      '<div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap;">' +
      '<button type="button" id="ttLikenessApproveBtn" class="ttq-primary" style="width:auto;"' + (preselectedGender ? '' : ' disabled') + '>✓ I love it!</button>' +
      (attemptsRemaining > 0
        ? '<button type="button" id="ttLikenessRetryBtn" class="ttq-textlink">Try a different photo (' + attemptsRemaining + ' left)</button>'
        : '') +
      '</div>' +
      '<div id="ttLikenessStatus" style="margin-top:12px;font-size:13px;font-weight:700;color:#b42318;"></div>';

    var approveBtnEl = stageEl.querySelector('#ttLikenessApproveBtn');

    Array.prototype.forEach.call(stageEl.querySelectorAll('.ttLikenessGenderBtn'), function (btn) {
      btn.addEventListener('click', function () {
        window.ttLikenessGender = btn.dataset.g;
        Array.prototype.forEach.call(stageEl.querySelectorAll('.ttLikenessGenderBtn'), function (b) { b.classList.remove('sel'); });
        btn.classList.add('sel');
        if (approveBtnEl) approveBtnEl.disabled = false;
      });
    });

    if (approveBtnEl) {
      approveBtnEl.addEventListener('click', function () {
        if (!window.ttLikenessGender) return;
        if (pageTheme === 'superhero' || pageTheme === 'princess') {
          approveBtnEl.disabled = true;
          approveBtnEl.textContent = 'Saving…';
                callApprove(imageUrl).then(function (approveOut) {
        if (approveOut && approveOut.ok) {
          finishLikenessApproval(imageUrl, wrap, approveOut.detected_entities);
            } else {
              approveBtnEl.disabled = false;
              approveBtnEl.textContent = '✓ I love it!';
              var statusEl = stageEl.querySelector('#ttLikenessStatus');
              if (statusEl) statusEl.textContent = "Couldn't save — please try again.";
            }
          }).catch(function () {
            approveBtnEl.disabled = false;
            approveBtnEl.textContent = '✓ I love it!';
          });
        } else {
          renderOutfitStep(imageUrl);
        }
      });
    }
    var retryBtnEl = stageEl.querySelector('#ttLikenessRetryBtn');
    if (retryBtnEl) {
      retryBtnEl.addEventListener('click', renderDropzone);
    }
  }

  function renderOutfitStep(baseImageUrl) {
  if (introEl) introEl.style.display = 'none';
  var likenessGender = window.ttLikenessGender || null;

    function renderGenderAsk() {
    var titleEl2 = wrap.querySelector('#ttLikenessTitle');
    if (titleEl2) {
      var nm2 = titleName();
      titleEl2.textContent = nm2 ? 'Here\'s ' + nm2 + '!' : 'Here they are!';
    }
    stageEl.innerHTML =
      '<img src="' + baseImageUrl + '" style="width:100%;max-width:200px;border-radius:16px;box-shadow:0 10px 26px rgba(26,58,92,.18);margin-bottom:14px;">' +
      '<div style="font-family:\'Fraunces\',serif;font-weight:600;font-size:18px;color:#16324a;margin-bottom:14px;">Let\'s dress them for the song!</div>' +
      '<div style="display:flex;gap:10px;justify-content:center;">' +
      '<button type="button" class="ttq-card" data-g="girl" style="padding:16px 22px;">👧 Girl</button>' +
      '<button type="button" class="ttq-card" data-g="boy" style="padding:16px 22px;">👦 Boy</button>' +
      '</div>';
    Array.prototype.forEach.call(stageEl.querySelectorAll('[data-g]'), function (btn) {
      btn.addEventListener('click', function () {
        likenessGender = btn.dataset.g;
        window.ttLikenessGender = likenessGender;
        renderWardrobe();
      });
    });
  }

  function renderWardrobe() {
    var CUSTOM_OUTFIT_IMG = 'https://pub-7937bc1fc6d44031b84f2090a7248297.r2.dev/outfit%20custom.png';
    var libraryItems = (OUTFITS[likenessGender] || []).map(function (o) { return { t: o[0], l: o[1] }; });
    var items = [
      { t: 'keep', l: 'Keep this outfit', isKeep: true },
      { t: 'custom', l: 'Custom outfit', isCustomTrigger: true },
    ].concat(libraryItems);

    stageEl.innerHTML =
      '<img src="' + baseImageUrl + '" style="width:100%;max-width:160px;border-radius:14px;box-shadow:0 8px 20px rgba(26,58,92,.15);margin-bottom:16px;">' +
      '<div class="ttq-lineup" id="ttLikenessWardrobeLineup">' +
      '<button type="button" class="ttq-arrow ttq-arrow-l" id="ttLikenessArrowL">‹</button>' +
      '<div class="ttq-track" id="ttLikenessTrack"></div>' +
      '<button type="button" class="ttq-arrow ttq-arrow-r" id="ttLikenessArrowR">›</button>' +
      '</div>' +
      '<div class="ttq-ldots" id="ttLikenessDots"></div>' +
      '<div id="ttLikenessOutfitCustomWrap" style="display:none;margin-top:16px;max-width:340px;margin-left:auto;margin-right:auto;">' +
      '<div style="display:flex;gap:8px;">' +
      '<input type="text" id="ttLikenessOutfitInput" placeholder="e.g. red superhero cape and boots" style="flex:1;padding:12px 14px;border-radius:12px;border:2px solid rgba(240,180,41,.3);font-family:\'Nunito\',sans-serif;font-size:13.5px;">' +
      '<button type="button" id="ttLikenessOutfitGoBtn" style="flex-shrink:0;padding:12px 16px;border-radius:12px;border:none;background:linear-gradient(135deg,#f0b429,#e0a000);color:#fff;font-weight:900;font-size:12.5px;font-family:\'Nunito\',sans-serif;cursor:pointer;">Dress them</button>' +
      '</div></div>' +
      '<div id="ttLikenessStatus" style="margin-top:14px;font-size:13px;font-weight:700;color:#b42318;"></div>';

    var track = stageEl.querySelector('#ttLikenessTrack');
    var dots = stageEl.querySelector('#ttLikenessDots');
    var customWrap = stageEl.querySelector('#ttLikenessOutfitCustomWrap');
    var slides = [];

    items.forEach(function (it) {
            var url = it.isKeep ? baseImageUrl
        : it.isCustomTrigger ? CUSTOM_OUTFIT_IMG
        : PRINCESS_DRESSES[it.t] ? PRINCESS_DRESSES[it.t].url
        : SUPERHERO_OUTFITS[it.t] ? SUPERHERO_OUTFITS[it.t].url
        : (ASSET_BASE + '/outfit-' + likenessGender + '-' + it.t + '.jpg');
      var slide = document.createElement('div');
      slide.className = 'ttq-slide';
      slide.dataset.token = it.t;
      slide.innerHTML =
        '<div class="ttq-slide-card"><div class="ttq-slide-skel"></div><img alt="' + it.l + '" loading="lazy"><span class="ttq-slide-chk">✓</span></div>' +
        '<div class="ttq-slide-label">' + it.l + '</div>';
      var img = slide.querySelector('img');
      img.addEventListener('load', function () {
        slide.querySelector('.ttq-slide-skel').style.display = 'none';
        img.style.opacity = '1';
      });
      img.addEventListener('error', function () {
        if (!it.isKeep && !it.isCustomTrigger) {
          slide.remove();
          var idx = slides.indexOf(slide);
          if (idx >= 0) slides.splice(idx, 1);
        }
      });
      img.src = url;
      slide.addEventListener('click', function () {
        Array.prototype.forEach.call(track.children, function (s) {
          s.querySelector('.ttq-slide-card').classList.remove('sel');
        });
        slide.querySelector('.ttq-slide-card').classList.add('sel');

        if (it.isCustomTrigger) {
          customWrap.style.display = 'block';
          var inputEl = customWrap.querySelector('#ttLikenessOutfitInput');
          if (inputEl) inputEl.focus();
          return;
        }
        customWrap.style.display = 'none';
        if (it.isKeep) finalizeLikenessOutfit(null, null);
        else finalizeLikenessOutfit(url, it.l);
      });
      track.appendChild(slide);
      slides.push(slide);
    });

    slides.forEach(function () {
      var d = document.createElement('span');
      d.className = 'ttq-ldot';
      dots.appendChild(d);
    });

    stageEl.querySelector('#ttLikenessArrowL').addEventListener('click', function () {
      track.scrollBy({ left: -Math.round(track.clientWidth * 0.7), behavior: 'smooth' });
    });
    stageEl.querySelector('#ttLikenessArrowR').addEventListener('click', function () {
      track.scrollBy({ left: Math.round(track.clientWidth * 0.7), behavior: 'smooth' });
    });
    stageEl.querySelector('#ttLikenessOutfitGoBtn').addEventListener('click', function () {
      var desc = (stageEl.querySelector('#ttLikenessOutfitInput').value || '').trim();
      if (!desc) return;
      finalizeLikenessOutfit(null, null, desc);
    });
  }

    function finalizeLikenessOutfit(outfitImageUrl, outfitLabel, customDescription) {
    if (!outfitImageUrl && !customDescription) {
      renderDressedConfirm(baseImageUrl);
      return;
    }
    renderDressing();
    fetch(WORKER_BASE + '/dress-likeness-photo', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code: code,
        base_image_url: baseImageUrl,
        outfit_image_url: outfitImageUrl || undefined,
        custom_description: customDescription || undefined,
      }),
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (out) {
        stopFunLoop();
        if (out && out.ok && out.imageUrl) {
          renderDressedConfirm(out.imageUrl);
        } else {
          renderWardrobe();
          var s3 = stageEl.querySelector('#ttLikenessStatus');
          if (s3) s3.textContent = (out && out.error) || "Couldn't create that outfit — please try again.";
        }
      })
      .catch(function () {
        stopFunLoop();
        renderWardrobe();
      });
  }

  function renderDressedConfirm(dressedImageUrl) {
    stageEl.innerHTML =
      '<img src="' + dressedImageUrl + '" style="width:100%;max-width:240px;border-radius:16px;box-shadow:0 12px 30px rgba(26,58,92,.2);margin-bottom:14px;">' +
      '<div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap;">' +
      '<button type="button" id="ttLikenessOutfitApproveBtn" class="ttq-primary" style="width:auto;">✓ Looks great!</button>' +
      '<button type="button" id="ttLikenessOutfitBackBtn" class="ttq-textlink">Choose a different outfit</button>' +
      '</div>' +
      '<div id="ttLikenessStatus" style="margin-top:12px;font-size:13px;font-weight:700;color:#b42318;"></div>';

    var approveBtnEl = stageEl.querySelector('#ttLikenessOutfitApproveBtn');
    approveBtnEl.addEventListener('click', function () {
      approveBtnEl.disabled = true;
      approveBtnEl.textContent = 'Saving…';
            callApprove(dressedImageUrl).then(function (approveOut) {
        if (approveOut && approveOut.ok) {
          finishLikenessApproval(dressedImageUrl, wrap, approveOut.detected_entities);
        } else {
          approveBtnEl.disabled = false;
          approveBtnEl.textContent = '✓ Looks great!';
          var s = stageEl.querySelector('#ttLikenessStatus');
          if (s) s.textContent = "Couldn't save — please try again.";
        }
      }).catch(function () {
        approveBtnEl.disabled = false;
        approveBtnEl.textContent = '✓ Looks great!';
      });
    });
    stageEl.querySelector('#ttLikenessOutfitBackBtn').addEventListener('click', renderWardrobe);
  }

    var hwCostumeUrl = pageTheme === 'halloween' ? halloweenCostumeUrl() : '';
  var hwCustomMatch = pageTheme === 'halloween' ? String(pageThemeOutfitName || '').match(/^custom:\s*(.+)$/i) : null;
  if (hwCustomMatch) finalizeLikenessOutfit('', 'Halloween costume', hwCustomMatch[1]);
  else if (hwCostumeUrl) finalizeLikenessOutfit(hwCostumeUrl, pageThemeOutfitName);
  else if (likenessGender) renderWardrobe();
  else renderGenderAsk();
}

  function callApprove(imageUrlOverride) {
    return fetch(WORKER_BASE + '/approve-likeness-character', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code: code,
        outfit: 'keep',
        consent_parent: true,
                      consent_bipa: true,
      image_url: imageUrlOverride || undefined,
        gender: window.ttLikenessGender || '',
      }),
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

    function renderDressing() {
    renderMagicLoadingPro(DRESS_MESSAGES);
  }

  // Age is collected later, in renderGeneratingWithAgeAsk (fired after a
  // photo is chosen) — this used to gate on age up front via a
  // renderLikenessAgeAsk() function that no longer exists, which threw a
  // silent ReferenceError here and left the whole upload UI blank with no
  // "Choose Photo" button. Just go straight to the photo picker.
  renderDropzone();
}
function finishLikenessApproval(imageUrl, uploadWrapEl, detectedEntities) {
  try {
    window.savedCharacterId = 'photo_likeness';
    window.savedCharacterUrl = imageUrl;
    window.ttOutfit = 'keep';
    window.ttCharacterMode = 'photo_likeness';
    window.ttCharacterApproved = true;
  } catch (e) {}

  var finalGender = window.ttLikenessGender || '';

  fetch(WORKER_BASE + '/update-record', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code: code, character_mode: 'photo_likeness', gender: finalGender }),
  }).catch(function () {});
  fetch(WORKER_BASE + '/start-character-demo-clip', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code: code }),
  }).catch(function () {});

  document.dispatchEvent(new CustomEvent('ttCharacterSaved', {
    detail: {
      character_id: 'photo_likeness',
      url: imageUrl,
      outfit: 'keep',
      gender: finalGender,
      base_character: 'photo_likeness',
    },
  }));
  document.dispatchEvent(new CustomEvent('ttCharacterDressed', { detail: { url: imageUrl } }));

   if (uploadWrapEl) uploadWrapEl.remove();
  var builderCardEl = document.getElementById('ttCharBuilder');
  if (builderCardEl) builderCardEl.style.display = 'none';

  if (detectedEntities && detectedEntities.length) {
    window.ttDetectedCast = detectedEntities;
    if (builderCardEl) ttShowCastNotice(builderCardEl, detectedEntities);
  }

    window.ttRefreshCastStrip();
  ttShowFamilyTip(window.ttDetectedCast || detectedEntities || []);
  var entityPromptEl = document.getElementById('ttEntityPrompt') || document.getElementById('ttCastNotice');
  if (entityPromptEl) {
    setTimeout(function () {
      try { entityPromptEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }, 200);
  } else {
    setTimeout(function () {
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }, 200);
  }
}

if (consentContinueBtn) {
  consentContinueBtn.addEventListener('click', function () {
    fetch(WORKER_BASE + '/save-consent', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code: code,
        consent_type: 'photo_likeness_biometric',
        consent_version: '1.0',
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        window.ttConsentId = data && data.consent_id;
        consentModalEl.style.display = 'none';
        showLikenessUploadUI();
      })
      .catch(function () {
        alert('Something went wrong — please try again.');
      });
  });
}
        fetchPageTheme().then(function () {
          setConsentBeforeAfter();
          if (restoredCharacterUrl) {
            showRestoredCharacter();
          } else {
            render();
          }
        });
      })();
  